import otherChinese from "./Chinese-other";
export default {
  //常规
  loading: "加载中",
  quantity: "数量",
  name: "名称",
  all: "全部",
  yes: "是",
  no: "否",
  or: "或",
  and: "与",
  in_all: "总共",
  Query: "查询",
  creation: "创建",
  Batchquery: "批量查询",
  delete: "删除",
  checkAll: "全选",
  Save_export_condition: "保存导出条件",
  Total_print: "打印总数",
  successfully_delete: "删除成功!",
  error_Message: "异常消息",
  edit: "编辑",
  editUser: "编辑用户",
  confirm: "确认",
  print: "打印",
  today: "今日",
  yesterday: "昨日",
  enterprise: "企业",
  personage: "个人",
  Before_yesterday: "前日",
  printLog: "打印日志",
  check: "查看",
  Button: "按钮",
  notice: "注",
  revocation: "撤销",
  Query_content: "查询内容",
  Scanning_successful: "扫描成功",
  successful_operation: "操作成功!",
  Please_select_orders_to_operate: "请选择要操作的订单",
  Please_select_same_platform_orders: "请选择相同平台的订单进行操作",
  The_query_is_successful: "查询成功",
  Delete_success: "删除成功！",
  operation_failed: "操作失败！",
  more: "更多",
  click_to_download: "点击下载",
  More_operations: "更多操作",
  More_Conditions: "更多条件",
  Displaystatus: "显示状态",
  According: "显示",
  Total_declared_value: "总申报价值",
  NoAccording: "不显示",
  Download_via_QR_code: "通过二维码下载",
  Please_select_display_status: "请选择显示状态",
  Path_is_None_Check_whether_the_address_is_correct:
    "地址为空，请查看地址输入是否正确!",
  Is_this_a_piece_of_content_sure_to_delete: "这是一段内容确定删除吗？",
  phone_number: "手机号",
  Payment_order_number: "支付单号",
  Please_enter_a_phone_number: "请输入手机号",
  SystemSettings: "系统设置",
  please_enter: "请输入",
  old_password: "旧密码",
  Please_enter_your_old_password: "请输入旧密码",
  new_password: "新密码",
  Please_enter_basket_length_width_and_height: "请输入篮子长宽高",
  Please_enter_the_order_number: "请输入单号",
  Please_enter_the_search_criteria: "请输入查询条件",
  uploading: "上传",
  next_step: "下一步",
  last_step: "上一步",
  change_password: "修改密码",
  Mission_center: "任务中心",
  TaskCenter: "任务中心",
  TaskCenterRegulates: "任务中心管理",
  TaskCenterList: "任务中心",
  Drag_and_drop_upload: "拖拽上传",
  Successfully_copied_to_clipboard: "已成功复制到剪贴板",
  Unable_to_copy_to_clipboard: "无法复制到剪贴板",
  The_form_verification_fails_Please_modify_and_try_again:
    "表单校验失败，请修改后重试",
  The_selected_data_is_empty: "选中数据为空",
  The_added_data_is_empty: "添加的数据为空",
  systematic_notification: "系统通知",
  open_in_new_window: "新窗口打开",
  successfully_upload: "上传成功",
  Specify_export_order: "指定导出订单",
  Specified_export_goods: "指定导出商品",
  Export_task_Id: "导出任务ID",
  Derived_exception: "导出异常",
  View_Personal_details: "查看个人详情",
  not_modified: "未修改",
  save_as_PDF: "另存为PDF",
  Download_sheet: "下载面单",
  ToolDownload: "工具下载",
  toolName: "工具名称",
  remote_control_software: "远程控制软件",
  Print_plug_in: "打印插件",
  PDABrowser: "PDA浏览器",
  It_can_be_downloaded_by_clicking_the_button_and_scanning_the_QR_code_by_touching_the_button:
    "可通过点击按钮或触摸按钮扫描二维码进行下载",
  The_user_does_not_have_any_permission_Please_assign_the_permission_to_the_superior_of_the_user:
    "该用户无任何权限，请该用户上级分配对应权限",
  To_use_system_printing_you_need_to_download_a_print_plugin:
    "使用系统打印需要下载打印插件",
  The_current_user_has_no_permission_Please_set_the_permission_and_log_in_again:
    "当前用户未设置权限，请设置权限后在重试登录",
  Using_the_specified_export_order_data_will_overwrite_the_list_of_selected_order_data:
    "使用指定导出订单数据将会覆盖列表选择订单数据",
  This_order_has_not_been_shipped_out_of_the_warehouse_and_cannot_be_reprinted:
    "该订单尚未出库，无法补印面单",
  Interface_communication_failed_Please_refresh_the_page_or_log_in_again_If_the_problem_persists_contact_the_administrator:
    "接口通讯失败，请刷新页面或重新登录。如果问题依旧，请联系管理员",
  Enter_the_client: "进入客户端",
  query_condition: "查询条件",
  Home: "首页",
  return: "返回",
  Please_upload: "请上传",
  The_upload_format_is: "上传的格式为",
  The_file_format_was_wrong_last_time: "上传文件格式有误",
  The_uploaded_file_exceeds_the_specified_size_Procedure:
    "上传文件超出规定大小，上传失败",
  Shop_status: "店铺状态",
  normal: "正常",
  Authorization_expired: "授权过期",
  One_click_out_of_storage: "一键出库",
  can_only_choose_one: "只能选择一个",
  Go_to_the_service_platform: "跳转至服务平台",
  api_Order: "Api订单",
  Notification_form: "推送单",
  Please_clear_template_format: "请清除模板格式",
  announcementsList: "公告列表",
  successful_operation_exist: "已存在该仓库配置成功",
  new: "新",
  no_blank_remains: "不留白换行",
  mass_export: "大批量导出",
  Print_controls: "打印控件",
  test: "测试",
  The_store_backend_address_must_be_exactly_the_same_as_the_shipping_warehouse_address:
    "店铺后台地址要和发货仓库地址完全一致",
  Generation_task_completed_successfully: "生成任务成功",

  Supported_previewable_file_formats: "支持预览的文件格式",
  File_formats_that_are_not_supported_for_previewing:  "不支持预览的文件格式",

  // 登录注册页
  Password: "密码",
  Authentication_Code: "验证码",
  Can_Exchange: "看不清？点击换一张",
  Remember_Password: "记住密码",
  Login: "登录",
  Register_Account: "注册账号",
  Confirm_PassWord: "确认密码",
  Account_Manager_ID: "客户经理工号",
  identity_card: "身份证",
  business_license: "营业执照",
  Please_Input_Password: "请输入密码",
  The_Passwords_Entered_Do_Not_Match: "两次输入的密码不一致",
  Please_Input_Phone_Number: "请输入手机号码",
  Please_Input_Verification_Code: "请输入验证码",

  Too_Many_Requests_Please_Try_Again_Later: "操作频繁，请稍后再试！",
  The_SMS_Verification_Code_Has_Been_Sent_Procedure: "已发送短信验证码",
  Obtain_SMS_Verification_Code: "获取短信验证码",
  Sending_The_Verification_Code: "正在发送验证码",
  Email: "邮箱",
  Phone_Number: "手机号码",
  Message_Authentication_Code: "短信验证码",
  Please_Enter_A_Valid_Email: "请输入正确的邮箱",
  The_Current_User_Has_Not_Been_Granted_Permissions_Please_Set_The_Permissions_And_Then_Try_Logging_In_Again:
    "当前用户未设置权限，请设置权限后在重试登录",
  Too_Many_Errors_Please_Enter_The_Verification_Code_And_Try_Again:
    "错误次数过多，请输入验证码后重试",

  Automatic_login_failed_Please_enter_your_account_and_password_manually:
    "自动登录失败，请手动输入账号密码",
  Logging_In_Automatically: "正在自动登录",

  //登录
  Chinese: "中文",
  English: "English",
  OMS_System: "OMS系统客户端",
  OMS_System_Admin: "OMS系统管理端",
  UserAccount: "用户账号",
  password: "密码",
  RememberPassword: "记住密码",
  ForgotPassword: "忘记密码",
  RegisterAccount: "注册账号",
  Register: "注册",
  login: "登录",
  Please_enter_a_user_account: "未输入用户账号",
  Please_enter_the_user_password: "未输入密码",
  Obtain_SMS_verification_code: "获取短信验证码",
  SignIn: "登录中",
  LoginSuccessful: "登录成功",
  language: "语言",
  LogOut: "退出登录",
  Skip_logistics_system: "跳转物流系统",
  No_need_to_export_content: "无需导出内容",
  waiting_in_line: "排队中",
  No_data_yet: "暂无数据",
  Account_manager_ID: "客户经理工号",
  message_authentication_code: "短信验证码",
  The_SMS_verification_code_has_been_sent_Procedure: "已发送短信验证码",
  authentication_code: "验证码",
  Sending_the_verification_code: "正在发送验证码",
  Can_exchange: "看不清？点击换一张",
  Export_successfully: "导出成功!",
  Export_task: "导出任务",
  print_out_task: "打印任务",
  Derivation_time: "导出时间",
  Derived_state: "导出状态",
  exporting: "正在导出",
  Recalculation_successful: "重算成功",
  It_is_being_saved_as_a_PDF: "正在另存为PDF",
  The_PDF_export_was_successful_The_automatic_download_has_started_If_it_does_not_start_automatically_please_refresh_and_try_again:
    "PDF导出成功,开始自动下载,如果未自动开始请刷新重试",
  Export_task_name: "任务名称",
  download: "下载",
  download_successfully: "下载成功",
  Too_many_errors_Please_enter_the_verification_code_and_try_again:
    "错误次数过多，请输入验证码后重试",
  fopltal: "操作频繁，请稍后再试！",
  Frequent_operation_please_try_again_later: "操作频繁，请稍后再试！",
  The_logistics_company_does_not_exist_or_has_been_deactivated_Please_check:
    "当前物流公司不存在或未启用，请检查",
  Business_license: "营业执照",
  Business_license_File: "营业执照文件",
  Identity_card: "身份证",
  ID_card_document: "身份证文件",
  Identity_card_code: "身份证号码",
  ID_card_number_of_legal_person: "法人身份证号码",
  Please_enter_the_ID_card_number_of_the_legal_person: "请输入法人身份证号码",
  Please_enter_the_ID_number: "请输入身份证号码",
  Default_customer: "默认客户",
  Do_you_want_to_confirm_the_cancellation: "是否确认作废？",
  express_sheet: "面单",
  Confirm_activation: "是否确认激活?",
  Please_upload_PDF_file: "请上传PDF格式文件",
  delivered: "已交运",
  One_click_export_across_warehouses_is_not_allowed:
    "不允许跨仓库进行一键出库!",
  Please_select_the_recipient_country_first_the_receipt_will_be_saved_to_the_server_in_the_corresponding_region:
    "请先选择收件人国家，面单将会保存至对应地域的服务器上",
  data_reorganizing: "数据整理中",
  Please_upload_the_front_and_back_of_your_ID_card: "请上传身份证正反面",

  //菜单
  Menu_authorization: "菜单授权",
  goodsOnline: "在线商品", //菜单名称修改时注意
  adminGoodsOnline: "在线商品", //管理端 菜单名称修改时注意
  menuID: "菜单ID",
  authorization: "授权",
  editRoleInfo: "编辑角色",
  createRoleInfo: "创建角色", //菜单名称修改时注意
  Role_ordering: "角色排序",
  UserCenter: "个人中心",
  workbench: "工作台", //菜单名称修改时注意
  announceList: "公告列表", //菜单名称修改时注意
  Processing_Center: "处理中心",
  Outbound: "出库",
  Order: "订单",
  pendingOrders: "待发货订单",
  Basic_configuration: "基础配置",
  BasicConfiguration: "基础配置", //菜单名称修改时注意
  basketList: "篮子列表",
  fixedSkuFee: "固定Sku费", //菜单名称修改时注意
  consumables: "耗材类型",
  log: "日志",
  logType: "日志类型",
  Please_upload_the_national_emblem_and_portrait: "请上传国徽面和人像面",
  oprateLog: "操作日志",
  oprateInfo: "操作信息",
  Please_enter_a_keyword_to_search: "请输入关键字进行搜索",
  MenuRemark: "菜单备注",
  Please_select_whether_to_enable_it: "请选择是否启用",
  Please_select_menu_type: "请选择菜单类型",
  menu: "菜单",
  MenuManagement: "菜单管理",
  Please_enter_a_menu_name: "请输入菜单名称",
  Menu_name: "菜单名称",
  Please_add_the_menu: "请先添加菜单",
  The_same_name_menu_is_not_allowed: "不允许出现相同名称菜单！",
  The_data_is_incorrect_adding_failed: "数据有误，添加失败",
  viewWarehouseEntry: "查看入库单", //菜单名称修改时注意
  PDAStatus: "PDA状态",
  Task_generation_type: "任务生成类型",
  Jump_to_old_system: "跳转至旧系统",
  This_operation_will_be_one_click_out_of_the_warehouse_and_can_not_be_undone_be_sure_to_confirm_that_the_order_is_complete_careful_operation:
    "该操作将会一键出库且无法撤销，一定要确认订单商品齐全，谨慎操作！",
  videoPhotoManagement: "录像拍照管理",
  storageSpaceServersWarehouse: "仓内服务器存储空间",
  videoPhotographyManagementControl: "录像拍照管理控制",
  videoPhotoList: "录像拍照列表",
  returnGoodsRegistrationShelving: "快速退货登记质检上架",
  returnInventoryManagement: "退货库存管理",
  returnInventoryList: "退货库存列表",
  ShopeeProfitReport: "Shopee利润报表",
  warehouseLevelReport: "仓库层级收支数据报表",
  platformLevelReport: "平台层级收支数据报表",
  customerLevelReport: "客户层级收支数据报表",
  storeLevelReport: "店铺层级收支数据报表",
  orderLevelReport: "订单层级收支数据报表",
  shopeeOrderProfitReport: "Shopee订单利润报表",
  shopeeStoreReport: "Shopee店铺利润报表",
  currencyExchangeRate: "币种汇率",
  currencyExchangeRateList: "币种汇率列表",
  returnWarehouseFlowList: "退货库位出入库流水列表",
  costRecalculation: "费用重算",
  chargeGiveSpecial: "费用特批",
  ShopeeReport: "Shopee报表",
  TikTokOrderProfitReport: "TikTok订单利润报表",
  logisticsHandover: "物流交接",
  logisticsHandoverTaskList: "物流交接任务列表",
  taskScanningFlowList: "任务扫描流水列表",
  handoverTaskList: "交接任务",
  tikTokStoreProfitReport: "TikTok店铺利润报表",
  lazadaProfitReport: "Lazada利润报表",
  lazadaOrderProfitReport: "Lazada订单利润报表",
  lazadaStoreProfitReport: "Lazada店铺利润报表",
  generateInventoryPlan: "生成备货计划",
  inventoryPlanManagement: "备货单管理",
  TikTokProfitReport: "TikTok利润报表",
  viewInventoryPlanManagement: "查看备货单管理",
  taskFlow: "任务操作流水",
  systemDeductionControl: "系统扣费控制",
  contractAuthorization: "合同授权",
  contractListCheck: "查看合同",
  logisticsHandoverScanningLog: "物流交接扫描日志",

  itemTypeRuleSettings: "件型规则设置",
  addLogisticsChannel: "创建物流渠道",
  editLogisticsChannel: "编辑物流渠道",
  listOfChannelsToBeConfirmed: "待确认渠道列表",
  newlyDevelopedCustomerSetting: "新开发客户设置",
  signTheList: "签署名单",
  categoryManagement: "类目管理",
  refundAndReturnTheProduct: "退货/退款",

  //字典管理
  parent_directory: "上级目录",
  Dictionary_management: "字典管理",
  explain: "说明",
  Please_enter_explain: "请输入说明",
  warning: "警告",
  cancel_authorization: "取消授权",
  Definitive_de_authorization: "确定取消授权?",
  apiPushMotificationList: "推送流水列表",
  //待发货订单
  platform: "平台",
  shop: "店铺",
  Please_select_CustomerId: "请选择客户ID",
  Please_select_shop: "请选择店铺",
  Only_a_single_store_can_be_selected: "仅支持选择单个店铺",
  The_transaction_number_and_order_time_cannot_be_empty_at_the_same_time:
    "交易号与订单时间不能同时为空",
  warehouse: "仓库",
  Warehouse_name: "仓库名称",
  Warehouse_code: "仓库代码",
  storage_location: "库位",
  order_number: "订单号",
  transaction_number: "交易号",
  waybill_number: "运单号",
  logistics_channel: "物流渠道",
  Logistics_track: "物流轨迹",
  Only_orders_entered_into_the_system_at_the_current_time_15_days_are_processed:
    "只处理进入系统当前时间-15天的订单",
  search: "搜索",
  type: "类型",
  state: "状态",
  time: "时间",
  country: "国家",
  Please_enter_country: "请输入国家",
  oprate: "操作",
  operation_log: "操作日志",
  thumbnail: "缩略图",
  Bar_code_of_goods: "商品条码",
  Commodity_bar_code_and_two_dimensional_code: "商品条码二维码",
  stock_position: "仓位",
  Orders_in_the_fulfillment: "配货中订单",
  Pending_sorting_tasks: "待分拣任务",
  Sorting_tasks: "分拣任务中",
  Pending_shipment: "待发货",
  In_transit: "发货中",
  Irregularity_in_delivery: "配货异常",
  Abnormal_quantity_of_distribution: "配货异常数量",
  The_sorting_task_is_abnormal: "分拣任务异常",
  Shipment_exception: "发货异常",
  Abnormal_shipment_quantity: "发货异常数量",
  log_list: "日志列表",
  Document_ID: "单据ID",
  task_order_number: "任务单号",
  order_id: "订单ID",
  Operation_type: "操作类型",
  Operation_Description: "操作描述",
  Operator: "操作人",
  creation_time: "创建时间",
  No_delivery_basket: "暂无配货筐",
  No_sorting_basket: "暂无分拣篮子",
  time_left: "剩余",
  overdue: "逾期",
  days: "天",
  hours: "时",
  minutes: "分",
  copy: "复制",
  copu_successful: "复制成功",
  verify_the_time: "确认时间",
  Transfer_to_oms_time: "转入oms时间",
  sorting_time: "分拣时间",
  Please_tick_the_content_first: "请先勾选内容",
  start_date: "开始日期",
  end_date: "结束日期",
  to: "至",
  Whether_used: "是否已使用",
  Last_three_days: "最近三天",
  Last_week: "最近一周",
  Last_month: "最近一个月",
  Assign_a_distributor: "指定配货员",
  Please_appoint_a_distributor: "请选择指定配货员",
  positionTransfer: "移仓",
  shiftingParkingData: "移库",
  Old_storage_location: "旧库位",
  New_storage_location: "新库位",
  Transfer_quantity: "移库数量",
  Add_transfer_library: "添加移库",
  The_number_of_removable_warehouses: "可移库数量",
  Cannot_scan_the_same_database_location: "不能扫描同一库位",
  This_product_does_not_exist_in_this_repository_Please_scan_other_repositories:
    "该产品在该库位不存在库存,请扫描其他库位",
  Go_to_OMS1_0: "跳转OMS1.0",
  The_bar_code_cannot_exceed_100_characters: "条码不能超过100个字符",
  The_SKU_cannot_exceed_100_characters: "SKU不能超过100个字符",
  The_name_of_a_Chinese_product_cannot_exceed_300_characters:
    "中文品名不能超过300个字符",
  The_name_of_an_English_product_cannot_exceed_300_characters:
    "英文品名不能超过300个字符",

  //单品配货
  Single_product_distribution: "单品配货",
  singleProductDistribution: "单品配货", //菜单名称修改时注意
  tips: "温馨提示",
  Task_mode: "任务方式",
  Get_task: "获取任务",
  Warehouse_partition: "仓库分区",
  Distribution_box_scanning_box: "配货框扫描框",
  Distribution_basket_code: "配货筐编码",
  Barcode_scanning_box_of_goods: "商品条码扫描框",
  picture: "图片",
  Allocated_goods: "已配货",
  To_be_distributed: "待配货",
  stock: "库存",
  view_details: "查看详情",
  details: "详情",
  Logistics_channel: "物流渠道",
  Please_enter_customer_ID: "请输入客户ID",
  conveyor: "传送带",
  please_scan_the_distribution_basket: "请扫描配货筐",
  The_basket_does_not_exist: "该篮子不存在",
  Quantity_of_goods_allocated: "已配货数量",
  When_you_do_not_need_to_pick_and_ship_you_do_not_need_to_carry_the_basket_number_please_scan_the_distribution_basket_code_directly:
    "不需要分拣发货时，不需要携带篮子编号，请直接扫描配货篮子编码!s",
  When_scanning_the_sorting_basket_the_basket_number_is_missing_please_rescan:
    "扫描分拣篮子时，缺少篮子编号，请重新扫描",
  Quantity_sorted: "已分拣数量",
  Quantity_of_goods_to_be_allocated: "待配货数量",
  distributor: "配货人",
  Distribution_time: "配货时间",
  Total_quantity_to_be_allocated: "总待配货数量",
  abnormal_quantity: "异常数量",
  Distribution_start_time: "配货开始时间",
  Distribution_end_time: "配货结束时间",
  Bulk_allocation: "批量配货",
  Sorting_query: "分拣查询",
  Separate_sorting_and_shipping: "单独分拣发货",
  Total_sorting_quantity: "总分拣数量",
  Sorting_stage: "分拣阶段",
  Sorting_end_time: "分拣结束时间",
  sorter: "分拣人",
  reauthorize: "重新授权",
  Prepare_a_single_item_distribution_basket_in_the_current_warehouse:
    "准备一个当前仓库下的单品配货筐",
  Scan_the_distribution_basket: "扫描配货筐",
  Scanning_product_bar_code: "扫描商品条码",
  Click_the_quantity_of_allocated_goods_to_batch_allocate_goods:
    "点击已配货数量可批量配货",
  Scan_the_corresponding_warehouse_location_for_distribution:
    "扫描对应库位进行配货",
  Take_the_goods_that_have_been_allocated_and_scan_the_goods_directly_to_be_shipped:
    "将配货好的商品拿过来，直接扫描商品就可以进行发货",
  Click_the_shipped_quantity_to_ship_in_bulk: "点击已发货数量可进行批量发货",
  Click_on_the_selected_quantity_to_pick_in_bulk: "点击已挑拣数量可以批量挑拣",
  Scan_the_sorting_basket_head: "扫描分拣篮子头",
  Scan_all_distribution_baskets: "扫描所有配货筐",
  Place_in_the_corresponding_sorting_basket: "放入对应的分拣篮子中",
  Scan_the_sorting_basket: "扫描分拣篮子",
  Scan_all_products: "扫描全部商品",
  priority_in_delivery: "优先发货",
  Confirmation_marked_as_priority_shipment: "确认标记为优先发货",
  Click_on_the_shipped_quantity_to_scan_in_bulk: "点击已发货数量可以批量扫描",
  Carry_out_the_corresponding_weighing_photo_operation_to_deliver_the_goods:
    "执行对应称重拍照操作进行发货",

  //多品配货
  multiProductDistribution: "多品配货", //菜单名称修改时注意

  //单品发货
  singleItemDelivery: "单品发货", //菜单名称修改时注意
  Packaging_material: "包材",
  Order_information: "订单信息",
  orderInfo: "订单信息", //菜单名称修改时注意
  total: "合计",
  Shipper: "配货员",
  package_photo: "包裹照片",
  Package_material_information: "包材信息",
  Waybill_number: "运单号",
  Has_been_inspected: "已验货",
  pending_inspection: "待验货",
  abnormal_delivery: "发货异常",
  Photograph: "拍照",
  Enter_key_to_take_a_photo: "回车键拍照",
  Please_weigh_the_order: "请进行订单称重",
  Please_photos_the_order: "请进行订单拍照",
  Out_of_stock_successfully: "出库成功",
  The_order_number_cannot_be_empty: "输入的订单号不能为空！",
  submit: "提交",
  send_back: "退回",
  Flag_exception: "标记异常",
  sensitized: "激活",
  weigh: "称重",
  Remaining_shipment_quantity: "剩余发货数量",
  Quantity_shipped: "已发货数量",
  Quantity_of_goods_to_be_shipped: "待发货数量",
  The_barcode_does_not_exist: "不存在该商品条码",
  Follow_these_steps_to_fill_in_the_standard_template_and_import_the_data:
    "请按照以下步骤填写标准模板并导入数据：",
  Header_Entry_order_information_In_the_template_fill_in_the_data_of_the_table_header_from_order_type_to_remarks_Each_row_represents_an_entry_orderentry_order:
    "1. 头程/入库单信息：在模板中，填写表头从 订单类型 到 备注 的数据，每一行代表一个入库单/头程单。",
  Box_product_information_In_the_template_fill_in_the_table_head_data_from_the_box_number_to_the_weight_KG_box_Each_row_represents_a_box_of_products:
    "2. 箱产品信息：在模板中，填写表头从 箱号 到 重量KG/箱 的数据，每一行代表一箱产品。",
  Please_ensure_that_each_item_is_filled_in_accurately_and_follow_the_example_after_downloading_the_standard_template:
    "请确保每一项数据都填写准确，并下载标准模板后按照示例填写。",
  The_weight_must_not_be_less_than_or_equal_to_0: "重量不得小于等于0",
  Exceeds_the_maximum_weight_please_re_enter: "超出最大重量，请重新输入",
  Unable_to_access_camera_please_reconnect_and_refresh_page:
    "无法访问摄像头,请重新连接后刷新页面",
  Error_uploading_files_to_Alibaba_Cloud_Please_contact_the_administrator:
    "文件上传至阿里云出错请联系管理员",
  The_number_of_anomalies_entered_is_incorrect: "输入的异常数量有误",
  advanceLoadingSingleItemDelivery: "单品发货（提前加载）",
  advanceLoadingMultiProductDelivery: "多品发货（提前加载）",
  advanceLoadingExplosiveDelivery: "爆款发货（提前加载）",
  Only_xlsx_format_files_are_supported_for_import_and_the_size_cannot_exceed_15_MB_A_maximum_of_ten_thousand_rows_of_data_can_be_imported:
    "仅支持导入xlsx格式文件，且大小不可超过15MB，最多支持导入一万行数据",
  //多品分拣
  multiProductSorting: "多品分拣",
  The_sorting_basket_does_not_exist_or_is_already_occupied_Please_refresh_and_try_again:
    "该分拣篮子不存在或已被占用，请刷新后重试",
  Basket_state: "篮子状态",
  Please_Select_Basket_state: "请选择篮子状态",
  The_distribution_basket_does_not_exist: "该配货篮子不存在",
  Sort_the_basket_head: "分拣篮子头",
  Task_details: "任务详情",
  Distribution_basket_not_scanned: "未扫描配货筐",
  Remaining_sorting_orders: "剩余分拣订单",
  Quantity_of_remaining_sorting: "剩余分拣数量",
  Sorting_abnormal_quantity: "分拣异常数量",
  Sorting_start_time: "分拣开始时间",
  The_list_has_been_picked: "已挑拣列表",
  Pick_details: "挑拣详情",
  Sorting_number: "分拣编号",
  Quantity_picked: "已挑拣数量",
  Quantity_to_be_picked: "待挑拣数量",
  Bulk_pick_quantity: "批量挑拣数量",
  Allotment_quantity: "配货数量",
  number_of_pages: "页数",
  Select_the_SKU_that_you_want_to_replace: "选择需要替换的SKU",
  When_entering_transaction_numbers_in_batches_separate_them_with_line_breaks_or:
    "批量输入交易号时，使用换行或者,隔开",

  //多品发货
  Multi_product_delivery: "多品发货",
  multiProductDelivery: "多品发货", //菜单名称修改时注意
  newMultiProductDelivery: "新多品发货", //菜单名称修改时注意
  IF_Need_to_take_pictures: "是否需要拍照",
  IF_Need_to_be_weighed: "是否需要称重",
  Priority_Shipping_Orders: "优先发货订单",
  Scanning_sorting_blue_head: "扫描分拣蓝子头",
  Number_of_current_product_types: "当前商品种类数量",
  kind: "种",
  indivual: "个",
  dispatcher: "配货员",
  Shipping_Basket: "分拣篮子",
  Preview_photo: "预览照片",
  reshoot: "重新拍摄",
  No_photos_yet: "暂无照片",
  determine: "确定",
  Sorting_error_No_basket_number: "分拣有误，无篮子编号",
  The_current_task_is_complete: "当前任务已完成",
  Loading_a_sheet: "正在加载面单",

  //称重出库
  Transaction_number_only: "仅交易号",
  Transaction_number_and_order_weight: "交易号和订单重量",
  Waybill_No_only: "仅运单号",
  Shipment_number_and_order_weight_only: "仅运单号和订单重量",
  Shipping_format: "发货格式",
  Freight_mode: "货运方式",
  Scan_delivery_information: "扫描配送信息",

  //篮子列表
  add_basket_head: "新增篮子头",
  save: "保存",
  Cancel: "取消",
  sequence: "序号",
  Please_enter_basket_header: "请输入篮子头",
  Add_basket: "新增篮子",
  Edit_basket: "编辑篮子",
  Basket_Type: "篮子类型",
  basket_head: "篮子头",
  basket_name: "篮子名字",
  Batch_create_baskets: "批量创建篮子",
  Please_select_a_basket_type: "请选择篮子类型",
  Basket_description: "篮子描述",
  Please_enter_a_basket_description: "请输入篮子描述",
  sorting_basket: "分拣篮子",
  Allotment_basket: "配货篮子",
  Please_select_a_distribution_basket: "请选择配货篮子",
  Sorting_basket_number: "分拣篮子编号",
  Allocation_phase: "配货阶段",
  Allotment_basket_item: "配货篮子(单品)",
  quality_inspection_basket: "质检篮子",
  other_types: "其他类型",
  Operation_time: "操作时间",
  Can_only_contain_letters_and_numbers: "只能包含字母和数字",
  print_basket_number: "打印篮子编号",
  starting_number: "起始编号",
  Please_enter_the_starting_number: "请输入起始编号",
  end_number: "结束编号",
  Please_enter_the_end_number: "请输入结束编号",
  The_label_specification: "标签规格",
  The_starting_number_must_be_less_than_the_ending_number:
    "结束编号必须大于起始编号",
  If_you_enter_the_start_number_2_end_number_5_and_basket_prefix_A_the_basket_will_be_generated_A2_A3_A4_A5:
    "假设输入起始编号2，结束编号5，篮子头A，就会生成篮子：A-2，A-3，A-4，A-5",
  custom_specification: "自定义标签规格",
  operational_context: "操作内容",
  Basket_number: "篮子编号",
  Please_enter_the_basket_name: "请输入篮子编号",
  Bulk_allocation_quantity: "批量配货数量",
  available: "可用",
  occupy: "占用",
  Allocation_task_for_additional_packing_material_delivery:
    "额外包材发货的配货任务!",
  The_basket_needs_to_be_placed_in_the_special_packing_area_of_the_item:
    "需要将该篮子放置在单品特殊打包处",
  The_basket_needs_to_be_placed_in_the_special_packing_area_for_explosive_products:
    "需要将该篮子放置在爆款特殊打包处",
  Please_place_in_the_nearest_single_item_delivery_area:
    "配货完成!请放置到最近的单品发货区",
  Distribution_completed_Please_place_it_in_the_nearest_delivery_area:
    "配货完成!请放置到最近的爆款发货区",
  If_the_inspection_fails_contact_the_administrator:
    "面单检测失败，请联系管理员进行处理",
  Incorrect_ticket_address_Failed_to_read_the_ticket:
    "面单地址有误读取面单失败",
  Failed_to_parse_the_PDF_content: "面单内容损坏解析PDF内容失败",
  Failed_to_convert_PDF_to_JPG: "PDF转JPG失败",
  Failed_to_parse_the_JPG_content: "解析JPG内容失败",
  The_surface_bill_does_not_match_the_waybill: "面单与运单不匹配",
  Enter_product_bar_codes_separated_by_SKU_line_breaks_for_batch_query:
    "请输入商品条码、SKU换行隔开，点击批量查询按钮进行批量查询",
  Getting_data: "正在获取数据...",
  The_shipping_mark_is_being_rendered: "正在渲染唛头...",
  Rendering_box_label: "正在渲染箱标...",
  Print_function_saved_as_PDF: "打印功能保存为PDF",
  Set_the_default_printer_to: "将默认打印机设置",
  Microsoft_Print_to_PDF: "Microsoft Print to PDF",
  Or_set_it_in_the_print_window_that_pops_up_after_you_click_Print:
    "点击打印后弹出的打印窗口内设置",
  After_setting_up_the_printer_click_Print_and_click_OK:
    "设置完成打印机后，点击打印后点击确定",
  Note_When_the_printer_does_not_have_suitable_paper_A4_paper_can_be_used_using_the_top_zoom_function_to_adjust:
    "注：当打印机没有合适纸张时，可使用A4纸张，利用顶部缩放功能进行调整",
  If_the_number_of_export_boxes_exceeds_300_boxes_it_will_be_divided_into_multiple_files_If_you_do_not_want_to_be_divided_into_multiple_files_please_use_the_print_function:
    "注：使用保存为PDF,导出箱数超过300箱，将会被分割成多个文件，若不想被分割成多个文件请使用打印功能",
  This_operation_will_permanently_deleteDo_you_want_to_continue:
    "该操作将会永久删除，是否继续",

  //sku固定信息
  Charge_items: "收费类型",
  Add_currency_information: "新增收费信息",
  Edit_currency_information: "编辑收费信息",
  special_price: "特殊价格",
  default_price: "默认价格",
  discounted_price: "优惠价",
  Listing_fee: "上架费",
  order_processing_fee: "订单处理费",
  orderProcessingFee: "操作费", //菜单名称修改时注意
  Destruction_delisting_fee: "销毁下架费",
  Return_reshelving_fee: "退件重新上架费",
  Return_listing_fee: "退件上架费",
  currency: "货币",
  currency_Type: "货币类型",
  Please_select_currency_type: "请选择货币类型",
  Please_enter_SKU: "请输入SKU",
  Please_enter_Stock: "请输入仓库",
  Please_enter_a_range_fee: "请输入范围费用",
  Please_enter_the_number_of_ranges: "请输入范围数量",
  Please_select_Charge_items: "请选择收费类型",
  expense_breakdown: "费用明细",
  Order_Status: "订单状态",
  Empty_product_details_exist_Please_check_and_try_again:
    "存在空的商品明细，请检查后重试",
  There_are_duplicate_product_details_Please_check_and_try_again:
    "存在重复商品明细，请检查后重试",
  Skus_and_bar_codes_can_only_contain_English_numbers_and_symbols_and_Spaces:
    "SKU、商品条码只能由英文、数字和符号(-、.、_、空格)组成",
  After_activation_all_receiving_and_quality_inspection_information_will_be_cleared_The_stage_of_the_inbound_order_will_be_changed_to_Tail_end_Receiving_in_Progress_Please_complete_the_receiving_and_quality_inspection_operations_again:
    "激活后会清空所有的收货与质检信息，入库单阶段改为尾程收货中，请重新完成收货与质检操作",
  If_necessary_please_make_sure_to_save_the_relevant_delivery_and_quality_inspection_information_before_activation:
    "如有需要请在激活前保存好相关的收货与质检",
  The_bar_code_cannot_start_or_end_with_spaces_or_contain_newlines:
    "条形码不能以空格开头或结尾，也不能包含换行符",

  //发货控制
  SKU: "SKU",
  Modified_by: "修改人",
  founder: "创建人",
  Please_enter_founder: "请输入创建人",
  Please_enter_Modified_by: "请输入修改人",
  tip: "提示",
  Confirm_before_deleting: "您确认要删除这一条数据吗，删除之后将无法恢复！",
  other: "其他",
  ProductID: "商品编号",
  batch_number: "批次号",
  Load_rate: "上架率",

  //菜单列表
  Menu_list: "菜单列表",
  menuList: "菜单列表", //菜单名称修改时注意
  add_Menu: "新增菜单",
  Batch_add_menu: "批量新增菜单",
  Edit_Menu: "编辑菜单",
  Menu_Name: "菜单中文名称",
  Menu_EnName: "菜单英文名称",
  Please_enter_the_Menu_Name: "请输入菜单中文名称",
  Please_enter_the_Menu_EnName: "请输入菜单英文名称",
  Please_enter_menu_sort: "请输入菜单排序",
  Menu_function: "菜单功能",
  Menu_Icon: "图标",
  catalogue: "目录",
  Menu_Path: "菜单地址",
  structure_configuration: "结构配置",
  Please_enter_the_Menu_Path: "请输入访问地址",
  Menu_Sort: "菜单排序",
  Menu_Code: "菜单编码",
  MenuPlease_enter_the_Menu_Code: "请输入菜单编码",
  MenuPlease_enter_the_Menu_address: "请输入菜单地址",
  Please_enter_Menu_Sort: "请输入排序",
  Menu_Name_Not_Null: "菜单中文名称不能为空",
  Menu_EnName_Not_Null: "菜单英文名称不能为空",
  Menu_Code_Not_Null: "菜单编码不能为空",
  Paren_Menu: "父级菜单",
  Son_Menu: "子级菜单",
  Please_Select_Paren_Menu: "请选择父级菜单",
  Please_Select_Son_Menu: "请选择子级菜单",
  Menu_Level: "菜单级别",
  Menu_creator: "菜单创建人",
  Menu_modifier: "菜单修改人",
  Menu_creation_time: "菜单创建时间",
  Menu_change_time: "菜单修改时间",
  Menu_Type: "菜单类型",
  Menu_Stair: "一级",
  Menu_Second: "二级",
  Menu_Three: "三级",
  Visible: "是否可见",
  Remark: "备注",
  RemarkInfo: "备注信息",
  Please_Input_Remark: "请输入备注",
  scanWaybillNumber: "扫描运单号",
  initialDistributionFlowLog: "头程分发流水日志",
  upAndDownListingProcess: "上下架流水是否一致",
  logisticsChannelManagement: "物流渠道管理",
  logisticsChannelManagementList: "物流渠道管理列表",
  managementOfFirstLegwarehouse: "头程物流中转仓管理",
  headlineogisticsAuthorization: "头程物流授权",
  viewAuthorizationDetails: "查看授权详情",
  ThirdPartyWarehouseAuthorization: "第三方仓授权",
  Logistics_company_authorization_information: "物流公司授权信息",
  Transit_warehouse_relation: "中转仓关系",
  customTags: "自定义标签",
  attributeManagement: "属性管理",
  // 头程物流授权页
  Payment_mode: "收款模式",
  Select_payment_mode: "请选择收款模式",
  Our_company_is_collection_of_payments: "我方公司收款",
  Receiving_payment_from_a_third_party_logistics_company: "第三方物流公司收款",
  third_party_logistics_service_provider: "第三方物流公司",
  Receivables_of_both_companies: "双方公司收款",
  Status: "启用状态",
  Select_status: "请选择启用状态",
  Logistics_company_name: "物流公司名称",
  Enter_logistics_company_name: "请输入物流公司名称",
  Enter_creator: "请输入创建人",
  Creation_time: "创建时间",
  Batch_enable: "批量启用",
  Batch_disable: "批量禁用",
  Enter_token: "请输入Token",
  API_account: "API账号",
  Enter_API_account: "请输入API账号",
  API_address: "API地址",
  Enter_API_address: "请输入API地址",
  API_endpoint: "API接口",
  Enter_API_endpoint: "请输入API接口",
  Establish_headhaul_logistics_authorization: "创建头程物流授权",
  After_the_creation_is_successful_please_click_to_synchronize_the_transfer_warehouse_for_the_synchronization_process:
    "创建成功后请点击同步中转仓进行同步",
  Edit_headhaul_logistics_authorization: "编辑头程物流授权",
  Granting_authorization_for_establishing_a_third_party_warehouse:
    "创建第三方仓授权",
  Edit_third_party_warehouse_authorization: "编辑第三方仓授权",
  After_the_creation_is_successful_please_click_Synchronize_Repository_to_perform_the_synchronization:
    "创建成功后请点击同步仓库进行同步",
  Batch_bind_transit_warehouse: "批量绑定中转仓",
  Batch_binding_of_warehouses: "批量绑定仓库",
  Bind_transit_warehouse: "绑定中转仓",
  Bind_the_warehouse: "绑定仓库",
  Unbind_transit_warehouse: "解绑中转仓",
  Unbind_the_warehouse: "解绑仓库",
  Sync_warehouses: "同步仓库",
  Synchronous_transfer_warehouse: "同步中转仓",
  Third_party_transit_warehouse: "第三方中转仓",
  Transit_warehouse: "中转仓库",
  Confirm_unbind_transit_warehouse: "确认解绑该中转仓吗？",
  Failed_to_get_logistics_company_ID: "未获取到物流公司ID",
  Select_transit_warehouse: "请选择中转仓库",
  No_third_party_transit_warehouse_data_sync_first_then_bind:
    "当前暂无第三方中转仓数据，请先同步后再选绑定",
  Select_third_party_warehouse_first: "请先选择第三方仓库",
  Transit_warehouse_already_selected: "该中转仓库已被其他第三方仓库选择",
  Complete_warehouse_pairing: "请完成仓库配对",
  Select_data_first: "请先勾选数据",
  Third_party_transit_warehouse_ID: "第三方中转仓ID",
  Third_party_transit_warehouse_CN_name: "第三方中转仓中文名称",
  Third_party_transit_warehouse_EN_name: "第三方中转仓英文名称",
  Third_party_repository_ID: "第三方仓库ID",
  Third_party_warehouse_code: "第三方仓库编码",
  Name_of_the_third_party_repository: "第三方仓库名称",
  Our_transit_warehouse_ID: "我方中转仓ID",
  Our_transit_warehouse: "我方中转仓",
  Our_transit_warehouse_CN_name: "我方中转仓中文名称",
  Our_transit_warehouse_EN_name: "我方中转仓英文名称",
  Our_warehouse_ID: "我方仓库ID",
  Our_warehouse_code: "我方仓库编码",
  Our_warehouse_name: "我方仓库名称",
  Third_party_warehouse: "第三方仓库",
  Our_warehouse: "我方仓库",
  This_warehouse_has_been_selected_by_other_third_party_warehouses:
    "该仓库已被其他第三方仓库选择",
  Are_you_sure_you_want_to_unbind_this_warehouse: "确定要解绑该仓库吗？",
  Currently_there_is_no_data_from_the_third_party_warehouse_Please_synchronize_first_and_then_select_to_bind:
    "当前暂无三方仓库数据，请先同步后再选绑定",
  //角色列表
  roleInfo: "角色信息",
  sysRole: "角色列表",
  roleList: "角色列表", //菜单名称修改时注意
  Role_CnName: "角色中文名称",
  Role_EnName: "角色英文名称",
  Role_Code: "角色唯一编码",
  Role_IsStart: "是否启用",
  Add_Role: "新增角色",
  Edit_Role: "新增角色",
  Role_Name: "角色名称",
  Please_Input_Role_Name: "请输入角色名称",
  Please_Input_Role_CnName: "请输入中文角色名称",
  Please_Input_Role_EnName: "请输入中文角色名称",
  Please_Input_Role_Code: "请输入角色唯一编码",
  Reset: "重置",
  ResetQuery: "重置查询",
  reset_data: "重置数据",
  Role_Sort: "排序",
  Role_CnName_Not_Null: "角色中文名称不能为空",
  Role_EnName_Not_Null: "角色英文名称不能为空",
  Role_Code_Not_Null: "角色唯一编码不能为空",
  Accredit_Menu: "授权菜单",
  Accredit_Stock: "授权仓库",
  More: "更多",
  Editing_role: "编辑角色",
  Modifying_Role_Permissions: "修改角色权限",
  Role_describe: "角色描述",
  blocked_balances: "冻结余额",
  Amount_of_gift: "赠送金额",
  Adjustment_type: "调整类型",
  Adjustment_blocked_balances: "调整冻结余额",
  Adjustment_Amount_of_gift: "调整赠送金额",
  role_state: "角色状态",

  //用户列表
  usersList: "用户列表",
  usersInfo: "用户信息",
  userManagement: "用户管理",
  User_Code: "用户账号",
  User_Name: "用户名称",
  User_CnName: "角色中文名称",
  Owning_warehouse: "所属仓库",
  Role: "角色",
  RoleManagement: "角色管理",
  user_password: "用户密码",
  staff: "员工",
  staffManagement: "员工管理",
  dictionaries: "字典",
  region: "地区",
  stateManagement: "国家管理",
  User_Branch: "部门",
  User_Phone: "手机",
  User_Rank: "职称",
  User_Email: "邮箱",
  User_EntryDate: "入职日期",
  User_Status: "用户状态",
  commonUser: "普通用户",
  service: "客服",
  open: "开启",
  finance: "财务",
  salesman: "业务员",
  salesmanager: "销售经理",
  superuser: "超级用户",
  overseasagency: "海外代理",
  Please_select_User_Status: "请选择用户状态",
  Please_select_User_Role: "请选择用户角色",
  Please_select_User_Type: "请选择用户类型",
  Please_select_User_Branch: "请选择部门",
  Please_select_User_Sex: "请选择性别",
  Please_select_salesman: "请选择业务员",
  Please_select_service: "请选择客服",
  User_Type: "用户类型",
  User_Sex: "用户性别",
  man: "男",
  woman: "女",
  User_Emergency: "紧急联系电话",
  User_PassWord: "密码",
  User_confirmPassWord: "确认密码",
  User_IDNumber: "身份证",
  User_Address: "住址",
  User_Unit: "单位",
  warehouseList: "仓库列表", //菜单名称修改时注意
  transshipmentdepot: "中转仓库",
  Please_Input_User_Name: "请输入用户名称",
  Please_Input_transshipmentdepot: "请输入中转仓库",
  Please_select_transshipmentdepot: "请选择中转仓库",
  Please_select_stock: "请选择仓库",
  Please_Input_User_Code: "请输入用户编码",
  Please_Input_User_PassWord: "请输入密码",
  Please_Input_User_confirmPassWord: "请输入确认密码",
  Please_Input_User_Rank: "请输入职称",
  Please_Input_User_IDNumber: "请输入身份证",
  Please_Input_User_Emergency: "请输入紧急联系电话",
  Please_Input_User_Phone: "请输入手机号码",
  Please_enter_the_correct_mobile_number: "请输入正确的手机号码",
  Please_Input_User_Address: "请输入住址",
  Please_Input_User_Email: "请输入邮箱",
  Please_enter_the_correct_email_address: "请输入正确的邮箱",
  Please_Input_User_Unit: "请输入单位",
  Please_Input_User_Status: "请选择状态",
  Please_Input_User_Role: "请选择角色",
  Entered_passwords_differ: "两次输入的密码不一致",
  The_password_contains_less_than_characters: "密码长度不能小于6位",
  Tpntbco816dolnos: "密码需要由8-16位的字母、数字和符号组成！",
  The_password_must_contain_8_to_16_characters: "密码长度应为8-16位",
  It_is_currently_being_exported: "当前正在导出",
  When_there_are_many_PDFS_to_be_saved_it_is_recommended_to_export_them_in_batches:
    "当需要保存的PDF较多时建议分批进行导出",
  It_is_recommended_when_there_are_a_large_number_of_PDFS_to_be_saved:
    "当需要保存的PDF较多时建议",
  Export_in_batches: "分批导出",
  The_left_navigation_allows_you_to_select_the_number_of_boxes_to_printSKU_and_quantity:
    "左侧导航可选择打印箱数,SKU,数量",
  Add_User: "新增用户",
  Please_Select: "请选择",
  Please_select_the_print_size: "请选择打印尺寸",
  Please_select_a_single_customer: "请选择单个客户",
  Please_select_print_data: "请选择打印数据",
  Please_select_a_single_warehouse: "请选择单个仓库",
  Please_select_the_same_order_type_order: "请选择相同订单类型的订单",
  Please_Select_Task_Name: "请选择任务名称",
  Please_Select_Order: "请选择订单",
  Please_select_the_business_condition: "请选择业务情况",
  Please_Select_Date: "请选择时间",
  Please_select_billing_properties: "请选择计费属性",
  Please_select_whether_it_can_be_edited: "请选择是否可编辑",
  Enabled: "启用",
  Batch_enabled_goods: "批量启用商品",
  Prohibited_goods_in_bulk: "批量禁用商品",
  Close: "关闭",
  all_transshipmentdepot: "全中转仓库",
  all_warehouse: "全仓库",
  Please_select_a_type: "请选择类型",
  Please_select_content: "请选择内容",
  Cost_information: "费用信息",
  Please_select_a_contact: "请选择联系人",
  The_same_rule_already_exists: "已存在相同规则",
  Please_select_the_goods_for_which_the_storage_location_needs_to_be_changed:
    "请选择需要更换库位的商品",
  all_partition: "全分区",
  enabled_product: "启用商品",
  prohibited_product: "禁用商品",
  set_inventory_warning: "设置库存预警",
  When_a_single_warehouse_is_selected_either_the_priority_picking_floor_or_the_priority_picking_zone_must_be_filled_in_one_of_the_two:
    "当选择单个仓库时，优先配货楼层与优先配货分区为必填项（二选一）",
  When_The_Employee_Type_Is_Picker_And_A_Single_Warehouse_Is_Selected_The_Priority_Picking_Floor_And_Priority_Picking_Zone_Are_Required_Fields_Select_At_Least_One:
    "当员工类型为配货员且选择单个仓库时，优先配货楼层与优先配货分区为必填项（二选一）",

  //部门
  department: "部门",
  Investment_promotion_department: "招商部",
  accounting_department: "财务部",
  customer_service_department: "客服部",
  management_department: "管理部",
  oversea_location: "海外仓",
  distribution: "分销",
  IT: "IT",
  Logistics_Department: "物流部",

  //员工列表
  staffList: "员工列表", //菜单名称修改时注意
  personal_details: "个人信息",
  contact_Information: "联系信息",
  Owning_Information: "所属信息",
  account_Information: "账号信息",
  upload_photo_as_avatar: "上传头像",
  staffInfo: "员工信息", //菜单名称修改时注意
  staff_name: "员工名称",
  staff_Code: "员工账号",
  staff_Status: "员工状态",
  staff_Role: "员工角色",
  staff_gender: "员工性别",
  staffType: "员工类型",
  staff_password: "员工密码",
  Laborial_Staff: "普通员工",
  Administrator: "管理员",
  Please_enter_the_employee_name: "请输入员工名称",
  Please_enter_your_employee_ID: "请输入员工账号",
  Please_select_member_type: "请选择员工类型",
  createStaff: "创建员工", //菜单名称修改时注意
  editStaff: "编辑员工",
  Please_select_member: "请选择员工",
  Please_select_an_employee_role: "请选择员工角色",
  batch_edit_staff_type: "批量编辑员工类型",
  create_staff: "创建员工",
  batch_create_staff: "批量创建员工",
  batchCreateStaff: "批量创建员工",
  batch_modify: "批量修改",
  batch_modify_quantity: "批量修改数量",
  Import_employees: "导入员工",
  Enter_employee_account: "进入员工账号",
  Prioritize_stock_allocation: "优先配货",
  Module_Permissions: "模块权限",
  All_Modules: "全模块",
  After_selecting_a_module_you_can_view_the_data_of_restricted_modules:
    "选择模块后，受限模块的数据都可看到",
  provided_that_the_corresponding_warehouse_or_transit_permissions_are_set:
    "前提是有设置对应仓库/中转仓权限",

  //耗材类型
  Add_consumables_type: "新增耗材类型",
  Edit_consumables_type: "编辑耗材类型",
  Consumable_name: "耗材名称",
  Description_of_consumables: "耗材描述",
  Please_enter_the_consumable_name: "请输入耗材名称",
  Please_enter_a_description_of_the_consumable: "请输入耗材描述",
  type_name: "类型名称",
  Type_description: "类型描述",
  Change_the_time: "修改时间",

  //耗材管理
  Add_consumables: "新增耗材",
  Add_consumable_information: "新增耗材信息",
  Editing_Supplies_Information: "编辑耗材信息",
  Consumables_Code: "耗材编码",
  Consumable_size: "耗材尺寸",
  Number_of_consumables: "耗材数量",
  single_standard_price: "单个标准价格",
  long: "长",
  long_cm: "长(cm)",
  outer_box_long_cm_one: "外箱长(cm/件)",
  Receiving_outer_box_long_cm_one: "收货外箱长(cm/件)",
  please_enter_Receiving_outer_box_long_cm_one: "请输入收货外箱长(cm/件)",
  width: "宽",
  width_cm: "宽(cm)",
  outer_box_width_cm_one: "外箱宽(cm/件)",
  Receiving_outer_box_width_cm_one: "收货外箱宽(cm/件)",
  please_enter_Receiving_outer_box_width_cm_one: "请输入收货外箱宽(cm/件)",
  Received_weight_KG_one: "收货重量(KG/个)",
  Received_weight_KG: "收货重量",
  please_enter_Received_weight_KG_one: "请输入收货重量(KG/个)",
  height: "高",
  height_cm: "高(cm)",
  outer_box_height_cm_one: "外箱高(cm/件)",
  Receiving_outer_box_height_cm_one: "收货外箱高(cm/件)",
  please_enter_Receiving_outer_box_height_cm_one: "请输入收货外箱高(cm/件)",
  Please_enter_the_consumable_code: "请输入耗材编码",
  Please_enter_length_width_and_height: "请输入长宽高尺寸",
  Please_enter_the_quantity_of_consumables: "请输入耗材数量",
  Please_enter_a_single_standard_price: "请输入单个标准价格",
  Please_select_a_warehouse: "请选择仓库",
  Please_enter_warehouse: "请输入仓库",
  Please_select_a_consumable_type: "请选择耗材类型",
  Consumable_Type: "耗材类型",
  Billing_way: "计费方式",
  The_priority_billing_method_shall_prevail: "以优先计费方式为准",
  Excluding_the_amount: "金额除外",
  Automatically_calculate_the_estimated_inventory_formula:
    "自动计算预警库存公式",
  All_billing_methods_will_be_calculated_and_the_highest_fee_will_be_taken_as_the_standard:
    "会将所有计费方式全部计算,以费用最高为准",
  Billing_attribute: "计费属性",
  Stores_operation_accounting_attributes: "仓储操作计费属性",
  Precedence_Billing_way: "优先计费方式",
  Please_select_Precedence_Billing_way: "请选择优先计费方式",
  The_number_of_the_first_charge: "首件计费件数",
  The_number_of_the_first_billing_item_must_not_be_less_than_1:
    "首件计费件数不能小于1",
  please_enter_The_number_of_the_first_charge: "请输入首件计费件数",
  Please_enter_the_number_of_items_for_which_the_charge_will_be_calculated:
    "请输入续件计费数",
  The_continuation_charge_amount_cannot_be_less_than_1: "续件计费数不能小于1",
  Please_select_Billing_way: "请选择计费方式",
  Volume_weight_value: "体积重值",
  Please_enter_volume_weight_value: "请输入体积重值",
  Please_enter_the_case_number: "请输入箱号",
  The_case_number_does_not_exist: "不存在该箱号!",
  The_sku_does_not_exist: "不存在该SKU",
  Save_receipt: "保存收货",
  Save_receipt_succeed: "保存收货成功",
  Please_stock_the_goods_at_the_specified_distribution_warehouse:
    "请在指定的配货库位配货",
  putaway: "上架",
  Inventory_batch_number: "库存批次号",
  unfinished: "未完成",
  completed: "已完成",
  Export_the_pairing_data: "导出配对数据",
  Currently_no_floor_is_added_to_the_warehouse_Please_perform_this_operation_after_adding_a_floor:
    "当前仓库未添加楼层，请添加楼层后在进行此操作",
  If_the_selected_data_exists_the_selected_data_is_processed_preferentially_for_batch_processing:
    "若存在勾选数据，则优先处理勾选数据进行批量处理",
  If_the_selected_data_is_not_selected_manually_fill_in_the_box_number_range_for_batch_processing:
    "未勾选数据时则手动填写箱号区间进行批量处理",
  If_the_field_value_is_empty_the_field_data_is_not_modified:
    "当字段值为空或者为0.00时则不会修改该字段数据",

  //一件待发费设置
  Momentumfee: "一件待发费设置",
  export: "导出",
  Export_the_header_order: "导出头程订单",
  Export_the_header_list: "导出头程清单",
  Export_the_First_bill: "导出头程账单",
  Export_the_import_and_export_details: "导出出入库明细",
  Three_sides_before_weight: "先三边后重量",
  First_weight_then_three_sides: "先重量后三边",
  First_cubic_then_weight: "先立方后重量",
  First_weight_then_cube: "先重量后立方",
  First_cube_and_then_three_sides: "先立方后三边",
  Three_sides_before_the_cube: "先三边后立方",
  entryAndExitDetails: "出入库明细",
  add: "添加",
  Batch_add: "批量添加",
  Batch_delete: "批量删除",
  date: "日期",
  The_longest_edge: "最长边",
  Long_side: "次长边",
  The_shortest_edge: "最短边",
  weight: "重量",
  Start_weight: "起始重量",
  End_weight: "截止重量",
  weight_KG: "重量(KG)",
  number: "件数",
  Add_interval: "添加区间",
  SumThreeSides: "三边长总和",
  SumThreeSides_CM: "三边长总和(CM)",
  The_sum_of_the_three_sides_cannot_be_negative: "三边长总和不能为负数",
  First_packing_material_cost: "首包材费用",
  Three_sides_length: "三边和",
  Three_sides: "三边",
  Start_hree_sides_length: "起始三边长",
  End_hree_sides_length: "截止三边长",
  Three_sides_length_CM: "三边和(CM)",
  actual_SumThreeSides: "实际三边长总和",
  actual_SumThreeSides_CM: "实际三边长总和(CM)",
  Continued_SKU_packaging_costs: "续SKU包材费用",
  The_number_of_continuations_is_charged: "续件计费件数",
  Please_enter_the_number_of_continuation_charges: "请输入续件计费件数",
  cost_a: "费用/个",
  Cost_attribute: "费用属性",
  cost_one_day_cube: "费用(天/立方)",
  cube: "立方",
  Start_cube: "起始立方",
  End_cube: "截止立方",
  Extra_charge: "续SKU操作费",
  One_charge: "首SKU操作费",
  One_Packaging_material: "首SKU包材费",
  Extra_Packaging_material: "续SKU包材费",
  Currency_type: "币种",
  Original_Currency_type: "原币种",
  Packaging_material_cost: "包材费",
  packagingMaterialManagement: "包材管理",
  Please_enter_Currency_type: "请输入币种",
  Please_select_Currency_type: "请选择币种",
  Please_enter_The_longest_edge: "请输入最长边",
  Please_enter_Long_side: "请输入次长边",
  Please_enter_The_shortest_edge: "请输入最短边",
  Please_enter_weight: "请输入重量",
  Please_enter_quantity: "请输入数量",
  Please_enter_SumThreeSides: "请输入三边长总和",
  Please_enter_cost_a: "请输入三边长总和",
  Please_enter_cost: "请输入费用",
  Please_enter_Extra_charge: "请输入续SKU操作费",
  Please_enter_One_charge: "请输入首SKU操作费",
  Please_enter_number: "请输入件数",
  Please_enter_One_Packaging_material: "请输入首SKU包材费",
  Please_enter_Extra_Packaging_material: "请输入续SKU包材费",
  Cancel_the_editor: "取消编辑",
  Cancel_the_add: "取消添加",
  Failed_to_start_the_camera_Please_check_whether_the_camera_is_available_Or_turn_on_the_camera_head:
    "摄像头开启失败，请检查摄像头是否可用！或者打开摄影头",
  This_operation_cannot_be_undone_Do_you_want_to_continue:
    "该操作将无法撤回，是否继续？",
  size: "尺寸",
  Please_select_size: "请选择尺寸",
  Please_enter_size: "请输入尺寸",
  Three_high: "长宽高",
  packaging: "打包方式",
  The_whole_pack: "整单打包",
  Pack_by_sku: "按SKU打包",
  Packing_according_to_the_entire_order_will_pack_all_the_items_in_the_entire_order_together:
    "按照整个订单进行打包,会将整个订单内所有商品打包到一起",
  Package_according_to_SKU_and_pack_together_with_SKU:
    "按照SKU进行打包,会将同SKU的商品打包到一起",
  All_items_will_be_packaged_separately: "会将所有商品进行单独打包",
  Create_a_warehouse_entry: "创建入库单",
  Separate_product_packaging: "单独商品打包",
  editCost: "编辑费用", //菜单名称修改时注意

  //扫描拍照
  outbound_pictures: "出库拍照",
  photo_list: "拍照列表",
  scan_pictures: "扫描拍照",
  scanning_waybill_number: "扫描运单号",
  The_operation_fails_Check_whether_the_input_of_the_waybill_number_is_correct:
    "操作失败，请查看运单号输入是否正确",

  //拍照列表
  Review_images: "查看图片",
  Operation_of: "操作人",
  start_time: "开始时间",
  End_days: "结束天数",
  Please_enter_the_start_time: "请输入开始时间",
  Please_enter_the_end_time: "请输入结束时间",
  The_input_start_time_cannot_be_negative: "输入的开始时间不能为负数",
  The_end_time_cannot_be_negative: "输入的结束时间不能为负数",
  The_start_time_cannot_be_later_than_the_end_time:
    "开始时间不允许大于结束时间",
  The_end_time_cannot_be_later_than_the_start_time:
    "结束时间不允许小于开始时间",
  end_time: "结束时间",
  Batch_set_roles: "批量设置角色",

  //公告
  Bulletin: "公告",
  BulletinManagement: "公告管理",
  Bulletin_Type: "公告类型",
  Bulletin_Name: "公告名称",
  This_window_asks_if_you_want_to_leave: "此窗口询问您是否要离开",
  The_information_you_enter_may_not_be_saved: "您输入的信息可能不会被保存",
  New_announcement: "新增公告",
  announcementState: "公告状态",

  // 工单管理
  workOrder: "工单管理",
  workOrderList: "工单列表",
  work_order_ID: "工单ID",
  problem_description: "问题描述",
  problem_types: "问题类型",
  processed_time: "已处理时间",
  processor: "处理人",
  discuss: "评论",
  ranking: "评分等级",
  turn_off_time: "关闭时间",
  New_work_order: "新增工单",
  result_of_handling: "处理结果",
  Please_enter_the_work_order_ID: "请输入工单ID",
  Please_provide_the_description_of_the_problem: "请输入问题描述",
  Please_provide_the_result_of_handling: "请输入处理结果",
  Work_order_information: "工单信息",
  Should_this_work_order_be_invalidated: "是否作废此工单是否作废？",
  to_deal_with: "去处理",
  Work_order_processing: "工单处理",
  reply: "回复",
  Please_select_the_type_of_question: "请选择问题类型",
  Please_select_the_rating_level: "请选择评分等级",
  Please_enter_your_evaluation: "请输入评价",
  initiator: "发起人",

  //字典列表
  Adding_dictionary_Categories: "添加字典分类",
  DictionaryList: "字典列表",
  dictionaryList: "字典列表", //菜单名称修改时注意
  EditDictionary: "编辑字典",
  Please_enter_the_dictionary_name: "请输入字典名称",
  Name_of_dictionary: "字典名称",
  Chinese_name: "中文名称",
  English_name: "英文名称",
  Goods_Chinese_name: "商品中文名称",
  Goods_English_name: "商品英文名称",
  setpoint: "设定值",
  Please_enter_Chinese_name: "请输入中文名称",
  Please_enter_English_name: "请输入英文名称",
  Please_enter_setpoint: "请输入设定值",
  Add_dictionary: "添加字典",
  Batch_Add_dictionary: "批量添加字典",
  value: "值",
  Please_add_the_dictionary_first: "请先添加字典",
  Chinese_name_English_name_does_not_allow_null_value:
    "中文名称/英文名称不允许出现空值",
  The_value_cannot_be_modified_after_it_is_set_Please_confirm_and_add_it_after_completion:
    "值设定后将无法修改，请确认完成后在进行添加!",
  Batch_Add_Parent_Directory: "批量添加上级目录",

  // 工作台
  recently: "近",
  day: "天",
  Warehouse_capacity: "仓库库容",
  Warehouse_capacity_data: "仓库库容数据",
  Service_storage_capacity: "使用库容",
  Storage_capacity_in_transit: "在途库容",
  Residual_storage_capacity: "剩余库容",
  Use_of_space: "使用仓位",
  Available_space: "可用仓位",
  financial_data: "财务数据",
  all_costs: "所有费用",
  storage_charges: "仓租",
  Removal_fee: "下架费",
  Returnable_shelving_fee: "退件上架费",
  other_expenses: "其他费用",
  Order_data: "订单数据",
  Orderto_be_supplied: "待配货订单",
  Order_In_transit: "发货中订单",
  Orderto_shipped: "已发货订单",
  Nearly_a_day: "近一天",
  Last_seven_days: "近七天",
  The_last_thirty_days: "近三十天",
  Nearly_ninety_days: "近九十天",
  Customer_details: "客户明细",
  TC_data: "头程数据",
  TC_wait_for_receiving: "头程待收货",
  Transfer_Warehouse_Receipt: "中转仓收货",
  Transit_warehouse_receiving_time: "中转仓收货时间",
  in_transit: "运输中",
  The_Last_Leg_Received: "尾程已收货",
  finish: "完成",
  Warehouse_entry_data: "入库单数据",
  Transit_warehouse_to_receive_goods: "中转仓待收货",
  The_last_leg_to_be_received: "尾程待收货",
  To_be_inspected: "待质检",
  To_be_put_on_the_shelf: "待上架",
  Return_data: "退件数据",

  //客户列表
  Customer_ID: "客户ID",
  ClientManagement: "客户管理",
  Customer: "客户",
  spread: "展开",
  pack_up: "收起",
  Put_away_the_menu: "收起菜单",
  Customer_List: "客户列表",
  clientList: "客户列表", //菜单名称修改时注意
  advanced_query: "高级查询",
  Customer_account_number: "客户账号",
  Please_enter_account_number: "请输入客户账号",
  Customer_account_name: "客户姓名",
  Please_enter_account_name: "请输入客户姓名",
  Customer_account_state: "客户状态",
  Please_enter_account_state: "请输入客户状态",
  unverified: "未认证",
  approve: "审批通过",
  Approval_failure: "审批失败",
  Api_Order: "API订单",
  Notification_Form: "推送单",
  handbill: "手工单",
  forbidden: "禁用",
  audit: "审核中",
  Contract_to_be_signed: "待签合同",
  cell_phone_number: "手机号码",
  Please_enter_cell_phone_number: "请输入手机号码",
  Please_select_cell_phone_number: "请选择客户状态",
  Please_select_Customer: "请选择客户",
  company_name: "公司",
  corporate_company: "法人公司",
  Please_enter_company_name: "请输入公司名称",
  registration_time: "注册时间",
  Business_termination_time: "终止业务时间",
  Contract_review_time: "审核合同时间",
  clearing_form: "结算方式",
  Please_select_clearing_form: "请选择结算方式",
  Please_select_whether_to_renew: "请选择是否续签",
  Please_select_the_type_of_customer: "请选择客户类型",
  Please_select_city: "请选择城市",
  Starting_amount: "开始金额",
  Closing_amount: "结束金额",
  prejunction: "预结",
  monthly_balance: "月结",
  balance_outstanding: "余额",
  Please_enter_balance_outstanding: "请输入余额",
  Please_enter_contact_information: "请输入联系方式",
  Please_select_balance_outstanding: "请选择余额",
  Please_select_the_shipping_to_transit_bin_method: "请选择运输到中转仓方式",
  have: "有",
  without: "无",
  Add_customer: "添加客户",
  Batch_upload: "批量上传",
  reset_passwords: "重置密码",
  Limit_adjustment: "调整额度",
  allot_salesman: "分配业务员",
  allot_service: "分配客服",
  Customer_Name: "客户名称",
  subordinate_companies: "所属公司",
  contact_information: "联系方式",
  account_frozen: "冻结金额",
  line_of_credit: "信用额度",
  No_currency_available: "暂无币种",
  Set_currency: "设置币种",
  account_type: "账户类型",
  account_state: "账户状态",
  Merchant_name: "商户名",
  Merchant_Number: "商户号",
  Corporate_name: "法人姓名",
  Corporate_Identity_Card: "法人身份证",
  Corporate_phone_number: "法人手机号",
  Business_license_registration_address: "营业执照注册地址",
  business_address: "办公地址",
  Unified_social_credit_code: "统一社会信用代码",
  Please_enter_unified_social_credit_code: "请输入统一社会信用代码",
  user_role: "用户角色",
  service_team: "服务团队",
  Distribution_service_team: "分配服务团队",
  Please_select_a_customer: "请选择一个客户",
  available_balance: "可用余额",
  Audit_customer: "审核客户",
  Confirm_to_audit_the_customer: "确认审核该客户",
  Please_enter_the_customer_mobile_number: "请输入客户手机号",
  New_account_login_will_overwrite_the_data_of_the_original_account_whether_to_continue:
    "新账号登录将会覆盖原有账号的数据，是否继续?",
  Set_up_warehouse: "设置仓库",
  Set_up_a_transit_warehouse: "设置中转仓",
  Full_warehouse_or_not: "是否全仓库",
  Whether_all_transfer_warehouse: "是否全中转仓",
  Total_balance: "总余额",

  //客户信息
  client_info: "客户信息",
  clientInfo: "客户信息", //菜单名称修改时注意
  createClient: "创建客户", //菜单名称修改时注意
  editClient: "编辑客户", //菜单名称修改时注意
  basic_information: "基本信息",
  address_message: "地址信息",
  QQ_WeChat: "QQ/微信",
  QQ_WeChat_ID_Not_Nickname: "QQ/微信号(非昵称)",
  oblast_province: "州/省",
  province: "省",
  district: "区",
  Please_enter_oblast: "请输入州",
  city: "城市",
  Please_enter_city: "请输入城市",
  location: "地址",
  shipping_address: "收货地址",
  Alternate_delivery_address: "备用收货地址",
  Please_enter_location: "请输入地址",
  financial_information: "财务信息",
  customer_code: "客户编码",
  Customer_mailbox: "客户邮箱",
  Customer_mobile_phone_number: "客户手机号",
  customer_company: "客户公司",
  Superior_account: "上级账号",
  service_conditions: "业务情况",
  underway: "进行中",
  Terminated: "已终止",
  delivery_method: "交付方式",
  assigner: "分配人",
  operating_log: "操作日志",
  auditor: "审核人",
  audit_time: "审核时间",
  Identifying_people: "确认人",
  acknowledging_time: "确认时间",
  Whether_to_send_back_ERP: "是否回传ERP",
  Return_time: "回传时间",
  Return_result: "回传结果",
  Account_top_up_details: "账户充值明细",
  accountTopUpDetails: "账户充值明细", //菜单名称修改时注意
  Recharge_method: "充值方式",
  Storage_query: "库存查询",
  storageQuery: "库存查询",
  account_recharge: "账户充值",
  accountRecharge: "账户充值", //菜单名称修改时注意
  online_trading: "在线交易",
  Online_payment: "在线付款",
  money: "金额",
  Please_enter_the_money: "请输入金额",
  Recharge_type: "充值类型",

  //温馨提示
  The_page_you_visited_does_not_exist_Please_check_whether_the_network_connection_is_normal_or_check_whether_the_address_input_is_correct:
    "您访问的页面不存在，请查看网络连接是否正常，或查看地址输入是否正确!",
  The_orders_that_have_been_shipped_and_failed_to_be_shipped_can_be_scanned_and_reprinted_here_Orders_that_have_been_shipped_can_be_reprinted_here_Note_The_order_must_be_the_order_placed_in_your_task_list:
    "已经发货扫描完成出货失败的订单，可以在此补印出货；已经出货的订单可以在此重新补印面单。（注：订单必须是您任务单下的订单）",
  Confirm_the_mark_is_abnormal: "确定标记异常？",
  operation_procedure: "操作流程",
  Operating_Instructions: "操作说明",

  //公告列表
  general: "通用",
  system_wide: "全系统",
  clientSide: "客户端",
  Management: "管理端",
  Announcement_title: "公告标题",
  Announcement_content: "公告内容",
  Announcement_Number: "公告编号",
  Please_enter_Announcement_title: "请输入公告标题",
  Please_enter_Announcement_Number: "请输入公告编号",
  Please_enter_Announcement_content: "请输入公告内容",
  Please_select_Bulletin_Type: "请选择公告类型",

  // API推送流水
  title: "标题",
  method: "请求方法",
  requestMethod: "请求方式",
  operUrl: "操作URL",
  operIp: "操作IP地址",
  operLocation: "操作地点",
  operParam: "操作参数",
  status: "状态",
  errorMsg: "错误信息",
  operTime: "操作时间",
  Success: "成功",
  Failure: "失败",

  //流水管理
  Inventory_batch_id: "库存批次ID",
  Verification_time: "校验时间",
  Operation_id: "操作ID",
  The_number_of_differences: "差异数量",
  Inventory_entry_and_exit_process_id: "出入库流水ID",

  //仓储订单列表
  Inventory_order_list: "仓储订单列表",
  inventoryOrderList: "仓储订单列表", //菜单名称修改时注意
  inventoryAllOrderList: "全部订单",
  abnormalTransportationList: "交运异常",
  warehouse_order_management: "仓储订单管理",
  logistics: "物流",
  logistics_status: "物流状态",
  Please_select_Logistics_channel: "请选择物流渠道",
  Platform_state: "平台状态",
  Please_select_Platform_state: "请选择平台状态",
  Please_select_Issue_Status: "请选择下发状态",
  Please_enter_order_number: "请输入订单号",
  Confirm_that_the_settings_are_not_synchronized_for_online_products:
    "确认设置不同步在线商品",
  Confirm_synchronization_of_the_specified_strategy_inventory:
    "确认同步指定策略库存",
  Please_select_the_mode: "请选择模式",
  Please_enter_the_rule_name: "请输入规则名称",
  Please_enter_the_inventory_threshold: "请输入库存阈值",
  Please_select_the_designated_store: "请选择指定店铺",
  Please_select_the_designated_SKU: "请选择指定SKU",
  Please_select_the_synchronous_SKU_range: "请选择同步SKU范围",
  Please_select_the_scope_of_the_synchronized_store: "请选择同步店铺范围",
  Please_select_the_inventory_allocation_strategy: "请选择库存分配策略",
  Please_enter_the_synchronized_inventory_quantity: "请输入同步库存数量",
  Please_carefully_verify_whether_the_warehouse_address_is_consistent_with_the_system:
    "请仔细检查仓库地址是否则跟系统一致",
  Please_enter_the_inventory_synchronization_strategy_value:
    "请输入库存同步策略值",
  The_inventory_synchronization_strategy_value_cannot_be_a_negative_number:
    "库存同步策略值不能为负数",
  The_synchronized_inventory_quantity_cannot_be_a_negative_number:
    "同步库存数量不能为负数",
  The_inventory_synchronization_strategy_value_must_be_greater_than_0:
    "库存同步策略值必须大于 0",
  The_synchronized_inventory_quantity_must_be_greater_than_0:
    "同步库存数量必须大于0",
  Please_enter_waybill_number: "请输入运单号",
  Please_enter_transaction_number: "请输入交易号",
  Priority_delivery: "优先交付",
  Priority_delivery_order: "优先交付订单",
  Non_priority_delivery_orders: "非优先交付订单",
  Platform_setting_priority_delivery: "平台设置优先交付",
  Manually_set_priority_delivery: "手动设置优先交付",
  Please_select_Priority_delivery: "请选择是否优先交付",
  shipping_method: "送货方式",
  Please_select_shipping_method: "请选择投递方式",
  Please_select_logistics_status: "请选择物流状态",
  Please_select_platform: "请选择平台",
  time_of_payment: "付款时间",
  Please_select_time_of_payment: "请选择付款时间",
  Please_select_Recharge_method: "请选择充值方式",
  To_be_reviewed: "待审核",
  drop_shipping: "待发货",
  Being_distributed: "配货中",
  shipped: "已发货",
  have_been_voided: "已作废",
  have_been_reject: "已驳回",
  Get_the_tracking_number: "获取运单号",
  Set_up_order_package_materials: "设置订单包材",
  Forward_delivery: "转入待发货",
  cancellation: "作废",
  Cancelled_order: "作废订单",
  activate: "激活",
  Get_order: "获取订单",
  Get_order_time: "获取订单时间",
  Upload_sheet: "上传面单",
  processing_batch: "批处理",
  Return_for_review: "退回待审核",
  Print_sheet: "打印面单",
  Preview_the_waybill: "预览面单",
  Printing_sheet: "打印面单中...",
  Preview_failed_orders: "预览失败订单",
  create_order: "创建订单",
  createOrder: "创建订单", //菜单名称修改时注意
  Batch_create_order: "批量创建订单",
  stores_expired: "个店铺授权过期",
  Push_or_not: "是否推送",
  Please_select_whether_to_push: "请选择是否推送",
  Please_select_order_status: "请选择订单状态",
  Platform_logistics_channel: "平台物流渠道",
  master_bill_number: "主单号",
  WMS_status: "WMS状态",
  destination_country: "目的国家",
  Platform_remarks: "平台备注",
  Warehouse_presence_remarks: "存在仓库备注",
  No_warehouse_remarks_exist: "不存在仓库备注",
  Warehouse_note: "仓库备注",
  Delivery_of_abnormal_information: "交运异常信息",
  Remaining_delivery_time: "剩余发货时间",
  order_amount: "订单金额",
  primitive_money: "原始货币",
  Order_profit: "订单利润",
  profit_margin: "利润率",
  delivery_time: "出库时间",
  Deduct_time: "扣费时间",
  Save_the_current_search_conditions: "保存当前查询条件",
  No_data_is_selected: "未选择任何数据!",
  No_customer_has_been_selected: "未选择任何客户!",
  The_order_was_cancelled_successfully: "订单作废成功!",
  Order_activation_success: "订单激活成功!",
  Orders_have_been_prioritized_for_delivery: "订单已设置优先交付!",
  OrderInfo: "订单详情",
  Modify_remarks: "修改备注",
  Quick_query_condition: "快捷查询条件",
  Marked_delivery: "标记发货",
  Please_select_a_piece_of_data: "请选择一条数据",
  Marked_delivery_Succeed: "标记发货成功",
  Marked_delivery_lose: "标记发货失败",
  Systematic_item_list: "系统商品明细",
  not_available: "暂无",
  multiattribute: "多属性",
  multiattributeID: "多属性ID",
  Please_select_an_order_from_the_same_warehouse: "请选择同一仓库下的订单",
  Batch_replacement_of_SKUs: "批量替换SKU",
  replace_SKU: "替换SKU",
  delete_SKU: "删除SKU",
  add_sku: "添加SKU",
  Only_one_SKU_can_be_replaced: "仅支持单个SKU进行替换",
  Select_the_sku_that_you_want_to_replace: "选择需要替换的sku",
  Select_the_new_SKU: "选择新的SKU",
  Whether_the_product_has_a_barcode: "商品是否有贴商品条码",
  Duplicate_SKUs_appear: "出现重复的SKU",
  Printing: "正在打印...",
  Please_select_a_type_of_basket: "请选择一个类型的篮子",
  printPreview: "预览打印",
  designPrinting: "设计打印",
  Delete_an_order: "删除订单",
  Pairing_or_not: "是否配对",
  type_of_merchandize: "商品种类",
  Print_type: "打印类型",
  The_uploaded_file_format_is_incorrect: "上传文件格式错误",
  Currently_only_single_order_upload_is_supported: "暂时只支持单个订单上传",
  Save_as_PDF: "保存为PDF",
  downloading: "正在下载",
  Direct_printing: "直接打印",
  Confirm_submission: "是否确认提交?",
  quantity_of_order: "订单数量",
  hour: "时",
  The_task_can_be_obtained_directly: "可直接获取任务",
  You_need_to_scan_the_distribution_basket_to_get_the_task:
    "需要扫描配货篮子才可以获取任务",
  When_the_task_type_is_multi_product_you_can_choose_whether_to_allocate_goods_by_floor:
    "当选择任务类型为多品才可以选择是否按楼层配货",
  Whether_to_scan_the_warehouse_location_when_distributing_goods:
    "配货时是否需要扫描库位",
  When_the_task_type_is_multi_product_the_matching_and_sending_function_cannot_be_enabled:
    "当选择任务类型为多品不可开启边配边发",
  presell: "预售",
  stockoutOrder: "缺货订单",
  No_out_of_stock_orders: "非缺货订单",
  Online_product_Pictures: "线上产品图片",
  After_the_warehouse_is_selected_the_corresponding_inventory_will_be_returned:
    "出库选择仓库后会回传对应库存",
  Transfer_the_tracking_number_to_obtain: "转入运单号获取中",
  Transfer_the_tracking_number_to_obtain_or_pending_shipment:
    "转入运单号获取中/待发货",
  Orders_with_a_tracking_number_will_automatically_be_moved_to_awaiting_shipment_while_orders_without_a_tracking_number_will_enter_tracking_number_retrieval:
    "有运单号的会自动转入待发货，无运单号的订单会进入运单号获取中。",
  The_tracking_number_exists: "存在运单号",
  No_waybill_number_exists: "不存在运单号",
  has_waybill_number: "有运单号",
  no_waybill_number: "无运单号",
  Whether_out_of_stock: "是否缺货",
  stockout: "缺货",
  stockout_short: "缺",
  // 短标识
  Platform_and_Shop: "平台/店铺",
  Whether_the_waybill_number_exists: "是否存在运单号",
  Presence_platform_remarks: "存在平台备注",
  No_platform_remarks: "不存在平台备注",
  has_platform_remark: "有平台备注",
  no_platform_remark: "无平台备注",
  Presence_remark: "存在备注",
  No_remarks_exist: "不存在备注",
  has_remark: "有备注",
  no_remark: "无备注",
  Split_order: "拆分订单",
  Unsplit_order: "非拆分订单",
  Advance_order: "预售订单",
  Non_advance_order: "非预售订单",
  Matching_order: "配对订单",
  Already_paired_Order: "已配对订单",
  unpaired_Order: "未配对订单",
  Traffic_anomaly: "交运异常",
  A_traffic_exception_exists_Procedure: "存在交运异常",
  No_traffic_exception_exists: "不存在交运异常",
  has_transportation_abnormal: "有交运异常",
  no_transportation_abnormal: "无交运异常",
  allTask: "全部任务",
  todayTask: "今日任务",
  todayTask17: "今日任务17",
  todayTask14: "今日任务14",
  todayTask19: "今日任务19",
  yesterdayTask: "昨日任务",
  New_quick_query: "新增快捷查询",
  Order_status_inquiry: "订单状态查询",
  The_tracking_number_is_being_obtained: "运单号获取中...",
  Submit_the_order_task: "提交的订单任务",
  Mixed_shipment_or_not: "是否混合发货",
  Order_task_submitted_today_00_00_00_18_00_00:
    "今日00:00:00-18:00:00提交的订单任务",
  Order_task_submitted_yesterday_00_00_00_23_59_59:
    "昨日00:00:00-23:59:59提交的订单任务",
  This_operation_will_permanently_delete_the_query_condition_Do_you_want_to_continue:
    "此操作将永久删除该查询条件, 是否继续?",
  After_obtaining_the_tracking_number_it_will_be_automatically_transferred_to_the_agent_for_delivery:
    "运单号获取成功后会自动转入待发货",
  The_input_format_is_incorrect_English_is_not_allowed_only_three_decimal_places:
    "输入格式有误，不允许出现英文，仅三位小数",
  Once_the_QR_code_scanning_is_initiated_it_will_be_invalid_Repeated_scanning_will_fail_the_verification_and_the_transaction_needs_to_be_re_initiated:
    "发起在线充值二维码扫描一次后将会失效，重复扫描将会校验不通过,需要重新发起交易",
  Confirm_the_transfer_pending: "确认转入待处理",
  transfer_pending: "转入待处理",
  When_the_task_type_is_multi_product_if_delivery_inspection_is_disabled_there_is_no_need_to_scan_all_SKUs_of_the_corresponding_order_scanning_one_SKU_will_allow_the_corresponding_order_to_be_shipped_If_enabled_all_SKUs_of_the_order_need_to_be_scanned:
    "当任务类型为多品时，若关闭了发货验货，则不需要扫描对应订单所有的sku，扫描其中一个sku，对应的订单就会出库。若开启，则需要扫描订单所有的sku。",
  When_the_task_type_is_single_product_and_the_match_and_send_function_is_enabled_There_is_no_need_to_wait_for_the_allocation_task_to_be_completely_finished_Once_some_SKUs_are_allocated_you_can_operate_the_orders_of_the_corresponding_allocated_SKUs_for_shipping:
    "当任务类型为单品时，开启了边配边发。无需等待配任务完全配货完成，部分SKU配货完成，就可以进行操作对应配好货SKU的订单发货。",
  Enable_this_function_and_single_product_orders_can_be_obtained_in_multi_product_allocation:
    "开启此功能，多品配货中将可以获取到单品订单。",
  Expired_stores: "已过期店铺",
  The_transportation_of_goods_in_the_past_seven_days_has_been_abnormal:
    "近七天交运异常",
  Whether_to_exclude_submission_rules: "是否排除提交规则",
  Not_excluded_submission_rules: "未排除提交规则",
  Excluded_submission_rules: "排除提交规则",
  Whether_to_exclude_automatic_packaging_rules: "是否排除自动包材规则",
  Not_excluded_automatic_packaging_rules: "未排除自动包材规则",
  Excluded_automatic_packaging_rules: "排除自动包材规则",
  Cancel_excluded_submission_rules: "取消排除提交规则",
  Cancel_excluded_automatic_packaging_rules: "取消排除自动包材规则",
  Excluded_all_rules: "排除所有规则",
  Cancel_excluded_all_rules: "取消排除所有规则",
  Refresh_platform_status: "刷新平台状态",
  Only_supports_operations_for_API_orders_with_a_delivery_deadline_within_12_hours_and_push_orders_created_later_than_12_hours:
    "仅支持操作 发货截止时间12小时之内的API订单 和 创建时间12小时之后的推送单",
  shipping_label: "面单",
  shipping_label_exists: "存在面单",
  no_shipping_label_exists: "不存在面单",
  has_label: "有面单",
  no_label: "无面单",
  out_of_stock_orders: "缺货订单",
  No_waybill_number: "无运单号",
  // has_platform_remark: "存在平台备注",
  has_warehouse_remark: "有仓库备注",
  no_warehouse_remark: "无仓库备注",
  is_split_orders: "拆分订单",
  is_presell_orders: "预售订单",
  Unpaired: "未配对",
  Get_the_logistics_track: "获取物流轨迹",
  Latest_updates: "最新更新",
  Logistics_information_is_being_pulled: "物流信息正在拉取中",
  package_information: "包材信息",
  Chinese_product_name: "中文品名",
  English_product_name: "英文品名",
  Obtaining_tracking_number: "运单号获取中",
  No_abnormalities: "无异常",
  Submission_rules_are_not_excluded: "未排除提交规则",
  The_submission_rule_is_excluded: "已排除提交规则",
  Automatic_packaging_material_rules_not_excluded: "未排除自动包材规则",
  The_automatic_packaging_rules_have_been_excluded: "已排除自动包材规则",
  The_number_of_selected_orders_cannot_exceed_100: "选择的订单数量不能超过100",
  Reship: "重新交运",
  Transfer_cancellation_exception: "转入撤销异常",
  Returned_without_generation: "退回未生成",
  The_currently_selected_order_has_no_delivery_exceptions_and_requires_no_action:
    "当前选中订单无交运异常，无需操作",
  If_you_need_to_check_the_inventory_information_of_the_products_please_select_the_option_on_the_right:
    "如果需要查看商品库存信息，请选择右边的按钮",
  Add_Warehouse_Product_Inventory_Details: "添加仓库商品库存明细",
  Issue_Status: "下发状态",

  //创建订单
  editOrder: "编辑订单",
  copyOrder: "复制订单",
  bulk_edit: "批量编辑",
  empty: "清空",
  consigner: "发件人",
  shipper: "发货人",
  Order_deduction: "订单扣费",
  Select_sender: "选择发件人",
  Please_enter_consigner: "请输入发件人",
  Sender_information: "发件人信息",
  consigner_address: "发件人地址",
  Please_enter_consigner_address: "请输入发件人地址",
  consignee_information: "收件人信息",
  recipients: "收件人",
  recipientsList: "收件人列表", //菜单名称修改时注意
  Save_as_a_regular_recipient: "保存为常用收件人",
  Select_recipients: "选择收件人",
  Please_enter_recipients: "请输入收件人",
  Only_one_recipient_can_be_selected: "只能选择一个收件人",
  Please_enter_the_recipient_name_for_query: "请输入收件人名称进行查询",
  postcode: "邮编",
  Please_enter_postcode: "请输入邮编",
  recipients_country: "收件人国家",
  Please_enter_recipients_country: "请输入收件人国家",
  Please_select_recipients_country: "请选择收件人国家",
  Please_select_recipients: "请选择收件人",
  type_of_shipping: "运输方式",
  Please_enter_type_of_shipping: "请输入运输方式",
  Please_select_type_of_shipping: "请选择运输方式",
  Alternate_recipient_address: "备用收件人地址",
  Please_enter_Alternate_recipient_address: "请输入备用收件人地址",
  commodity_information: "商品信息",
  Select_product: "选择产品",
  Save_until_reviewed: "保存至待审核",
  Submit_to_consignment: "提交至待发货",
  Batch_set_package_materials: "批量设置包材",
  Please_add_packing_material: "请添加包材",
  under: "下面的",
  Please_enter_the_tracking_number_information: "请输入单号货拉拉信息",
  Please_select_the_estimated_time_of_arrival: "请选择预计到仓时间",
  Only_a_single_recipient_can_be_selected: "仅允许选择单个收件人",
  Please_enter_a_combination_SKU: "请输入组合SKU",
  The_number_of_empty_combination_SKUs_exists_Check_and_try_again:
    "存在空的组合SKU数量，请检查后重试",
  Please_enter_the_combination_SKU_name: "请输入组合SKU名称",
  Click_to_select_the_row_data_doubleclick_to_select_the_row_data_and_confirm_the_current_selection_data:
    "单击选择该行数据，双击选择该行数据并确认当前选择数据！",
  tagged: "有标",
  No_mark: "无标",
  Import_recipients: "导入收件人",
  //仓储取消订单列表
  agree: "同意",
  reject: "拒绝",
  cancellationOrder: "取消订单",
  reason_for_refusal: "拒绝原因",
  Please_enter_reason_for_refusal: "请选择拒绝原因",
  Application_for_cancellation_of_time: "申请取消时间",
  expiration_time: "过期时间",
  reason_of_cancellation: "取消原因",
  Please_Select_Warehouse_First: "请先选择仓库",
  Please_Select_Packaging_Method_First: "请先选择打包方式",
  Number_Of_Loops: "圈数",
  Please_Select_Packaging_Material: "请选择包材",
  Please_Select_Packaging_Method: "请选择打包方式",
  Please_Enter_Number_Of_Loops: "请输入圈数",
  Order_Packaging: "订单包材",
  Packaging_Method: "打包方式",
  Packaging_Material_Type: "包材类型",
  Whole_Order_Packaging: "整单打包",
  Packaging_By_SKU: "按SKU打包",
  Individual_Product_Packaging: "单独商品打包",
  Volume: "体积",
  Unit_Price: "单价",
  Please_Enter_Quantity: "请输入数量",
  Packaging_Material_Type_And_Packaging_Method_Must_Be_Filled_In_Simultaneously:
    "包材类型与打包方式必须同时填写",

  //头程管理
  first_leg: "头程",
  Head_process_management: "头程管理",
  FirstLegOrderManagement: "头程订单管理",
  firstLegOrderList: "头程订单列表", //菜单名称修改时注意
  firstBillingList: "头程账单列表", //菜单名称修改时注意
  First_billing_list: "头程账单列表",
  FirstLegOrderStatus: "头程单状态",
  FirstLegOrderNumber: "头程单号",
  Headway_tracking_number_Order_number_Grabway_information:
    "头程单号/单号/货拉拉信息",
  First_order_stage: "头程订单阶段",
  Please_enter_FirstLegOrderNumber: "请输入头程单号",
  warehouse_entry_number: "入库单号",
  Please_enter_warehouse_entry_number: "请输入入库单号",
  createoriginReceivingInboundOrder: "创建头程入库订单", //菜单名称修改时注意
  editOriginReceivingInboundOrder: "编辑头程入库订单", //菜单名称修改时注意
  editHeaderList: "编辑头程单", //菜单名称修改时注意
  firstLegOrderId: "头程ID",
  draft: "草稿",
  audited: "已审核",
  abnormal: "异常",
  Self_delivery_warehouse: "自送到仓",
  The_customer_sends_it_to_the_transit_warehouse: "客户自行送至中转仓库",
  Door_to_door_collection: "上门揽收",
  Transfer_warehouse_contact_logistics_to_customer_designated_address_collection:
    "中转仓联系物流到客户指定地址揽收",
  Warehouse_entry_stage: "入库单阶段",
  Warehouse_entry_description: "入库单描述",
  Batch_number_issued_by_three_warehouses: "三方仓下发批次号",
  Three_party_warehouse_PO_number: "三方仓PO单号",
  Storage_single_status: "入库单状态",
  destination: "目的地",
  Other_destinations: "其他目的地",
  Other_address: "其他地址",
  Other_address_contacts: "其他地址联系人",
  Other_address_Contact_number: "其他地址联系人号码",
  Estimated_time_of_arrival: "预计到仓时间",
  Channel_type: "渠道类型",
  Please_select_a_destination: "请选择目的地",
  Please_select_Channel_type: "请选择渠道类型",
  Self_delivered: "自送",
  Take_in: "揽收",
  total_quantity: "总数量",
  odd: "单号",
  push: "推送",
  Do_not_push: "非推送",
  Edit_cabinet_number: "编辑柜号",
  Cargo_pull_information: "货拉拉信息",
  odd_Cargo_pull_information: "单号/货拉拉信息",
  First_billing_stage: "头程账单阶段",
  First_pass_single_stage: "头程单阶段",
  Delivery_to_transit_warehouse: "运送到中转仓方式",
  Reserved_gross_weight: "预约总重量",
  Total_number_of_reservations: "预约总方数",
  Total_number_of_quantity: "预约总数量",
  Total_number_of_packages_arrived: "实际总件数",
  Actual_gross_weight: "实际总重量",
  Actual_total_number_of_squares: "实际总方数",
  Total_number_of_appointments: "预约总件数",
  Total_number_of_boxes_booked: "预约总箱数",
  Cost_per_cubic_meter_KG: "每立方/KG费用",
  expense_per_cubic_meter_KG: "每立方/KG成本",
  Total_number_of_billed_squares: "计费总方数",
  Gross_chargeable_weight: "计费总重量",
  Additional_charge_per_cubic_meter_KG: "每立方/KG附加费用",
  Surcharge_cost_per_cubic_meter_KG: "每立方/KG附加费成本",
  container_number: "柜号",
  Please_enter_container_number: "请输入柜号",
  Please_select_a_stuffing_time: "请输入装柜时间",
  Customer_remarks: "客户备注",
  Customer_service_remarks: "客服备注",
  Financial_remarks: "财务备注",
  Abnormal_remarks: "异常备注",
  please_enter_Abnormal_remarks: "请输入异常备注",
  receiving_time: "收货时间",
  consignee: "收货人",
  Delivery_time: "中转收货时间",
  Estimated_time_to_transit_warehouse: "预计到中转仓时间",
  Destination_arrival_time: "目的地到货时间",
  submission_time: "提交时间",
  Create_a_Customer_ID: "创建客户ID",
  The_operation_failed_because_an_empty_box_exists_Please_modify_the_box_and_try_again:
    "操作失败，存在空的箱，请修改后重试!",
  The_operation_failed_because_there_is_an_empty_amount_of_incoming_storage_Please_modify_it_and_try_again:
    "操作失败，存在空的入库数量，请修改后重试!",
  viewOriginReceivingInboundOrder: "查看头程入库订单", //菜单名称修改时注意
  firstReceiptGoods: "头程收货", //菜单名称修改时注意
  goods_receiving_information: "收货信息",
  consignment_sheet: "收货清单",
  firstBillingDetails: "头程账单明细",
  billing_details: "账单明细",
  billingDetails: "账单明细", //菜单名称修改时注意
  Inventory_SKU_List: "库存SKU列表",
  inventorySKUIist: "库存SKU列表", //菜单名称修改时注意
  First_order_number: "头程订单号",
  Entry_number: "入库单单号",
  Financial_verification_time: "财务核实时间",
  Verify_collection_time: "核实收款时间",
  Total_freight: "总运费金额",
  freight_amount: "运费金额",
  Total_freight_cost: "总运费成本",
  gross_profit: "总利润",
  Gross_surcharge: "总附加费",
  Basic_query: "基本查询",
  Logistics_inquiry: "物流查询",
  logisticsInquiry: "物流查询", //菜单名称修改时注意
  Logistics_batch: "物流批次",
  Number_of_scans: "扫描数量",
  Successful_quantity: "成功数量",
  Number_of_failures: "失败数量",
  Remark_query: "备注查询",
  Time_query: "时间查询",
  Amount_inquiry: "金额查询",
  settlement_date: "结算时间",
  Statement_number: "结算单号",
  Supplier_settlement: "供应商结算",
  viewFirstBillingDetails: "查看头程账单明细",
  stuffing_time: "装柜时间",
  Changing_Customer_ID: "修改客户ID",
  Submit_initial_billing: "提交头程账单",
  Return_the_initial_bill: "退回头程账单",
  freight_inquiry: "货物查询",
  Starting_weight: "开始重量",
  Initial_number: "开始方数",
  End_square: "结束方数",
  Starting_number_of_packages: "开始件数",
  End_number_of_packages: "结束件数",
  Initial_quantity: "开始数量",
  End_quantity: "结束数量",
  Actual_quantity_arrived: "实际到货数量",
  Reservation_quantity: "预约数量",
  The_number_of_received_boxes_is_inconsistent_with_the_number_of_reserved_boxes_whether_to_continue_to_submit:
    "收货箱数与预约箱数不一致，是否继续提交",
  First_leg_deduction_fee: "头程扣费",
  Advance_payment: "头程付款",
  Transfer_warehouse_to_collect: "中转仓揽收",
  Shipping_to_overseas_warehouse: "运送至海外仓",
  Overseas_warehouse_delivery: "海外仓派送",
  There_are_mandatory_fields_in_the_received_information:
    "发货信息存在未填必填项",
  There_are_mandatory_fields_in_the_channel_information:
    "运输信息存在未填必填项",
  There_are_no_required_fields_in_the_delivery_information:
    "到仓信息存在未填必填项",
  Please_select_a_delivery_type: "请选择派送类型",
  warehousing: "入仓",
  pick_up_in_a_store: "自提",
  delivery: "派送",
  delivery_address: "派送地址",
  Store_goods_directly_in_overseas_warehouses: "直接将货物存放至海外仓内",
  The_customer_will_receive_the_goods_from_the_overseas_warehouse_by_himself:
    "客户自行到海外仓进行收货",
  By_overseas_warehouse_contact_logistics_delivery_to_the_customer_designated_location:
    "由海外仓联系物流派送至客户指定地点",
  Upload_credentials: "上传凭证",
  credentials: "凭证",
  Please_select_the_same_channel_type: "请选择相同的渠道类型",
  replacement_expense: "重置费用",
  Set_the_replacement_charge_according_to_the_head_charge:
    "按头程费用设置重置费用",
  Reset_the_current_order_cost_by_the_actual_number_of_square_feet:
    "按实际方数重置当前订单费用",
  Reset_the_current_order_charge_according_to_the_actual_order:
    " 按照订单实际方式重置当前订单费用",
  Order_different_goods_attributes_warehouse_transit_warehouse_billing_method_currency_customer_will_use_the_current_cost_Settings_to_calculate_the_cost:
    "订单不同货物属性，仓库 ，中转仓库，计费方式，币种，客户，都将使用当前费用设置计算费用。",
  Freight_cost_surcharge_cost_default_value_is_set_for_the_current_order_cost_corresponding_to_the_maximum_amount_cubic_KG:
    "运费成本，附加费成本，默认值为当前订单费用设置对应最大金额(立方/KG)。 ",
  Freight_cubic_meter_KG: "运费(立方/KG)",
  Additional_charge_cubic_meter_KG: "附加费(立方/KG)",
  freight_cost_cubic_meter_KG: "运费成本(立方/KG)",
  Surcharge_cost_cubic_meter_KG: "附加费成本(立方/KG)",
  The_content_is_not_filled_in: "存在未填写的内容",
  Please_scan_the_head_track_number: "请扫描头程单号",
  Please_scan_a_valid_header_tracking_number: "请扫描有效的头程单号",
  Attributes_of_goods_received: "收货货物属性",
  Commodity_property: "商品货物属性",
  Import_order: "导入订单",
  Click_Upload: "点击上传",
  Click_here_to_download_the_template: "点击此处下载模板",
  Download_template: "下载模板",
  DeliveryTime: "运输时间",
  Start_time_of_inspection: "开始质检时间",
  End_time_of_inspection: "结束质检时间",
  Shelf_start_time: "开始上架时间",
  End_shelf_time: "结束上架时间",
  Billing_information: "账单信息",
  evidence_of_payment: "付款凭证",
  Be_generating: "正在生成",
  Entering_a_custom_size_will_override_the_selected_print_size:
    "输入自定义尺寸将会覆盖选择的打印尺寸",
  import_first_receipt_goods: "导入头程收货",
  View_the_inbound_and_outbound_flows: "查看出入库流水",
  tracking_number: "物流单号",
  edit_tracking_number: "编辑物流单号",
  transit_time: "承运时间",
  loading_time: "装载时间",
  preset_Exception_Remark: "预设异常备注",
  Batch_Modify_Product_Billing_Attributes: "批量修改商品计费属性",
  Please_Select_Product_Billing_Attributes: "请选择商品计费属性",
  Product_Billing_Attributes: "商品计费属性",
  loading_method: "装柜方式",
  Packing_dimensions: "装柜尺寸",

  //入库管理
  stockManagement: "入库管理",
  Warehouse_entry_list: "入库单列表",
  warehouseEntryList: "入库单列表", //菜单名称修改时注意
  warehouseReceiptList: "入库单收货列表", //菜单名称修改时注意
  over_time: "超时",
  Hit_shelves_on_time: "及时上架",
  Number_of_SKUs: "SKU数量",
  SKU_total_quantity: "SKU总数量",
  qualified_quantity: "合格数量",
  Quantity_of_reserved_storage: "预约入库数量",
  Number_of_reserved_storage_parties: "预约入库方数",
  time_efficiency: "时效",
  On_shelf_rate: "上架及时率",
  Whether_it_is_forced_into_transit: "是否强制到运输中",
  Store_entry_details: "入库单详情",
  Damaged_quantity: "破损数量",
  Miss_delivery: "漏发",
  Miss_delivery_quantity: "少发数量",
  wrongly_send: "错发",
  wrongly_send_quantity: "错发数量",
  Warehousing_to_receive_goods: "入库收货",
  warehousingReceiveGoods: "入库收货", //菜单名称修改时注意
  inventoryEntryListChecked: "入库单待质检列表", //菜单名称修改时注意
  inventoryEntryList: "入库单待上架列表", //菜单名称修改时注意
  Inbound_inspection: "入库质检",
  inboundInspection: "入库质检", //菜单名称修改时注意
  Quality_inspection_quantity: "质检数量",
  quality_testing: "质检",
  Batch_quality_inspection: "批量质检",
  Obtaining_quality_Inspection_Task: "获取质检任务",
  Generate_a_quality_check_task: "指派质检任务",
  Setting_priority_inspection: "设置优先质检",
  The_inspection_quantity_cannot_be_empty: "质检数量不能为空",
  Disabled_Excess_Check_quantity_cannot_be_greater_than_the_scheduled_check_quantity:
    "未开启超额质检时质检数量不能大于预约数量",
  Abnormal_quality_inspection_quantity: "质检数量异常",
  enter_the_qualified_quantity: "请输入合格数量",
  enter_the_breakage_quantity: "请输入破损数量",
  enter_the_lack_send_quantity: "请输入漏发数量",
  enter_the_wrongly_send_quantity: "请输入错发数量",
  enter_the_actual_weight: "请输入实际重量",
  enter_the_actual_length: "请输入实际长度",
  enter_the_actual_width: "请输入实际宽度",
  enter_the_actual_height: "请输入实际高度",
  length_CM: "长度(CM)",
  width_CM: "宽度(CM)",
  height_CM: "高度(CM)",
  widht_MM: "宽度(MM)",
  height_MM: "高度(MM)",
  There_may_be_print_incompatibilities_when_using_custom_printing:
    "使用自定义打印时可能会存在打印内容不兼容",
  This_parameter_is_valid_only_when_the_width_and_height_are_greater_than_0:
    "只有当填写尺寸宽度与高度大于0时生效",
  Create_mis_sent_SKUs: "创建错发sku",
  The_number_of_missent_SKUs_cannot_be_0: "错发sku数量不能为0",
  Only_a_single_item_can_be_selected: "仅允许选择单件商品",
  Number_of_SKUs_sent_incorrectly: "错发SKU数量",
  The_inspection_of_the_sku_has_been_completed_Scan_other_SKUs:
    "该sku已经完成质检请扫描其他sku",
  The_inspection_Label_quantity_cannot_be_empty: "请填写贴标数量",
  The_inspection_Label_quantity_cannot_be_greater_than_the_qualified_quantity:
    "质检标签数量不能大于合格数量",
  Please_scan_the_receipt_number: "请扫描入库单号",
  Quality_inspector: "质检人",
  Quality_inspection_information: "质检信息",
  Product_real_information: "产品真实信息",
  printBoxLabel: "打印箱标",
  Print_head_entry_slip: "打印头程入库单",
  Print_shipping_mark_and_case_label: "打印唛头箱标",
  Print_storage_box_label: "打印入库箱标",
  Quantity_labeled: "已贴标数量",
  Quantity_inspected: "已质检数量",
  Printing_product_bar_code: "打印商品条码",
  unpackingInspection: "拆箱质检",
  fastQualityInspectionAndShelf: "快速质检上架",
  qualityInspectionTaskList: "质检任务列表",
  shelvesTaskList: "上架任务列表",
  Ordinary_quality_inspection: "普通质检",
  Rapid_quality_inspection: "快速质检",
  Please_enter_SKU_or_product_barcode: "请输入SKU/商品条码",
  batch_input: "一键录入",
  After_marking_as_abnormal_the_original_state_cannot_be_restored_Once_activated_it_will_enter_the_final_receiving_process_clearing_all_receiving_and_quality_inspection_information_Are_you_sure_you_want_to_adjust_it_to_the_abnormal_stage:
    "标记异常后无法恢复原来的状态，激活后会进入尾程收货中，清除掉所有的收货与质检信息，确认是否要调整至异常阶段",
  Abnormal_Remarks: "异常备注",
  The_calculation_formula_for_the_on_shelf_timeliness_rate_is:
    "上架及时率的计算公式为",
  When_not_yet_completed_and_put_on_the_shelf: "未完成上架时",
  The_time_effect_formula_is: "时效公式为",
  Receiving_date: "收货日期",
  Current_time: "当前时间",
  countdown: "进行倒计时",
  If_shelving_time_exceeds: "如果上架时间超过",
  It_shows_overtime: "则显示超时",
  If_not: "如果没有",
  It_shows_normal: "则显示正常",
  Receiving: "收货",
  Please_enter_remarks: "请输入备注",

  //创建头程入库订单
  Please_enter_the_number_of_boxes: "请输入箱数",
  Order_types: "订单类型",
  entering_the_warehouse: "入库",
  FirstLegOrder: "头程单",
  InventoryOrder: "入库单",
  FirstLegOrder_AND_InventoryOrder: "头程单+入库单",
  InventoryOrderType: "入库单类型",
  InventoryOrderID: "入库单ID",
  ThirdPartyInventoryOrder: "三方仓入库单",
  Receive_information: "揽收信息",
  Receiving_address: "揽收地址",
  transport_information: "运输信息",
  Arrival_information: "到仓信息",
  delivery_type: "交货方式",
  Push_order: "推送订单",
  Push_order_Type: "推送订单状态",
  Please_select_delivery_type: "请选择交货方式",
  Please_select_Order_types: "请选择订单类型",
  Please_select_a_task_type: "请选择任务类型",
  detailed_address: "详细地址",
  Please_enter_detailed_address: "请输入详细地址",
  Please_enter_phone: "请输入联系电话",
  Select_a_contact: "选择联系人",
  phone: "联系电话",
  warehouse_address: "仓库地址",
  Warehouse_information: "仓库信息",
  freight_information: "货运信息",
  Please_enter_mode_of_transportation: "请输入运输方式",
  Please_enter_warehouse_address: "请输入仓库地址",
  Please_select_Estimated_time_to_transit_warehouse: "请选择预计到中转仓时间",
  Please_select_an_estimated_time_to_warehouse: "请选择预计到仓库时间",
  Shipping_to_transit_warehouse_method: "运送到中转仓方式",
  Pure_warehouse_receipt_does_not_support_door_to_door_collection:
    "纯入库单不支持上门揽收",
  General_container_number: "总箱号",
  cargo_list: "货物清单",
  cargoInfo: "货物信息",
  personalized_setting: "个性化设置",
  Navigation_bar_style: "导航栏样式",
  window: "窗口",
  windowAddress: "窗口地址",
  printContent: "打印内容",
  printingQuantity: "打印数量",
  isShowCnName: "是否显示中文名称",
  isShowMadeInChina: "是否显示Made in China",
  isShowTime: "是否显示时间",
  The_cargo_list_is_empty: "货物清单为空",
  add_cargo_list: "添加货物清单",
  batch_add_cargo_list: "批量添加货物清单",
  total_value: "总价值",
  outer_box_length: "外箱长度",
  Please_enter_outer_box_length: "请输入外箱长度",
  outer_box_width: "外箱宽度",
  Please_enter_outer_box_width: "请输入外箱宽度",
  outer_box_height: "外箱高度",
  Please_enter_outer_box_height: "请输入外箱高度",
  Receiving_container_length: "收货外箱长度",
  Receiving_container_width: "收货外箱宽度",
  Receiving_container_height: "收货外箱高度",
  Received_weight: "收货重量",
  carton_size: "外箱尺寸",
  Please_select_whether_there_is_a_label: "请选择是否有标",
  Please_enter_the_customer_name: "请输入客户名称",
  Please_enter_the_customer_id: "请输入客户ID",
  box: "箱",
  boxNumber: "箱号",
  product_details: "商品明细",
  add_product_details: "添加商品明细",
  remove: "移除",
  product_image: "产品图片",
  Eng_Cn_Name: "中文品名",
  Please_enter_Eng_Cn_Name: "请输入中文品名",
  Eng_En_Name: "英文品名",
  Please_enter_Eng_En_Name: "请输入英文品名",
  unit_price: "单价",
  Please_enter_unit_price: "请输入单价",
  Is_there_a_mark: "是否有标",
  goodsCode: "商品条码",
  model: "型号",
  Please_enter_model: "请输入型号",
  material: "材质",
  stage: "阶段",
  product_code: "产品编码",
  Please_enter_material: "请输入材质",
  customs_code: "海关编码",
  Please_enter_customs_code: "请输入海关编码",
  brand: "品牌",
  Please_enter_brand: "请输入品牌",
  List_of_goods_not_selected_for_addition: "未选择添加的货物清单",
  There_is_an_empty_container_number_Please_fill_in_the_container_number_and_try_again:
    "存在空的箱号，请填写箱号后在重试!",
  Property_of_goods: "货物属性",
  Please_select_goods_attributes: "请选择货物属性",
  CollectInfo: "揽收信息",
  Repeated_SKUs_appear: "出现重复SKU",
  The_quantity_of_goods_cannot_exceed_the_operable_quantity:
    "商品数量不能超过可操作数量",
  Save_to_draft: "保存至草稿",
  batch_processing: "批量处理",
  Quantity_in_storage: "入库数量",
  Dimensional_synchronization: "尺寸同步",
  The_batch_list_is_not_selected: "未选择批处理的货物清单",
  Total_storage_quantity: "总入库数量",
  Gross_cargo_weight: "货物总重量",
  Shipping_Information: "派送信息",
  Delivery_type: "派送类型",
  box_quantity: "箱数",
  Size_of_the_outer_box_received: "收货外箱尺寸",
  not_receive_the_goods: "未收货",
  received: "已收货",
  Take_pictures_of_receiving_goods: "收货图片",
  Receive_goods_in_one_box: "单箱收货",
  Double_receipt: "重复收货",
  Write_back_time: "回写时间",
  Write_back_result: "回写结果",
  Single_box_Only_one_box_can_be_selected: "单箱收货只允许选择单箱",
  The_receiving_list_has_empty_value_and_cannot_be_saved:
    "收货清单存在空值,保存失败",
  No_box_was_selected_to_save_the_receipt: "未选择任何保存收货的箱",
  Duplicate_receipt_is_detected_whether_to_duplicate_receipt:
    "检测到有重复收货，是否重复收货?",
  Whether_excess_inspection: "是否超额质检",
  Priority_inspection: "是否优先质检",
  Only_a_single_entry_ticket_can_be_selected: "仅允许选择单个入库单",
  The_box_number_already_exists: "箱号有误，请重新输入",
  Please_enter_the_box_number: "请输入箱号",
  The_inspection_of_all_the_current_container_numbers_has_been_completed:
    "当前箱号已全部质检完成",
  There_is_no_quality_inspection_data_for_the_current_container_number:
    "当前箱号暂无可质检数据，请重新扫描！",
  The_SKU_does_not_exist_in_the_current_container_number: "当前箱号不存在该SKU",
  inspected: "已质检",
  Not_inspected: "未质检",
  Successful_receipt: "收货成功",
  Submit_and_print: "提交并打印",
  Print_head_list: "打印头程单",
  Header_list: "头程清单",
  printHeaderList: "打印头程清单", //菜单名称修改时注意
  printSubMitHeaderList: "打印提交头程清单", //菜单名称修改时注意
  First_shipping_mark: "头程唛头",
  printFirsShippingMark: "打印头程唛头", //菜单名称修改时注意
  printSubMitFirsShippingMark: "打印提交头程唛头", //菜单名称修改时注意
  First_single_box_label: "头程单箱唛",
  Warehouse_single_box_label: "入库单箱标",
  printFirstSingleBoxLabelAndWarehouseSingleBoxLabel:
    "打印头程单箱唛+入库单箱标", //菜单名称修改时注意
  printSubMitFirstSingleBoxLabelAndWarehouseSingleBoxLabel:
    "打印提交头程单箱唛+入库单箱标",
  Select_individual_order: "请选择单个订单",
  total_number_packages: "总件数",
  total_weight_KG: "总重量(KG)",
  Gross_cube_CBM: "总立方(CBM)",
  Gross_cube: "总立方",
  Export_data_priority: "导出数据优先级",
  Specified_exported_data: "指定导出数据",
  List_selection_data: "列表选择数据",
  List_filtering_data: "列表筛选数据",
  distributionManagement: "配货管理", //菜单名称修改时注意
  printInventoryEntryList: "打印入库单清单", //菜单名称修改时注意
  The_form_verification_failed_Please_check_and_try_again:
    "表单校验失败，请检查后重试",
  The_product_bar_code_does_not_exist_in_the_current_task_list_or_has_been_put_on_the_shelf:
    "当前任务单不存在此商品条码或已上架完成,请重新扫描！",
  Inventory_entry_list: "入库单清单",
  Print_the_inventory_entry_list: "打印入库单清单",
  One_click_out_and_print_the_pick_list: "一键出库并打印拣货单",
  One_click_out_the_warehouse_and_print_the_invoice: "一键出库并打印发货单",
  Only_confirmation_time_is_supported: "仅支持确认时间",
  Please_select_confirmation_time: "请选择确认时间",
  Only_save_the_hour_minute_and_second_of_the_confirmation_time:
    "仅保存确认时间的时分秒，快捷查询时默认为今日日期",
  The_current_operation_cannot_be_undone_Do_you_want_to_continue:
    "当前操作无法撤销是否继续",
  Quantities_that_have_not_passed_quality_inspection_will_be_considered_entirely_unqualified:
    "未经过质检的数量将视为全部不合格",
  The_quantity_that_has_not_been_put_on_the_shelves_will_be_regarded_as_all_unqualified:
    "未经过上架的数量将视为全部不合格",
  Edit_warehouse_remark: "修改仓库备注",
  Submit_to_listed: "提交至已上架",
  Has_the_quality_inspection_been_completed: "是否已完成质检",

  //订单详情
  Forecast_error_message: "预报错信息",
  Take_pictures_out_of_the_warehouse: "出库拍照图",
  Online_product_details: "线上商品明细",
  Product_preview: "商品预览图",
  declared_value: "申报价值",
  Weight_KG_piece: "重量(KG/个)",
  Weight_KG_box: "重量(KG/箱)",
  Declared_value_USD_piece: "申报价值(USD/个)",
  Please_enter_Declared_value_USD_piece: "请输入申报价值(USD/个)",
  Please_enter_Weight_KG_piece: "请输入重量(KG/个)",

  //商品管理
  CommodityManagement: "商品管理",
  commodity: "商品",
  commodityName: "商品名称",
  Online_product_name: "在线商品名称",
  SKUManagement: "SKU管理",
  inventorySKUManagement: "库存SKU管理",
  inventorySKU: "库存SKU",
  EditInventorySKU: "库存SKU",
  inventorySKUName: "库存SKU名称",
  inventorySKUList: "库存SKU列表", //菜单名称修改时注意
  inventorySKUImage: "库存SKU图片",
  Click_to_upload_stock_SKU_picture: "点击上传库存SKU图片",
  Click_to_upload_combined_SKU_images: "点击上传组合SKU图片",
  Import_goods: "导入商品",
  Batch_create_goods: "批量创建商品",
  Edit_the_combined_SKU: "编辑组合SKU",
  bar_code: "条码",
  Commodity_billing_attribute: "商品计费属性",
  Editable_or_not: "是否可编辑",
  Combination_quantity: "组合数量",
  Add_stock_SKUs: "添加库存SKU",
  Please_enter_inventorySKU: "请输入库存SKU",
  Please_enter_bar_code: "请输入条码",
  product_Cn_name: "产品中文名称",
  Please_enter_product_Cn_name: "请输入产品中文名称",
  product_En_name: "产品英文名称",
  Please_enter_product_En_name: "请输入产品英文名称",
  initiate_mode: "启用状态",
  Please_select_initiate_mode: "请选择启用状态",
  inventory_status: "库存状态",
  Please_select_inventory_status: "请选择库存状态",
  Alarm_threshold_status: "预警阈值状态",
  Please_select_Alarm_threshold_status: "请选择预警阈值状态",
  Last_two_weeks: "最近两周",
  Last_two_month: "最近两月",
  Last_three_month: "最近三月",
  actual_weight_KG: "实际重量(KG)",
  Actual_Trilateral_sum_CM: "实际三边和(CM)",
  Actual_size_CM: "实际尺寸(CM)",
  physical_length: "实际长度",
  physical_width: "实际宽度",
  physical_height: "实际高度",
  size_CM: "尺寸(CM)",
  Actual_size: "实际尺寸",
  print_size: "打印尺寸",
  Custom_size: "自定义尺寸",
  Custom_size_print: "自定义尺寸打印",
  Please_enter_actual_weight: "请输入实际重量",
  Please_enter_actual_Trilateral_sum_CM: "请输入实际三边和(CM)",
  Please_enter_actual_weight_KG: "请输入实际重量(KG)",
  Please_enter_actual_size: "请输入实际尺寸",
  inventory_quantity: "库存总量",
  Total_occupied_inventory: "占用库存总量",
  Total_cubic_number_of_inventory: "库存总立方数",
  Total_unshipped_quantity: "未发货库存总量",
  Total_available_inventory: "可用库存总量",
  Available_Stock: "可用库存",
  Total_number_of_cubes_in_transit: "在途总立方数",
  Total_number_in_transit: "在途库存总量",
  Total_unavailable_inventory_quantity: "不可用库存总量",
  In_transit_inventory: "在途库存",
  Sales_Volume_7_14_30_60_90: "销量(7/14/30)",
  Sales_Volume_60_90: "销量(60/90)",
  Sales_Volume_45_60_90: "销量(45/60/90)",
  Forecast_30_day_average_daily_sales: "预测30天日均销量",
  Number_of_warnings: "预警数量",
  Alert_stock: "预警库存",
  Whether_to_calculate_alert_inventory_automatically: "是否自动计算预警库存",
  Please_select_Whether_to_calculate_alert_inventory_automatically:
    "请选择是否自动计算预警库存",
  Automatic_calculation_mode: "自动计算方式",
  purchase_price: "采购价",
  Please_select_SKU: "请选择SKU",
  portfolioSKUManagement: "组合SKU管理",
  portfolioSKUList: "组合SKU列表", //菜单名称修改时注意
  product_barcode: "商品条码",
  Please_enter_the_product_barcode: "请输入商品条码",
  Select_all_boxes: "选择所有箱",
  Reset_option: "重置选择",
  Modify_the_print_quantity_of_the_selected_item: "修改所选商品打印数量",
  Please_enter_the_product_barcode_for_screening: "请输入商品条码进行筛选",
  Inventory_warning_does_not_allow_duplicate_warehouses:
    "库存预警不允许出现重复仓库",
  isReceiveWarningNotice: "是否接收预警通知",
  Last_release_date: "最近上架日期",
  Add_early_warning: "添加预警库存",
  Days_of_existing_warning: "已预警天数",
  Please_enter_the_number_of_alerts: "请输入预警库存",
  Please_enter_the_expected_number_of_days: "请输入预警天数",
  Please_select_automatic_calculation_mode: "请选择自动计算方式",
  Please_select_whether_to_receive_an_alert_notification:
    "请选择是否接收预警通知",
  Average_daily_sales_for_the_last_7_days: "近7天日均销量",
  Average_daily_sales_for_the_last_15_days: "近15天日均销量",
  Average_daily_sales_for_the_last_30_days: "近30天的日均销量",
  Average_weekly_sales: "周均销量",
  Sales_time_meets_12_months_week: "销售时间满足12(月/周)",
  Total_sales_in_the_last_12_weeks_month_divided_by_12: "近12(周/月)总销量÷12",
  Average_monthly_sales: "月均销量",
  The_data_was_updated_in_the_early_hours_of_the_next_day:
    "更新数据时间为第二天的凌晨",
  The_sales_time_does_not_meet_12_months_week: "销售时间不满足12(月/周)",
  Total_sales_in_months_weeks_sold_divided_by_the_number_of_months_weeks_sold:
    "已销售(月/周)总销量÷已销售(月/周)数",
  Set_inventory_warning_in_batches: "批量设置库存预警",
  combination_SKU_Chinese_name: "组合SKU中文名称",
  combination_SKU_English_name: "组合SKU英名称",
  Add_the_combined_SKU: "添加组合SKU",
  Combine_SKU_images: "组合SKU图片",
  combined_SKU: "组合SKU",
  Portfolio_inventory: "组合库存",
  goodsImage: "商品图片",
  viewPortfolioSKU: "查看组合SKU",
  Historical_operation_record: "历史操作记录",
  Edit_inventory_SKU_list: "编辑库存SKU列表",
  editInventorySkuList: "编辑库存SKU列表", //菜单名称修改时注意
  viewInventorySkuList: "查看库存SKU列表", //菜单名称修改时注意
  createInventorySkuList: "创建库存SKU列表", //菜单名称修改时注意
  Only_common_products_can_be_selected: "仅有普通产品才可多选",
  inventory_management: "库存管理",
  inventoryManagement: "库存管理",
  Unavailable_inventory: "有无不可用库存",
  inventoryList: "库存列表", //菜单名称修改时注意
  product_material: "产品材质",
  Please_select_product_material: "请选择产品材质",
  Product_bar_code: "产品条码",
  Reference_number: "参考号",
  update_specified_goods: "更新指定商品",
  pull_specified_goods: "拉取指定商品",
  please_select_data: "请选择数据",
  Select_a_single_SKU_for_operation: "请选择单个SKU进行操作",
  update_successfully: "更新成功",
  pull_successfully: "拉取成功",
  please_enter_link_id: "请输入链接ID",
  subordinate_Account: "子账号",
  Authorized_subaccount: "授权子账号",
  Assign_subaccount: "分配子账号",
  Please_select_the_subaccount_that_you_want_to_authorize:
    "请选择需要授权的子账号",
  Please_select_a_sub_account: "请选择子账号",
  modifyProductInformationList: "修改商品信息流水列表",
  batchCreateCombinedsku: "批量创建组合SKU",
  batch_create_combined_sku: "批量创建组合SKU",
  Please_check_the_data_first: "请先勾选数据",
  Import_the_combined_SKU: "导入组合SKU",
  batchCreateSubAccount: "批量创建子账号",
  batch_Create_SubAccounts: "批量创建子账号",
  Import_subAccounts: "导入子账号",
  Import_to_modify_the_product_barcode: "导入修改商品条码",
  modify_the_product_barcode: "修改商品条码",
  Set_the_default_allocation_of_the_first_trip_fee: "设置默认分摊头程费",
  Default_allocation_of_first_trip_fee: "默认分摊头程费",
  Default_first_leg_fee: "默认头程费",
  Default_allocation_of_first_trip_fee_only_used_for_order_profit_report_calculation_statistics:
    "默认分摊头程费只用于订单利润报表计算统计",
  Includes_the_quantity_to_be_reviewed_and_reviewed_received_in_the_transit_warehouse_and_in_transit_and_in_the_last_leg_and_received_in_the_last_leg_and_in_the_quality_inspection_and_inspected_but_not_yet_listed:
    "包含待审核、已审核、中转仓收货、运输中、尾程收货中、尾程已收货、质检中、已质检未上架的数量",
  This_operation_will_permanently_delete_sku: "此操作将永久删除sku",
  Batch_modification_of_purchase_prices: "批量修改采购价",
  Batch_modification_of_default_allocation_of_headhaul_fees:
    "批量修改默认分摊头程费",
  Original_purchase_price: "原采购价",
  New_purchase_price: "新采购价",
  The_original_default_allocation_of_the_origin_leg_cost: "原默认分摊头程费",
  New_default_allocation_of_origin_charges: "新默认分摊头程费",
  Modify_the_purchase_price: "修改采购价",
  Form_modification_of_purchase_price: "表单修改采购价",
  Modify_the_default_allocation_of_origin_charges: "修改默认分摊头程费",
  Modify_the_default_allocation_of_the_initial_transportation_cost_in_the_form:
    "表单修改默认分摊头程费",
  Import_and_modify_the_purchase_price_and_the_default_headway_cost_allocation:
    "导入修改采购价和默认分摊头程费",
  Greater_than_0_001_and_less_than_9999999: "大于0.001小于9999999",
  Unusable_inventory_quantity: "不可用库存数量",

  //创建商品
  createGoods: "创建商品", //菜单名称修改时注意
  product_information: "产品信息",
  Please_enter_product_information: "请输入产品信息",
  product_specification: "产品规格",
  Product_declaration: "产品申报",
  procurement_price: "采购价格",
  Please_enter_cost_price: "请输入成本价格",
  Please_enter_procurement_price: "请输入采购价格",
  volume_cm: "体积(cm³)",
  actual_volume: "实际体积",
  actual_volume_cm: "实际体积(cm³)",
  commercial_specification: "商品规格",
  Please_enter_commercial_specification: "请输入商品规格",
  Product_name_Chinese: "申报品名(中文)",
  Please_enter_Product_name: "请输入申报品名",
  Product_name_English: "申报品名(英文)",
  country_of_origin: "原产地",
  Please_enter_country_of_origin: "请输入原产地",
  Days_of_purchase: "采购天数",
  Please_enter_Days_of_purchase: "请输入采购天数",
  product_attribute: "商品属性",
  Special_commodity_attribute: "特殊商品属性",
  Please_select_product_properties: "请选择产品属性",
  inventory_warning: "库存预警",
  Early_warning_inventory: "预警库存",
  Days_of_warning: "预警天数",
  Please_enter_Early_warning_inventory: "请输入预警库存",
  Please_enter_Days_of_warning: "请输入预警天数",
  Calculating_early_warning_inventory: "计算预警库存方式",
  Automatic_calculation_of_early_warning_inventory: "自动计算预警库存",
  Alert_inventory_is_equal_to_alert_days_multiplied_by_daily_sales:
    "预警库存 = 预警天数 * 单天销量",
  Click_to_upload: "点击上传",
  Only_jpg_or_png_files_with_a_maximum_size_of_2048kb_can_be_uploaded:
    "只能上传jpg或png文件，且不超过2048kb",
  Please_upload_product_pictures: "请上传产品图片",
  Please_enter_dimensions_of_length_width_and_height_greater_than_zero:
    "请输入长宽高尺寸并且大于零",
  The_operation_failed__Please_check_the_content_and_submit_again:
    "操作失败，请检查填写内容后重新提交",
  editorialGoods: "编辑商品",
  viewGoods: "查看商品",
  Enter_SKU_and_bar_code_separated_by_commas_comma:
    "请输入SKU、条码，用逗号隔开",
  Please_enter_sku: "请输入sku",
  delete_in_batches_sku: "批量删除SKU",
  Select_the_sku_that_you_want_to_delete: "选择需要删除的sku",
  Select_the_SKUs_that_you_want_to_add: "选择需要添加的SKU",
  And_enter_the_number_of_SKUs_you_want_to_add: "并输入需要添加SKU的数量",
  Select_the_SKU_that_you_want_to_modify: "请选择需要修改的SKU",
  Enter_the_number_of_SKUs_that_you_want_to_modify: "并输入需要修改的SKU数量",
  Select_the_SKU_for_which_you_want_to_modify_the_repository:
    "请选择需要修改仓库的SKU",
  And_select_a_new_warehouse: "并选择新的仓库",
  Adding_SKUs_in_bulk: "批量添加SKU",
  Edit_note: "编辑备注",
  select_sku: "选择SKU",
  Type_query: "类型查询",
  Export_goods: "导出商品",
  Export_incoming_and_outgoing_records: "导出出入库记录",
  product_list: "商品列表",
  product_list_sub_warehouse: "商品列表(分仓)",
  serial_Number: "编号",
  Create_distribution_control: "创建配货控制",
  Number_of_generated_tasks: "生成任务数量",
  create_task: "生成任务",
  Delivery_process_2_cannot_use_border_variation: "发货流程2无法使用边配变分",
  If_a_check_order_exists_during_task_generation_the_check_order_task_is_preferentially_generated:
    "生成任务时存在勾选订单则会优先生成勾选订单任务",

  //仓库列表
  warehouse_management: "仓库管理",
  warehouseOperation: "仓库操作",
  warehouse_Number: "仓库编号",
  Please_enter_warehouse_Number: "请输入仓库编号",
  Please_enter_warehouse_partition: "请输入仓库分区",
  goods_shelf: "货架",
  goods_shelf_info: "货架信息",
  Shelf_type: "货架类型",
  Please_enter_Shelf_type: "请输入货架类型",
  Shelf_layer: "货架层",
  Please_enter_Shelf_layer: "请输入货架层",
  Storage_rack: "货架列",
  Please_enter_Storage_rack: "请输入货架列",
  Shelf_size_length_width_and_height: "货架尺寸(长*宽*高)",
  Shelf_cube: "货架立方/m³",
  Please_enter_Shelf_cube: "请输入货架立方",
  Library_location_information: "库位信息",
  Storage_location_type: "库位类型",
  Please_enter_Storage_location_type: "请输入库位类型",
  SKU_storage_type: "SKU存放类型",
  Please_enter_goods_shelf: "请输入货架",
  Please_enter_Residual_storage_capacity: "请输入剩余库容",
  Please_enter_Storage_capacity_in_transit: "请输入在途库容",
  Please_enter_Service_storage_capacity: "请输入使用库容",
  Please_select_the_currency_of_charge: "请选择收费币种",
  Please_select_warehouse_type: "请选择仓库类型",
  Storage_location_SKU: "库位SKU",
  Please_enter_Storage_location_SKU: "请输入库位SKU",
  Initial_storage: "开始库容",
  End_storage: "结束库容",
  Add_partition: "添加分区",
  Edit_partition: "编辑分区",
  partition_number: "分区编号",
  Please_enter_partition: "请输入分区",
  Please_enter_partition_number: "请输入分区编号",
  Please_select_floor: "请选择楼层",
  partition: "分区",
  floor: "楼层",
  Batch_pairing: "批量配对",
  storey: "楼",
  Single_SKU: "单SKU",
  Multiple_SKU: "多SKU",
  Add_warehouse: "添加仓库",
  Edit_warehouse: "编辑仓库",
  Add_storage_location: "添加库位",
  contacts: "联系人",
  Please_enter_contacts: "请输入联系人",
  Warehouse_zip_code: "仓库邮编",
  Please_enter_Warehouse_zip_code: "请输入仓库邮编",
  Toll_currency: "收费币种",
  Please_enter_Toll_currency: "请输入收费币种",
  Warehouse_recipient: "仓库收件人",
  Recipient_phone_number: "收件人电话",
  Warehouse_capacity_m: "仓库库容/m³",
  Service_storage_capacity_m: "使用库容/m³",
  Storage_capacity_in_transit_m: "在途库容/m³",
  Residual_storage_capacity_m: "剩余库容/m³",
  Zoned_storage_m: "分区库容/m³",
  Storage_location_Storage_capacity_m: "库位库容/m³",
  Storage_capacity_SKU: "库容SKU",
  Bind_the_library_location_SKU: "绑定库位SKU",
  Pick_the_warehouse_location: "拣货库位",
  Shelf_coding: "货架编码",
  Please_enter_Shelf_coding: "请输入货架编码",
  Shelf_name: "货架名称",
  Please_enter_Shelf_name: "请输入货架名称",
  Shelf_length: "货架长",
  Please_enter_Shelf_length: "请输入货架长",
  Shelf_weight: "货架宽",
  Please_enter_Shelf_weight: "请输入货架宽",
  Shelf_height: "货架高",
  Please_enter_Shelf_height: "请输入货架高",
  single_face: "单面",
  two_sided: "双面",
  Warehouse_location_number: "库位编号",
  Location_number: "库位号",
  Edit_library_location: "编辑库位",
  Only_one_table_can_be_imported_simultaneously: "只允许同时导入一张表",
  Only_tables_can_be_imported: "只允许导入表",
  Only_select_tables_are_allowed: "仅允许选择表",
  Import_a_single_table_first: "请先进行单表导入",
  Unselected_formula: "未选择公式",
  Selection_result_table: "选择结果表",
  Please_select_table: "请选择表",
  Only_one_table_can_be_selected: "仅允许选择一张表",
  Manually_insert_data: "手动插入数据",
  The_current_table_is: "当前的表为",
  Trigger_name: "触发器名称",
  Please_enter_Trigger_name: "请输入触发器名称",
  libraryLocationList: "库位列表", //菜单名称修改时注意
  Back_libraryLocationList: "返回库位列表",
  have_been_used: "已使用",
  unused: "未使用",
  print_Library_location_number: "打印库位号",
  quantity_in_stock: "库存数量",
  Inventory_occupancy: "库存占用数量",
  Inventory_warning_quantity: "库存预警数量",
  deposit_type: "存放类型",
  The_location_type: "库位类型",
  sectionList: "分区列表",
  shelvesList: "货架列表",
  Batch_delete_shelves: "批量删除货架",
  Modify_the_partition_number: "修改分区编号",
  Modify_the_shelf_number: "修改货架号",
  Modify_the_storage_location_number: "修改库位号",
  Please_enter_the_shelf_number: "请输入货架号",
  Import_modified_partition_codes: "导入修改分区编码",
  Import_and_modify_the_shelf_number: "导入修改货架号",
  Import_and_modify_the_storage_location_numbers: "导入修改库位号",
  Please_select_the_shelves_you_want_to_delete: "请选择要删除的货架",
  Confirm_to_delete_the_shelfs: "确认删除货架",
  goods_shelf_number: "货架号",

  //地区管理
  regional_management: "地区管理",
  countriesList: "国家列表", //菜单名称修改时注意
  Added_country: "添加国家",
  Bulk_add_countries: "批量添加国家",
  Please_select_country: "请选择国家",
  Please_select_Destination_warehouse: "请选择目的仓库",
  Destination_warehouse: "目的仓库",

  //地址管理
  recipientManagement: "收件人管理", //菜单名称修改时注意
  Please_enter_the_recipient_name: "请输入收件人姓名",
  Please_enter_the_recipient_phone_number: "请输入收件人电话",
  Recipient_name: "收件人名称",
  Receiver_Address: "收件人地址",
  Add_recipient: "添加收件人",
  Edit_recipient: "编辑收件人",
  Recipient_email_address: "收件人邮箱",
  Please_select_the_full_region: "请选择完整地区",
  Please_select_a_region: "请选择地区",

  //财务管理
  financialManagement: "财务管理",
  financialReports: "财务报告",
  cost: "费用",
  costmanagement: "费用管理",
  costType: "费用状态",
  costSetting: "费用设置",
  create_setting: "创建设置",
  edit_setting: "编辑设置",
  Client_editing: "客户编辑",
  AmazonBaiyiUS: "亚马逊百易科讯美国",
  amazonBaiyiUS: "亚马逊百易科讯美国", //菜单名称修改时注意
  month: "月份",
  turnover: "营业额",
  The_amount_of_the_platform_should_be_lent: "平台应放款金额",
  The_wrong_amount_should_be_lent: "应放款错误金额",
  have_already_settled: "已结算",
  consolidate_orders: "合并订单",
  refund: "退款",
  rebates: "部分退款",
  Refund_and_compensation: "退款赔付",
  compensate: "赔付",
  Unlent_amount: "未放款金额",
  deleteTable: "删除表",
  Confirm_deletion_table: "确认删除表",
  Recharge_time: "充值时间",
  Please_select_a_Recharge_time: "请选择充值时间",
  Add_top_up: "添加充值",
  exchange_rate: "汇率",
  Amount_actually_paid: "实际支付金额",
  Please_enter_the_Amount_actually_paid: "请输入实际支付金额",
  Currency_of_payment: "支付币种",
  Please_enter_the_Currency_of_payment: "请输入支付币种",
  The_currency_of_the_deposit: "充值币种",
  Please_enter_the_The_currency_of_the_deposit: "请输入充值币种",
  service_charge: "手续费",
  accounting_date: "到账时间",
  Please_select_a_accounting_date: "请选择到账时间",
  note: "备注",
  Top_up_number: "充值号",
  recharge_amount: "充值金额",
  Balance_before_recharge: "充值前余额",
  Balance_after_recharge: "充值后余额",
  The_charge_shall_not_be_greater_than_the_amount_of_the_deposit:
    "手续费不得大于充值金额",
  Recharge_information: "充值信息",
  Please_select_a_billing_time: "请选择结算时间",
  Please_enter_the_statement_number: "请输入结算单号",
  Please_select_a_recharge_type: "请选择充值类型",
  About_to_jump_to_the_recharge_page: "即将跳转充值页面",
  state_of_payment: "支付状态",
  Continue_to_pay: "继续支付",
  during_the_payment: "支付中",
  payment_failure: "支付失败",
  have_expired: "已过期",
  canceled: "已取消",
  Completed_transaction: "已完成交易",
  Uncompleted_transaction: "交易未完成",
  failure_of_transaction: "交易失败",
  Only_a_single_task_can_be_selected: "仅可选择单个任务",
  Please_select_a_basket: "请选择篮子",
  Sheet_address: "面单地址",
  Recommended_storage_location: "推荐库位",
  The_product_is_finished: "该商品已完成",
  initial_workpiece: "首件",
  follow_up_workpiece: "续件",
  aggregate_amount: "总金额",
  Daily_order_volume: "每日单量",
  Total_order_processing_fee: "总订单处理费",
  Average_unit_price_per_order: "每单平均单价",
  Total_number_of_SKUs_for_shipment: "总发货SKU数量",
  Average_unit_price_per_SKU: "每SKU平均单价",
  Demurrage_start_day: "滞留起收天数",
  Transfer_stock_fee: "移仓费用（M³/元）",
  Detention_stock_fee: "滞留仓租费（M³/元）",

  //费用设置
  orderProcessingFeeSet: "订单处理费",
  Additional_cost: "添加费用",
  Additional_Max_cost: "添加最大费用",
  Add_order_processing_fee: "添加订单处理费",
  Additional_charge: "加收费用",
  Rate_number: "收费标准编号",
  type_of_cost: "费用类型",
  Please_select_type_of_cost: "请选择费用类型",
  Please_enter_Additional_charge: "请输入加收费用",
  Please_enter_Rate_number: "请输入收费标准编号",
  Out_of_range_first_SKU_operating_fee: "超范围首SKU操作费",
  Please_enter_Out_of_range_first_SKU_operating_fee: "请输入超范围首SKU操作费",
  Continued_SKU_operating_fee_out_of_range: "超范围续SKU操作费",
  Please_enter_Continued_SKU_operating_fee_out_of_range:
    "请输入超范围续SKU操作费",
  Cost_of_first_packing_material_out_of_range: "超范围首包材费用",
  Please_enter_Cost_of_first_packing_material_out_of_range:
    "请输入超范围首包材费用",
  SKU_packaging_costs_are_exceeded: "超范围续SKU包材费用",
  Please_enter_SKU_packaging_costs_are_exceeded: "请输入超范围续SKU包材费用",
  The_number_of_out_of_range_continuums_is_charged: "超范围续件计费件数",
  Please_enter_The_number_of_out_of_range_continuums_is_charged:
    "请输入超范围续件计费件数",
  The_input_add_fee_has_no_value_Please_check_and_try_again:
    "输入的添加费用存在空值，请检查后重试",
  Please_add_the_charges: "请添加费用",
  The_charge_standard_number_cannot_be_repeated: "收费标准编号不能重复",
  Out_of_range_listing_fees: "超范围上架费",
  Out_of_range_Destruction_delisting_fee: "超范围销毁下架费",
  Out_of_range_Return_listing_fee: "超范围退件上架费",
  Three_sides_are_preferred: "优先三边长",
  Preferred_weight: "优先重量",
  packagingMaterialCost: "包材费", //菜单名称修改时注意
  Package_material_coding: "包材编码",
  Please_enter_Package_material_coding: "请输入包材编码",
  Packing_material_name: "包材名称",
  Please_enter_Packing_material_name: "请输入包材名称",
  Packing_material_length: "包材长度",
  Please_enter_Package_material_length: "请输入包材长度",
  Packing_material_width: "包材宽度",
  Please_enter_Package_material_width: "请输入包材宽度",
  Packing_material_height: "包材高度",
  Packing_material_Weight: "包材重量",
  Please_enter_Packing_material_height: "请输入包材高度",
  Packing_material_quantity: "包材数量",
  Please_enter_Packing_material_quantity: "请输入包材数量",
  Packing_material_type: "包材类型",
  Please_enter_Packing_material_type: "请输入包材类型",
  add_Packing_material: "添加包材",
  edit_Packing_material: "编辑包材",
  Batch_add_Packing_material: "批量添加包材",
  quantity_of_commodity: "商品数量",
  The_box_number_does_not_exist: "该箱号不存在",
  Packaging_material_picture: "包材图片",
  createCost: "创建费用", //菜单名称修改时注意
  Please_upload_picture_of_package_material: "请上传包材图片",
  expenseDeduction: "费用补扣", //菜单名称修改时注意
  Add_a_premium_deduction: "添加费用补扣",
  Expense_reimbursement_type: "费用补扣类型",
  Please_select_the_type_of_reimbursement: "请选择费用补扣类型",
  Please_select_packing_material: "请选择包材",
  Please_select_a_packaging_method: "请选择打包方式",
  Set_the_packaging_mode_in_batches: "批量设置打包方式",
  Please_enter_barcode_SKU_Chinese_product_name_English_product_name:
    "请输入SKU、商品条码、中文品名、英文品名，点击查询按钮进行查询",
  Please_enter_barcode_SKU: "请输入SKU、商品条码，点击查询按钮进行查询",
  Please_enter_the_order_number_separated_by_line_breaks_or_commas:
    "请输入订单号，换行或逗号隔开",
  Packing_material_billing_type: "包材计费类型",
  Minimum_charge_amount: "最低计费金额",
  Number_of_warnings_must_not_exceed_the_quantity_in_stock:
    "预警数量不得超过库存数量",
  default_packaging_material: "默认包材",
  packingMaterialDetail: "包材详情",
  packing_material_info: "包材信息",
  import_order_processing_fee: "导入订单处理费",
  import_storage_charges: "导入仓租费",
  import_fixed_sku_fees: "导入固定SKU费",
  import_first_pass_cost: "导入头程费",
  setFeesByTemplate: "按模板设置费用",
  The_amount_of_the_deduction: "费用补扣金额",
  viewFixedSKUFee: "查看固定SKU费", //菜单名称修改时注意
  SpecialAprovalNumber: "特批编号",
  Special_Customer_ID: "特批客户ID",
  Addition_special_fees: "创建费用特批",
  Special_approval_for_import_fees: "导入费用特批",
  The_current_approver: "当前审批人",
  Whether_to_be_anonymous_or_not: "是否匿名",
  Work_order_source: "工单来源",
  Notes_should_not_exceed_1000_characters: "备注长度不能超过1000个字符",
  Pending_approval_currently: "当前审批人",
  Currently_awaiting_review: "当前待审核",
  Save_and_generate_multiple_warehouse_fees: "保存并生成多仓费用",
  Cost_of_generating_multiple_warehouses: "生成多仓费用",
  Multiple_warehouses_need_to_be_selected: "需要选择多个仓库",

  //头程费用设置
  firstPassCostSetting: "头程费用设置",
  firstPassCostDrawercabinet: "头程费-散柜", //菜单名称修改时注意
  firstPassCostFCL: "头程费-整柜",
  freight_cost_cube_KG: "运费成本(立方/KG)",
  freight_cost: "运费成本",
  fixed_cost: "成本",
  profit: "利润",
  Please_enter_the_shipping_cost: "请输入运费成本",
  Surcharge_cost_cube_KG: "附加费成本(立方/KG)",
  Surcharge_cost: "附加费成本",
  Please_enter_the_Surcharge_cost: "请输入附加费成本",
  Out_of_range_freight_cube_KG: "超范围运费(立方/KG)",
  Out_of_range_freight: "超范围运费",
  Please_enter_Out_of_range_freight: "请输入超范围运费",
  Overreach_surcharge_cube_KG: "超范围附加费(立方/KG)",
  Overreach_surcharge: "超范围附加费",
  Please_enter_Overreach_surcharge_cube_KG: "请输入超范围附加费",
  Minimum_number_of_charging_parties: "最小计费方数",
  Please_enter_Minimum_number_of_charging_parties: "请输入最小计费方数",
  Start_greater_than: "起始(>)",
  cutoff: "截止(<=)",
  additional_charge_cube_KG: "附加费(立方/KG)",
  additional_charge: "附加费",
  Minimum_chargeable_weight: "最小计费重量",
  Please_enter_Minimum_chargeable_weight: "请输入最小计费重量",
  The_added_fee_is_empty: "添加的费用为空",
  The_added_cost_has_a_null_value_The_creation_failed_Please_modify_the_cost_and_try_again:
    "添加的费用存在空值，创建失败，请修改后重试",
  The_start_of_the_added_fee_is_not_equal_to_the_end_Please_modify_it_and_try_again:
    "添加的费用起始不等于截止，请修改后重试",
  Volume_weight_calculation_method_cubic_divide_volume_weight_is_worth_the_result_compare_the_weight_which_big_which:
    "体积重计算方式：立方/体积重值得出结果，比较重量，哪个大取哪个",
  Length_cm_X_width_cm_X_height_cm_volume_weight_value:
    "立方：（长度(cm)*宽度(cm)*高度(cm) / 体积重值） / 1000000",
  There_are_no_packing_materials_for_the_warehouse: "暂无该仓库的包材",
  Printing_control: "正在打印第",
  Several_tasks: "个任务",
  code: "代码",
  await: "等待",
  second: "秒",
  request_timeout: "请求超时",
  Stop_query: "停止查询",
  Edit_the_entry_slip: "编辑入库单",
  Deduction_amount: "补扣金额",
  Deduction_personnel: "补扣人",
  Deduction_time: "补扣时间",

  // 头程费用-整柜,
  portCharges: "港杂费",
  trailerFee: "拖车费",
  loadingFee: "装柜费",
  customsDeclarationFee: "报关费",
  airportHandlingFee: "机场操作费",
  borderCrossingFee: "边境过境费",
  otherHandlingFee: "其他操作费",
  freightCost: "运费成本",
  portChargesCost: "港杂费成本",
  trailerFeeCost: "拖车费成本",
  loadingFeeCost: "装柜费成本",
  customsDeclarationFeeCost: "报关费成本",
  airportHandlingFeeCost: "机场操作费成本",
  borderCrossingFeeCost: "边境过境费成本",
  otherHandlingFeeCost: "其他操作费成本",
  Import_full_container_for_the_initial_shipment: "导入整柜头程费",
  Details_of_the_first_leg_bill_full_container: "头程账单详情（整柜）",
  Details_of_the_first_leg_bill_open_counter: "头程账单详情（散柜）",
  Cost_allocation: "费用配置",
  Main_transportation_costs: "主要运输成本",
  Dock_handling_document_fees_storage_fees_etc: "码头装卸、文件费、堆存费等",
  Ground_transportation_from_the_factory_or_warehouse_to_the_port_or_airport_or_distribution_center:
    "从工厂/仓库到港口/机场/集散中心的地面运输",
  Sea_container_loading_service: "海运集装箱装箱服务",
  Export_import_customs_clearance_service_fee_global:
    "出口/进口清关服务费，全球通用",
  Security_inspection_storage_sorting_fuel_surcharge_etc:
    "安检、仓储、分拣、燃油附加费等",
  Cross_border_customs_inspection_transfer_fees: "跨境时的通关、查验、中转费用",
  Used_for_non_standard_charges: "用于非标准收费",
  costConfiguration: "成本配置",
  minimumValueIsZero: "最小值为0",
  pleaseSelectCountry: "请选择国家",
  pleaseSelectDestinationWarehouse: "请选择目的仓库",
  pleaseSelectTransitWarehouse: "请选择中转仓库",
  pleaseEnterCustomerID: "请选择客户",
  pleaseSelectChannelType: "请选择渠道类型",
  pleaseSelectStuffingSize: "请选择装柜尺寸",
  pleaseSelectEnableStatus: "请选择启用状态",
  editFullContainerFirstPassCost: "编辑整柜头程费",

  //固定SKU费用
  fixedSkuFees: "固定SKU费用",
  Added_fixed_SKU_fee: "添加固定SKU费用",
  edit_fixed_SKU_fee: "编辑固定SKU费用",
  Select_Add_SKUs: "选择添加SKU",

  //仓租费
  storageCharges: "仓租费", //菜单名称修改时注意
  List_of_warehouse_rental_charges: "仓租费列表",
  listWarehouseRentalCharges: "仓租费列表", //菜单名称修改时注意
  Start_days: "开始天数",
  time_Info: "时间信息",
  Warehousing_charge: "仓租费用",
  Days_in_storage: "入仓天数",
  warehousing_time: "入仓时间",
  edit_cost: "编辑费用",
  please_enter_SKU: "请输入SKU",
  Operator_query: "操作人查询",
  Minimum_length_of_three_sides: "最小三边长",
  Maximum_length_of_three_sides: "最大三边长",
  The_input_fee_cannot_be_negative: "输入的费用不能为负数",
  Storage_rental_days_are_calculated_at_the_beginning_of_each_SKU_incoming_batch:
    "每个SKU入库批次开始计算仓租天数",

  //贴标费
  labellingCharge: "贴标费", //菜单名称修改时注意
  Label_quantity: "贴标数量",
  Label_or_not: "是否贴标",
  import_labelling_charges: "导入贴标费",

  //费用特批
  special_CostId: "特批编号",
  special_CustomerId: "特批客户ID",
  finish_time: "结束时间",
  additionSpecialFees: "创建费用特批",
  additionSpecialFeesEdit: "编辑费用特批",
  viewSpecialApprovalExpenses: "查看费用特批", //菜单名称修改时注意
  comeupReview: "提交审核",
  Special_approval_information: "特批信息",
  Whether_to_invalidate_this_special_approval_for_expenses:
    "是否作废此费用特批",
  After_approval_the_original_fee_settings_will_be_overwritten_Please_carefully_check_if_the_settings_are_correct:
    "审核通过后会覆盖掉原本的费用设置，请谨慎检查是否设置正确",
  Please_select_the_same_type_of_special_order: "请选择相同类型的特批订单",

  //财务报表
  Financial_statement: "财务报表",
  financialStatement: "财务报表", //菜单名称修改时注意
  tableConfigurationList: "表配置列表",
  Add_configuration_table: "添加配置表",
  table_name: "表名",
  table_ID: "表ID",
  table_name_data_type: "表名数据类型",
  tier: "层级",
  Required_or_not: "是否必填",
  Enable_or_not: "是否启用",
  Add_field: "添加字段",
  field_name: "字段名",
  field_ID: "字段ID",
  Field_data_type: "字段数据类型",
  to_lead: "导入",
  Multiple_table_import: "多表导入",
  Serial_number_multi_table_import: "序列号多表导入",
  inportSuccess: "导入成功",
  Drag_the_file_here: "将文件拖到此处",
  Only_xls_xlsx_csv__files_can_be_uploaded_and_the_size_does_not_exceed_100_MB:
    "只能上传xls/xlsx/csv文件，且不超过100MB",
  formulaConfiguration: "公式配置", //菜单名称修改时注意
  Add_a_single_table_formula: "添加单表公式",
  Edit_a_single_table_formula: "编辑单表公式",
  Add_a_multi_table_formula: "添加多表公式",
  Edit_table_formula: "编辑表公式",
  List: "表",
  data_processing_type: "数据处理类型",
  operator_symbol: "操作符",
  summation: "求和",
  Specified_data: "指定数据",
  Marker_text: "标记文字",
  de_weight: "去重",
  equation: "公式",
  equation_Name: "公式名",
  Sign_Color: "标记颜色",
  Result_field: "结果字段",
  Selection_formula: "选择公式",
  Selection_result_List: "选择结果表",
  Please_select_the_result_table: "请选择结果表",
  Only_one_result_table_can_be_selected: "仅允许选择一张结果表",
  resultList: "结果表",
  serial_number: "序列号",
  Serial_number: "流水号",
  Please_enter_the_serial_number: "请输入流水号",
  Please_upload_the_certificate: "请上传凭证",
  include: "包含",
  delete_batch: "删除批次",
  Specified_number_of_rows: "指定行数",
  Batch_process_field_data_types: "批量处理字段数据类型",
  Please_enter_the_serial_number_of_the_batch_you_want_to_delete:
    "请输入需要删除批次的序列号",
  editFinancialStatement: "编辑财务报表",
  Add_trigger: "添加触发器",
  Collection_management: "收账管理",
  Please_enter_the_tracking_number_separated_by_commas_or_newlines:
    "请输入运单号,用逗号或换行隔开",
  Please_enter_the_transaction_number_separated_by_commas_or_line_breaks:
    "请输入交易号,用逗号或换行隔开",
  Please_enter_the_head_order_number_separated_by_a_comma_or_a_newline:
    "请输入头程订单号,用逗号或换行隔开",
  Please_enter_the_receipt_number_separated_by_a_comma_or_a_newline:
    "请输入入库单号，用逗号或换行隔开",
  registerReturnOrder: "退货收货",
  returnOrderGrounding: "退货上架",
  Number_of_remaining_shelves: "剩余上架数量",
  please_enter_Number_of_shelves: "请填写上架数量",
  Batch_registration_basket: "批量登记篮子",
  registration_basket: "登记篮子",
  Today_is_total_revenue: "今日总收入",
  Today_is_total_expenditure: "今日总支出",
  Today_is_balance: "今日余额",
  Yesterday_is_balance: "昨日余额",
  ConsolidationOfSimilar: "同类费用合并",

  //退货
  sales_return: "退货",
  return_management: "退货管理",
  returnManagement: "退货管理", //菜单名称修改时注意
  returnList: "退货列表",
  Claim_status: "认领状态",
  date_issued: "上架时间",
  valid_time: "有效时间",
  Create_a_return_form: "创建退货单",
  Edit_a_return_form: "编辑退货单",
  Receiving_warehouse: "收货仓库",
  logistics_provider: "物流商",
  Return_note: "退货备注",
  processing_scheme: "处理方案",
  Product_picture: "商品图片",
  Select_add_item: "选择添加货品",
  Claim_time: "认领时间",
  Temporary_storage_number: "暂存号",
  viewReturnNote: "查看退货单", //菜单名称修改时注意
  Claimed: "已认领",
  unclaimed: "未认领",
  Parcel_information: "包裹信息",
  Package_picture: "包裹图片",
  Package_details: "包裹详情",
  Number_of_shelves: "上架数量",
  unqualified_quantity: "不合格数量",
  Quantity_of_abandonment: "废弃数量",
  // Return_Basket: '退货篮子',
  Image: "图片",
  Return_StockUnit: "退货库位",
  // Actual_Weight: '真实重量',
  // Actual_Lenth: '真实长度',
  // Actual_Width: '真实宽度',
  // Actual_Height: '真实高度',
  Receiving_Warehouse: "收货仓库",
  Claim_ReturnOrderMsagess:
    "当前包裹未登记，继续填写信息点击保存后将会登记至认领区！",
  Please_enter_the_tracking_number: "请输入运单号",
  Please_enter_the_warehouse: "请选择收货仓库",
  Please_enter_the_logistics_provider: "请输入物流商",
  Please_enter_the_temporary_number: "请输入暂存号",
  Please_enter_the_sku: "请选择SKU",
  Package_picture_isNotNull: "包裹图片不能为空",
  ReturnOrder_ItemProduct_IsNotSkuQuantityNull: "退货项商品SKU数量不能为空",
  ReturnOrder_ItemProduct_IsNotQuantityNull: "退货项商品数量不能为空",
  Please_add_the_return_order_item: "请添加退货商品",
  Reject: "驳回",
  Abandon: "废弃",
  Ground_Quantity: "已上架数量",
  Stay_Ground_Quantity: "待上架数量",
  Please_select_the_basket: "请扫描退货篮子",
  Handle_Remark: "处理备注",
  Please_add_the_commodity: "请添加产品",
  Please_fill_in_the_required_information: "请填写明细项真实尺寸信息",
  Please_enter_the_unqualified_quantity: "请输入不合格数量",
  The_unqualified_quantity_cannot_be_greater_than_the_product_quantity:
    "不合格数量不能大于商品数量",
  Generate_shelf_task: "指派上架任务",
  Please_enter_the_solution: "请输入处理方案",
  Please_upload_pictures: "请上传图片",
  //quality_testing:'质检',
  Return_StockUnits: "退货库存",
  Actual_Weight: "真实重量(kg/个)",
  Actual_Lenth: "真实长",
  Actual_Width: "真实宽",
  Actual_Height: "真实高",
  Actual_Lenth_unit: "真实长度(CM)",
  Actual_Width_unit: "真实宽度(CM)",
  Actual_Height_unit: "真实高度(CM)",
  Actual_Size: "真实长宽高(CM)",
  Return_Basket: "退货篮子",
  ThirdParty_Warehousing: "三方仓",
  Determine_whether_to_reject: "是否确定驳回",
  Determine_whether_to_abandon: "是否确定废弃",
  returnOrderStayGrounding: "退货单待上架列表",
  Please_select_a_product_that_belongs_to_this_customer: "请选择该客户所属商品",
  Viewing_Delivery_logs: "查看发货日志",
  Reprint_face_sheet: "补印面单",
  By_default_the_quantity_of_reserved_storage_is_regarded_as_the_qualified_quantity_during_batch_inspection:
    "批量质检时默认以预约入库数量作为合格数量,产品默认已有标，是否继续？",
  When_the_return_form_of_the_claim_area_is_unclaimed_for_more_than_30_days_it_will_automatically_enter_the_destruction_area:
    "当认领区退件单超过30天无人认领，将自动进入销毁区",
  Failure_to_claim_within_30_days_automatically_enters_the_destruction_zone:
    "30天未认领自动进入销毁区",
  claim: "认领",
  Please_enter_separated_by_commas_or_newlines: "请输入,用逗号或换行隔开",
  Import_returns: "导入退货",
  attribution: "归属人",
  unfinishedReturnTaskList: "未完成退货任务列表",
  finishedReturnTaskList: "已完成退货任务列表",
  Viewing_print_logs: "查看打印日志",
  batch_abandon: "批量废弃",
  The_minimum_value_is: "最小值为",
  The_original_product_cannot_be_deleted_if_there_is_a_shortage_or_defective_product_please_fill_in_the_unqualified_quantity:
    "原始商品不可删除，如有缺货或残次品请填写不合格数量",
  Confirm_return_pending_review: "确认退回待审核",
  Confirm_abandon: "确认废弃",
  Cofirm_modify_warehouse: "确认修改仓库",
  Verify_tracking_number: "验证运单号",

  //刊登
  publish: "刊登",
  publishLazada: "Lazada在线商品", //菜单名称修改时注意
  publishShopee: "Shopee在线商品", //菜单名称修改时注意
  publishTikTok: "TikTok在线商品", //菜单名称修改时注意
  tiktokGoodsOnline: "TikTok在线商品",
  lazadaGoodsOnline: "Lazada在线商品",
  shopeeGoodsOnline: "Shopee在线商品",
  lazadaTrusteeshipGoodsOnline: "Lazada托管在线商品", //菜单名称修改时注意
  Goods_to_be_released: "待发布商品",
  CNSC_Goods_to_be_released: "CNSC待发布商品",
  Global_commodity: "全球商品",
  Site_goods: "站点商品",
  Link_ID: "链接ID",
  Link_Name: "链接名称",
  Link_SKU: "链接SKU",
  Variant_ID: "变体ID",
  master_map: "主图",
  onLineSKU: "线上SKU",
  pair: "配对",
  Paired_inventory_SKUs: "配对",
  pairLog: "配对日志",
  unpair: "解除配对",
  Modified_pairing: "修改配对",
  temuGoodsOnline: "Temu在线商品",
  temuOnlineProductDetails: "Temu在线商品明细",

  //平台授权
  PlatformAuthorization: "平台授权",
  store_management: "店铺管理",
  ShopAuthorization: "店铺授权",
  shopAuthorization: "店铺授权", //菜单名称修改时注意
  Add_authorization: "添加授权",
  name_of_shop: "店铺名称",
  store_name: "店铺名称",
  korach: "可拉取",
  Being_drawn: "拉取中",
  Please_enter_the_name_of_the_shop: "请输入店铺名称",
  Platform_store_name: "平台店铺名称",
  authorization_status: "授权状态",
  be_authorized: "已授权",
  Authorization_successful: "授权成功",
  About_to_expire: "即将过期",
  unauthorized: "未授权",
  privileged_time: "授权时间",
  Expiration_time_of_authorization: "授权到期时间",
  Is_the_address_consistent: "地址是否一致",
  Manually_synchronize_the_repository: "手动同步仓库",
  After_authorization_automatically_pull_orders_within_half_a_month_automatically_pull_returns_within_half_a_month_and_online_product_information_within_half_a_year:
    "授权后自动拉取半个月内的订单，自动拉取半个月的退件，半年内的在线商品信息",
  After_authorization_automatically_pull_online_products_that_have_been_updated_within_half_a_year:
    "授权后自动拉取半年内存在更新的在线商品",
  Platform_SKUs_have_changed_please_pay_attention_to_re_pairing_otherwise_the_original_platform_SKUs_and_stock_SKUs_are_still_paired:
    "平台sku有变更，请注意重新配对，否则仍然是原平台SKU和库存sku配对",
  Replace_the_pairing_the_goods_information_of_the_previous_order_will_not_be_replaced_with_the_newly_paired_goods_please_go_to_the_order_list_to_modify_the_goods:
    "更换配对，之前订单商品信息不执行更换新配对的商品，请到订单列表修改商品。",
  After_the_dissolution_of_the_relationship_the_product_information_of_the_previous_order_will_not_be_unpaired_After_the_manual_pairing_the_new_pairing_logic_will_not_be_executed_for_the_previously_paired_order_Please_go_to_the_order_list_to_modify_the_product:
    "解除关系后，之前订单商品信息不执行解除配对关系，再手动配对后，之前已配对过的订单不执行新配对的逻辑，请到订单列表修改商品。",
  Pull_goods: "拉取商品",
  Recent_pull_time: "最近拉取时间",
  Store_pull_status: "店铺拉取状态",
  Store_pull_exception: "店铺拉取异常",
  Store_Pull_time: "店铺拉取时间",
  Last_7_days: "最近7天",
  Last_30_days: "最近30天",
  Last_90_days: "最近90天",
  Last_180_days: "最近180天",
  Stores_that_have_not_shipped_within_2_months_will_be_automatically_invalidated:
    "2个月未发货的店铺将会自动作废",
  Latest_shipping_time: "最后发货时间",
  Last_3_months: "最近3个月",
  Beginning_to_pull_the_time: "开始拉取时间",
  Ending_pull_time: "结束拉取时间",
  Establish_a_store: "创建店铺",

  //WMS任务控制
  WMSmissionContro: "WMS任务控制", //菜单名称修改时注意
  Configuration_task_type: "配置任务类型",
  please_select_Configuration_task_type: "请选择配置任务类型",
  Distribution_task_generation_control_type: "配货任务生成控制类型",
  please_select_Distribution_task_generation_control_type:
    "请选择配货任务生成控制类型",
  Task_order_quantity: "任务订单数量",
  Please_enter_the_Task_order_quantity: "请输入任务订单数量",
  Maximum_order_number: "最大订单数",
  Please_enter_the_Maximum_order_number: "请输入最大订单数",
  Allocation_inquiry: "配货查询",
  Whether_to_allocate_goods_by_floor: "是否按楼层配货",
  please_select_Whether_to_allocate_goods_by_floor: "请选择是否按楼层配货",
  Whether_the_storage_space_can_be_allocated: "备货库位是否可配货",
  please_select_Whether_the_storage_space_can_be_allocated:
    "请选择备货库位是否可配货",
  Order_allocation_timeout_time: "订单配货超时时间",
  Please_enter_the_Order_allocation_timeout_time: "请输入订单配货超时时间",
  Generate_timeout_order_tasks_first: "优先生成超时订单任务",
  please_select_Generate_timeout_order_tasks_first:
    "请选择优先生成超时订单任务",
  Match_and_send: "边配边发",
  please_select_Match_and_send: "请选择边配边发",
  Delivery_weighing: "是否发货称重",
  please_select_Delivery_weighing: "请选择是否发货称重",
  Do_you_want_to_take_photos: "是否发货拍照",
  Is_the_shipment_recorded: "是否发货录像",
  please_select_Do_you_want_to_take_photos: "请选择是否发货拍照",
  Check_whether_the_goods_are_delivered: "是否发货验货",
  please_select_Check_whether_the_goods_are_delivered: "请选择是否发货验货",
  Whether_the_whole_sorting_task_is_shipped: "是否整分拣任务发货",
  please_select_Whether_the_whole_sorting_task_is_shipped:
    "请选择是否整分拣任务发货",
  Delivery_inquiry: "发货查询",
  New_task_control: "新增任务控制",
  Edit_task_control: "编辑任务控制",
  Allocation_information: "配货信息",
  shipping_information: "发货信息",
  Multi_floor_combination_distribution: "多楼层组合配货",
  Distribute_goods_while_shipping: "边配货边发货",
  Total_allocation_quantity: "总配货数量",
  Total_shipment_quantity: "总发货数量",
  Delivery_phase: "发货阶段",
  Delivery_start_time: "发货开始时间",
  Delivery_end_time: "发货结束时间",
  Abnormal_query: "异常查询",
  need: "需要",
  do_without: "不需要",
  Please_enter_basket_remarks: "请输入篮子备注",
  Failed_to_print_sheet_please_rescan: "打印面单失败，请重新扫描",
  Single_print_success: "面单打印成功",
  batch_delivery: "批量发货",
  Bulk_shipment_quantity: "批量发货数量",
  Whether_to_scan_the_database: "是否扫描库位",
  Please_confirm_that_the_goods_have_been_returned_to_the_original_warehouse:
    "请确认已将商品放回原库位",
  Return_the_order_to_ungenerated: "将订单退回至未生成",
  Return_the_order_to_a_draft: "将订单退回至草稿",
  Return_the_order_to_the_pending_review_status: "将订单退回至待审核",
  Item_task_list: "单品任务列表",
  itemTaskList: "单品任务列表", //菜单名称修改时注意
  Multi_task_list: "多品任务列表",
  multiTaskList: "多品任务列表", //菜单名称修改时注意
  Packing_material_condition: "包材状态",
  Basket_quantity: "篮子数量",
  viewWarehouseEntryList: "查看入库单列表",
  No_combo_SKU_images_uploaded: "请上传组合SKU图片",
  Whether_sorting_and_delivery_is_required: "是否需要分拣发货",
  delivery_process: "发货流程",
  delivery_process_one: "发货流程1",
  delivery_process_two: "发货流程2",
  Delivery_flow_2_does_not_allow_the_use_of_border_variations:
    "发货流程2不允许使用边配边分",
  Delivery_process_2_Multi_floor_distribution_is_not_allowed:
    "发货流程2不允许使用多楼层配货",
  Default_delivery_process_scanning_the_corresponding_basket_for_goods_sorting_and_delivery:
    "默认发货流程，扫描对应篮子进行货品分拣发货",
  Goods_are_sorted_and_no_baskets_are_needed_for_delivery:
    "货品进行分拣，发货不再需要篮子",
  Multiple_products_and_edge_matching_edge_division_unusable_volume:
    "多品与边配边分不可使用容积",
  Use_the_delivery_flow_for_multi_product_tasks_2_The_border_variation_is_not_allowed:
    "多品任务使用发货流程2不允许使用边配边分",
  surfTheInternet: "是否上网",
  surfExternalOrder: "是否允许外部订单",
  Please_choose_surfTheInternet: "请选择是否上网",
  Please_choose_surfExternalOrder: "请选择是否允许外部订单",
  Whether_to_go_online_refers_to_whether_the_platform_api_interface_is_called_to_verify_whether_the_logistics_trajectory_has_been_collected:
    "是否上网指的是是否调用平台api接口验证物流轨迹是否揽收",
  //WMS
  Preview_sheet: "预览面单",
  If_the_bill_is_abnormal_contact_the_administrator:
    "面单出现异常，请联系管理员进行处理",
  Exit_Printing: "退出打印",
  single_product: "单品",
  paperTask: "纸质任务", //菜单名称修改时注意
  multiProductPaperDistribution: "多品纸质配货", //菜单名称修改时注意
  singleProductPaperDistribution: "单品纸质配货", //菜单名称修改时注意
  obtainPaperDistributionOfSingleProduct: "获取单品纸质配货", //菜单名称修改时注意
  completeThePaperDistributionOfTheSingleProduct: "完成单品纸质配货", //菜单名称修改时注意
  obtainMultiProductPaperDistribution: "获取多品纸质配货", //菜单名称修改时注意
  completeMultiProductPaperDistribution: "完成多品纸质配货", //菜单名称修改时注意
  Paper_tracking_number: "纸质单号",
  basket: "篮子",
  basket_Info: "篮子信息",
  specified_Quantity: "指定数量",
  Individual_product_operation: "单品操作", //菜单名称修改时注意
  Multiple_product_operation: "多品操作",
  multipleProductOperation: "多品操作", //菜单名称修改时注意
  multiple_products: "多品",
  order_quantity: "订单数量",
  volume: "容积",
  describe: "描述",
  taskList: "任务列表", //菜单名称修改时注意
  Extra_packing_material: "额外包材",
  Additional_packing_material_exists: "存在额外包材",
  listOrdersShipped: "待发货订单列表", //菜单名称修改时注意
  listAbnormalShipment: "待发货异常列表",
  Order_phase: "订单阶段",
  order_source: "订单来源",
  Quantity_occupied: "占用数量",
  The_address_of_the_bill_is_empty_Contact_the_administrator:
    "面单地址为空,请联系管理员处理",
  The_address_of_the_bill_is_empty: "面单地址为空",
  There_are_orders_with_empty_waybill_numbers_in_the_selected_orders_so_the_waybill_cannot_be_previewed:
    "所选订单中存在运单号为空的订单,无法预览面单",
  Please_scan: "请扫描",
  Please_scan_the_barcode: "请扫描商品条码",
  Modify_the_number_of_SKUs: "修改SKU数量",
  Modified_warehouse: "修改仓库",
  Submitted_to_be_reviewed: "提交至待审核",
  Commit_back_not_generated: "提交回未生成",
  Back_to_not_generated: "退回至未生成",
  Back_to_draft: "退回至草稿",
  Return_to_pending_review: "退回至待审核",
  priority: "优先",
  secondary: "次要",
  order_inquiry: "订单查询",
  info_query: "信息查询",
  Print_basket_number: "打印篮子编号",
  Back_to_basket_list: "返回篮子列表",
  Sorting_starts_numbering: "分拣开始编号",
  Sorting_end_number: "分拣结束编号",
  Tripartite_warehouse_information: "三方仓信息",
  Threeway_warehouse_OP_number: "三方仓OP号",
  Batch_sorting: "批量分拣",
  The_sorting_number_of_the_current_scan_is: "当前扫描的分拣编号为",
  Print_the_sorting_basket_head: "打印分拣篮子头",
  List_of_shipped_orders: "已发货订单列表",
  listShippedOrders: "已发货订单列表", //菜单名称修改时注意
  taskID: "任务ID",
  Please_enter_taskID: "请输入任务ID",
  There_are_no_tasks_in_the_basket: "当前篮子暂无任务",
  bulk_print: "批量打印",
  to_do_list_ID: "任务单ID",
  task_type: "任务类型",
  List_of_tasks_in_allocation: "配货中任务列表",
  listTasksAllocation: "配货中任务列表", //菜单名称修改时注意
  Sorting_task_list: "分拣中任务列表",
  sortingTaskList: "分拣中任务列表", //菜单名称修改时注意
  List_of_tasks_being_shipped: "发货中任务列表",
  listTasksBeingShipped: "发货中任务列表", //菜单名称修改时注意
  Printing_successfully_Stopped_printing: "打印成功,停止打印",
  List_of_shipped_tasks: "已发货任务列表",
  listShippedTasks: "已发货任务列表", //菜单名称修改时注意
  explosiveOperation: "爆款操作", //菜单名称修改时注意
  explosiveDistribution: "爆款配货", //菜单名称修改时注意
  explosiveDelivery: "爆款发货", //菜单名称修改时注意
  explosiveList: "爆款列表", //菜单名称修改时注意
  Order_origin_currency: "订单原始货币",
  Out_of_storage: "正在出库",
  Print_failed_Please_check_and_try_again: "打印失败!请检查后重试",
  One_click_out_completed: "一键出库完成",
  not_finished: "未结束",
  have_not_started: "未开始",
  If_the_printing_is_not_successful_for_more_than_5_seconds_the_printing_ends:
    "打印超过5秒没捕获到成功状态,打印结束",
  Whether_it_is_a_paper_task: "是否为纸质任务",
  Checking_the_sheet: "正在检测面单",
  A_sheet_is_being_printed: "正在打印面单",
  System_deduction: "系统扣费",
  Get_the_distribution_task: "获取配货任务",
  Reprint_the_distribution_sheet: "补印配货单",
  invoice: "发票",
  HOT: "爆款",
  print_TaskId: "打印任务ID",
  Generating_task: "正在生成任务",
  distributionControl: "配货控制", //菜单名称修改时注意
  Order_distribution_time_zone: "订单配货时区",
  Order_distribution_sorting_field: "配货排序字段",
  automatic_printing: "自动打印",
  Non_automatic_printing: "不自动打印",
  Automatic_printing_of_distribution_slips: "自动打印配货单",
  Automatically_prints_the_task_ID: "自动打印任务ID",
  The_time_zone_already_exists: "该时区已存在",
  Add_Time_zone: "添加时区",
  example: "示例",
  Ungenerated_task: "未生成任务",
  completed_distribution: "已完成配货",
  Order_submission_time: "订单提交时间",
  Please_select_automatic_printing: "请选择自动打印",
  Please_select_order_distribution_sorting_field: "请选择配货排序的字段",
  The_entered_time_zone_must_be_longer_than_one_hour_from_the_existing_time_zone:
    "输入的时区与现有时区需大于一个小时",
  The_time_zone_must_be_between_0100_and_2300:
    "输入的时间必须在01：00-23：00之间",
  Support_input_time_zone_return_to_add_the_input_time_zone_needs_to_exist_in_the_selection_value:
    "可直接选择时间，可输入时区回车进行添加，注：输入时区需存在选择值中",
  Sort_by_order_submission_time_from_morning_to_night:
    "以订单提交时间从早到晚进行排序",
  The_order_is_sorted_by_the_repository_number_and_the_next_repository_order_task_will_be_performed_only_after_processing_the_current_repository_order_task:
    "以库位号进行排序，处理完当前库位订单任务后才会进行下一个库位订单任务",
  Sort_by_sku_the_current_sku_is_completed_before_proceeding_to_the_next_sku:
    "按sku进行排序，完成当前sku后才会进行下一个sku",
  Generate_earlier_time_zone_tasks_first: "优先生成更早的时区任务",
  If_the_order_distribution_time_zone_is_not_set_it_will_not_be_divided_by_time_Only_the_order_distribution_sorting_field_will_be_sorted_to_generate_the_order:
    "如果不设置订单配货时区，就不会进行按照时间分割。只会按照订单配货排序字段，排序进行生成订单。",
  Pre_0_yesterday_orders_are_preferentially_generated:
    "优先生成0点前(昨日)订单",
  Generate_orders_from_0000_to_1200: "生成00:00至12:00时间段内的订单",
  Generate_orders_after_1200_to_before_2400: "生成12:00后至24:00前的订单",
  Please_enter_the_number_of_tasks: "请输入任务数量",
  Please_select_a_single_order_type: "请选择单种订单类型",
  Please_scan_task_ID: "请扫描任务ID",
  Whether_to_limit_the_sorting_and_delivery_to_the_same_person:
    "是否限制为同一个人分拣发货",
  Mixed_shipments_are_possible_for_orders_of_different_task_types:
    "不同任务类型的订单可进行混合发货",
  task_bound_person: "任务绑定人",
  remaining_products: "剩余上架产品种数",
  Please_perform_wms_task_control_first: "请先进行wms任务控制",
  The_current_warehouse_has_not_performed_wms_task_control:
    "当前仓库未进行wms任务控制",
  whether_batch_ship: "是否批量发货",
  hot_item_whether_batch_ship: "爆款是否批量发货",

  //手工出入库
  manualEntryAndExitList: "手工出入库列表", //菜单名称修改时注意
  Manual_Entry_and_exit_slip_number: "手工出入库单号",
  Manual_Entry_and_exit_slip_type: "手工出入库类型", //手工出入库类型
  Entry_and_exit_slip_type: "出入库类型", //出入库类型
  Manual_Entry_and_exit_slip_status: "手工出入库状态", //手工出入库状态
  accomplish_Time: "完成时间",
  audits: "审核",
  Operable_quantity: "可操作数量",
  import_manualEntryAndExit: "导入手工出入库",
  Create_ManualEntryAndExit: "创建手工出入库单",
  Please_fill_in_the_audit_remarks: "请填写审核备注",
  audit_remarks: "审核备注",
  pass_the_audit: "审核通过",
  The_inventory_will_be_changed_after_clicking: "点击确定后库存将会变化",
  Clicking_OK_will_flag_the_exception: "点击确定将标记为异常",
  Click_OK_and_it_will_be_rejected: "点击确定后将会被驳回",
  Number_of_shelvesd: "货架数量",
  Type_of_outgoing_and_incoming_accounts: "出入账类型",
  If_a_recommended_repository_exists_the_recommended_repository_is_selected_by_default:
    "存在推荐库位时，默认选中推荐库位",
  If_a_recommended_repository_exists_the_recommended_repository_is_entered_by_default:
    "存在推荐库位时，默认输入推荐库位",
  When_the_type_of_warehouse_operation_is_outbound_after_selecting_the_storage_location_the_available_inventory_on_this_location_will_be_displayed_The_quantity_filled_in_must_not_exceed_the_operable_inventory:
    "当出入库类型为出库时，选择库位后会显示此库位上可用库存，填写数量不可大于可操作库存",
  Consolidation_of_similar_expenses: "同类费用合并",
  Add_Consolidation_of_similar_expenses: "新增同类费用合并",
  Monthly_Expense_List: "每月消费列表",
  Name_of_the_expense_item: "费用项名称",

  //账单明细
  Accounting_in: "入账",
  Accounting_out: "出账",
  in_out_account: "出入账",
  Sku_and_quantity: "商品SKU和数量",
  Billing_weight: "计费重量",
  Charge_quantity: "费用设置计费件数",
  Charge_weight: "费用设置重量",
  Cost_setting_Cube: "费用设置立方",
  cost_setting_Three_sides_length_CM: "费用设置三边和",
  Cost_set_three_sides_long: "费用设置三边长",
  goods_cobe: "商品立方",
  goods_Three_sides_length_CM: "商品三边长",
  goods_weight: "商品重量",
  type_of_fee: "费用类型",
  Item_code: "货品编码",
  Fill_in_the_positive_balance_of_recharge_and_fill_in_the_negative_balance_of_deduction:
    "充值余额填写正数，扣除余额填写负数",

  //出入库记录
  stock_in_and_stock_out_record: "出入库记录",
  storage_location_number: "库位号",
  Entry_quantity: "库存变动数量",
  total_inventory_quantity: "总库存数量",
  Current_batch_inventory_quantity: "当前批次库存数量",
  Batch_stock_quantity: "库位总库存数量",
  Batch_occupied_inventory_quantity: "批次占用库存数量",
  life: "库龄",
  Has_stock: "有库存",
  No_stock: "无库存",
  Has_No_stock: "有无库存",
  stock_type: "库存类型",
  Entry_time: "入库时间",
  Tripartite_storage: "三方仓库存",
  General_stock: "普通库存",
  Unusable_inventory: "不可用库存",
  Entry_and_exit_records: "查看库存详情",
  grounding: "上架",
  Shelf_in_bulk: "批量上架",
  Number_of_shelvesds: "上架数量",
  Unshelved: "未上架",
  Already_listed: "已上架",
  Multiple_quantity: "多发数量",
  Shelf_batch: "上架批次",
  Check_the_storage_details: "查看出入库明细",
  operate_successfully: "操作成功",
  Print_the_default_size_paper_distribution: "打印默认大小纸质配货单",
  Print_A4_size_distribution: "打印A4大小纸质配货单",
  Print_100_150_size_distribution: "打印100*150大小纸质配货单",
  The_customer_password_will_be_reset_to_ESTP_mobile_number:
    "将会把客户密码重置为：ESTP+手机号",
  The_customer_password_will_be_reset_to_customer_ID: "将会把客户密码重置为：客户ID",
  Get_a_shelf_task: "获取上架任务",
  Please_select_some_user: "上架人",
  Prioritize_shelving: "设置优先上架",
  Please_select_the_type_of_manual_entry_ticket: "请选择手工出入库单类型",
  Please_select_warehouse: "请选择仓库",
  Please_input_transfer_stock_fee: "请输入费用（立方/KG）",
  Please_input_demurrage_start_day: "请输入滞留起收天数",
  Please_input_detention_stock_fee: "请输入滞留仓租费（M³/元）",
  Please_select_the_warehouse_location: "请选择库位",
  Please_scan_the_database_location: "请扫描库位",
  Select_date_time: "选择日期时间",
  please_select_stockId: "请选择仓库",
  please_select_stockzone: "请选择分区",
  please_select_shelf: "请选择货架",
  Please_scan_sku: "请扫描SKU",
  please_select_auditUser: "请选择审核人",
  Storage_type: "出入库类型",
  Billing_quantity: "计费数量",
  Cost_type: "费用类型",
  frozenBillingDetails: "冻结账单明细",
  storage_location_capacity: "库位容量",
  product_capacity: "产品使用容量",
  recommendstorage_location_type: "推荐库位类型",
  Operational_query: "操作查询",
  Please_scan_the_basket: "请扫描篮子编码！",
  The_number_of_shelves_cannot_be_greater_than_the_qualified_number:
    "上架数量不能大于合格数量",
  Whether_batch_shelves: "是否批量上架",
  Please_select_the_same_warehouse_entry_form_to_submit:
    "请选择同一仓库入库单进行提交！",
  The_database_bit_number_does_not_exist: "不存在该库位号",
  replacement_cost: "重置成本",
  Create_a_breakout_task: "创建爆款任务",
  Match_and_divide: "边配边分",
  matchAndDivide: "边配边分", //菜单名称修改时注意
  Online_SKU_images: "线上SKU图片",
  Seller_SKU: "卖家SKU",
  AbnormalRemarks: "异常备注",
  Store_SKU: "店铺SKU",
  Authorization_assignment: "授权赋值",
  Please_enter_the_AccessToken: "请输入AccessToken",
  Please_enter_the_RefreshToken: "请输入RefreshToken",
  APITokenInformation: "API令牌信息",
  authorization_management: "授权管理",
  authorization_message: "授权信息",
  companyName: "公司名称",
  Print_a_paper_distribution: "打印纸质配货单",
  Select_case_number: "选择箱号",
  Starting_box_number: "开始箱号",
  End_box_number: "结束箱号",
  picker: "拣货人",
  Pick_date: "拣货日期",
  print_time: "打印时间",
  sku_quantity: "sku数量",
  Refill_slip_number: "补扣单号",
  Whether_to_cancel_supplementary_deduction: "是否确定撤销补扣?",
  irredeemable: "无法重复撤销",
  This_item_is_out_of_stock: "该商品无库存",
  The_repository_does_not_exist: "不存在该库位",
  flowingWaterInAndOutOfStorage: "出入库流水",
  Generation_task_type: "生成任务类型",
  View_the_default_log_of_the_initial_shipping_fee_for_modifying_the_purchase_price:
    "查看修改采购价默认头程费日志",

  //入库单控制
  warehouseEntryControl: "入库/退货控制",
  Add_the_entry_ticket_control: "添加系统控制",
  Edit_entry_slip_control: "编辑系统控制",
  Whether_to_open_excess_inspection: "是否开启超额质检",
  Control_the_number_of_boxes_generated_during_inspection_tasks:
    "控制质检任务生成箱数",
  Control_the_number_of_SKUs_generated_by_the_mount_task:
    "控制上架任务SKU生成种数",
  Create_entry_ticket_control: "创建系统控制",
  Enter_0_for_the_entire_build_task: "输入0为整单生成任务",
  Whether_To_return_the_package_to_take_photos: "是否退货包裹拍照",
  Control_The_number_of_boxes_generated_for_a_quality_inspection_task_indicates_the_number_of_boxes_generated_when_a_worker_obtains_a_quality_inspection_task_Set_0_to_the_entire_generation_task:
    "控制质检任务生成箱数为工人获取质检任务时生成的箱数，填写0为整单生成任务",
  Control_the_number_of_SKU_types_generated_for_the_shelf_task_to_the_number_of_SKU_types_generated_when_obtaining_the_shelf_task_Fill_in_0_for_the_entire_single_generation_task:
    "控制上架任务SKU生成种数为工人获取上架任务时生成的SKU种数，填写0为整单生成任务",
  Whether_to_take_a_picture_of_the_return_is_whether_to_take_a_picture_of_the_package_when_the_return_receipt_is_received:
    "是否退货拍照为退货单收货时是否包裹拍照",
  There_are_mandatory_fields_that_are_not_filled_in_Please_fill_them_in_and_try_again:
    "存在未填写的必填项，请填写后重试",
  inbound_and_return_control: "入库/退货控制",
  Only_registration: "仅登记",
  Equivalent_to_regular_return_receipt: "等于普通的退件收货",
  Move_to_the_return_storage_location: "上架至退货库位",
  After_return_automatically_put_away_to_return_storage_location:
    "退件后自动上架到退货库位",
  Please_set_up_the_return_storage_location_first: "请先设置好退件库位",
  Register_and_put_away: "登记并上架",
  After_registering_the_returned_items_and_selecting_the_storage_location_proceed_with_putaway:
    "退件登记并选择库位号后上架",

  //子账号管理
  Subaccount_management: "子账号管理",
  subaccountList: "子账号列表", //菜单名称修改时注意
  Subaccount_number: "子账号编号",
  subaccount_name: "子账号名称",
  Please_enter_a_subaccount_name: "请输入子账号名称",
  Add_a_subaccount: "添加子账号",
  subAccountRoleInfo: "子账号信息", //菜单名称修改时注意
  payment_type: "支付方式",
  Whether_to_terminate_services: "是否终止业务",
  Subaccount_role: "子账号角色",
  Please_add_product: "请添加商品",
  Please_select_product: "请选择商品",
  An_empty_container_number_exists_Please_check_and_try_again:
    "存在空的箱号，请检查后重试",
  An_empty_number_exists_Please_check_and_try_again:
    "存在空的数量，请检查后重试",
  Submit_success: "提交成功！",

  //撤销订单
  cancellation_of_order: "取消订单",
  Cancel_a_task: "取消任务",
  Confirm_cancellation_of_order: "确认取消订单",
  Confirm_cancel_task: "确认取消任务",
  Order_operation: "订单操作",
  Cancel_an_order: "撤销订单",
  Undo_to_exception: "撤销到异常",
  Undo_to_ungenerated: "撤销到未生成",
  cancelOrder: "撤销订单", //菜单名称修改时注意
  Please_enter_the_waybill_number_Only_100_waybills_are_supported_at_a_time_separated_by_line_breaks:
    "请输入运单号,一次仅支持100个运单,以换行分隔",
  Order_cancellation_Pick_stock_please_return_the_stock_to_the_original_shelf_order_cancellation_directly_to_the_confirmation:
    "已拣货的订单撤销拣货库存,请将库存放回原货架,订单直接撤销到确认中",

  // 自动处理规则
  automaticProcessingRule: "自动处理规则",
  Rule_name: "规则名",
  Rule_type: "规则类型",
  priority_level: "优先级",
  Rule_description: "规则描述",
  Rule_subitem: "规则子项",
  Modification_time: "修改时间",
  Modified_successfully: "修改成功",
  content: "内容",
  Please_add_at_least_one_rule: "请至少添加一个规则",
  Please_select_the_rule_type_first: "请先选择规则类型",
  Rule_detail: "规则详情",
  sku_matching_mode: "SKU匹配方式",
  packing_type: "打包类型",
  Please_select_at_least_one_rule: "请选择至少一项规则",
  Only_process_the_orders_that_have_been_pending_review_for_15_days_from_the_current_system_time_and_the_inventory_sufficient:
    "只处理待审核中进入系统当前时间-15天 且 库存充足 的订单",
  Customer_inquiry_Please_enter_only_numbers: "客户查询请输入纯数字",
  The_priority_must_be_a_positive_number: "优先级必须是正数",

  // 仓租账单明细
  listWarehouseRentalChargesDetail: "仓租账单明细详情",
  warehouseRentalBillSKUDetails: "仓租账单SKU明细",
  list_warehouse_rental_charges_detail: "仓租账单明细详情",
  Inventory_batch: "库存批次",
  Upload_file_error_Upload_acsv_XLS_XLSX_file:
    "上传文件有误！请上传.CSV，.XLS，.XLSX后缀名的文件",

  // 管理端工作台
  There_are_unfinished: "存在未完成的",
  task: "任务",
  Whether_to_process: "是否前往处理",
  chart_type: "图表类型",
  Excluding_today: "不包含今日",
  rop_shipping_product_ranking_list: "待发货商品排行榜",
  single_Product_Single_Order: "单品单量",
  single_Product_Multi_Order: "单品多量",
  singleProductMultiOrder: "单品多量",
  multi_Product_Multi_Order: "多品多量",
  multiProductMultiOrder: "多品多量",
  single_product_single_order_drop_shipping_product_quantity_ranking_list:
    "单品单量待发货商品数量排行榜",
  single_Product_Multi_Order_drop_shipping_product_quantity_ranking_list:
    "单品多量待发货商品数量排行榜",
  multi_product_Multi_order_drop_shipping_product_quantity_ranking_list:
    "多品多量待发货商品数量排行榜",
  to_do_task: "待办任务",
  value_added_services: "增值服务",
  The_timeout_is_set_to_a_certain_time: "超时设置时间为",
  Recent_announcements: "最近公告",
  See_more: "查看更多",
  next: "下一个",

  // 仓库节假日
  warehouseHolidayList: "仓库节假日列表",
  holidayDate: "节假日日期",
  overdueSetting: "逾期设置",
  overdueTime: "逾期时间",
  Import_warehouse_holidays: "导入仓库节假日",
  overdue_Duration: "逾期时长",
  Warehouse_during_holidays: "仓库节假日",

  // 件型规则设置
  product_item_type: "商品件型类型",
  Update_the_product_diversion_number: "更新商品分流编号",
  Do_you_need_to_update_the_product_diversion_number: "是否更新商品分流编号",
  Priority_calculation_method: "优先计算方式",
  formula_mode: "计算方式",
  Add_range: "添加范围",
  Add_the_maximum_range: "添加最大范围",
  The_input_range_for_addition_contains_null_values_Please_check_and_try_again:
    "输入的添加范围存在空值，请检查后重试",
  Imported_part_type_rule_setting: "导入件型规则设置",

  // 新客户开发设置
  set_type: "设置类型",
  calculation_type: "计算类型",
  calculate_the_time_type: "计算时间类型",
  calculated_value: "计算值",
  overseas_warehouse_fees: "海外仓费用",
  First_leg_fees: "头程费用",
  Days: "天数",
  Month: "月份",
  Add_newly_developed_customers: "添加新开发客户",
  Delete_newly_developed_customers: "删除新开发客户",
  Please_select_set_type: "请选择设置类型",
  Please_select_calculation_type: "请选择计算类型",
  Please_select_calculate_the_time_type: "请选择计算时间类型",
  Whether_to_use_the_strategy_of_new_order_volume_for_the_entire_month:
    "是否使用整月新开单量策略",
  Please_enter_the_calculated_value: "请输入计算值",
  The_calculated_value_must_be_greater_than_zero: "计算值必须大于0",
  When_the_time_type_is_month_the_value_cannot_exceed_twelve:
    "当计算时间类型为月时，该值不能超过12",
  The_month_corresponding_to_the_starting_time_obtained_from_the_calculation_type:
    "对应计算类型得出的起始时间的那个月，",
  For_new_customers_this_will_no_longer_be_counted_after_this_month:
    "为新开发客户，本月过后就不算了",
  The_time_type_is_month: "计算时间类型是月份：",
  Using_the_strategy_of_total_monthly_new_orders_If_the_data_generation_time_is_the_1st_day:
    "使用整月新开单量策略：如果产生数据的时间是1号，",
  Even_if_the_entire_current_month_has_a_high_volume_of_new_customer_orders_if_this_is_the_case_for_any_other_days:
    "就算当前月整月都是新开发客户单量，如果是其他日期的话，",
  The_number_of_new_development_customer_orders_will_be_available_from_the_start_date_until_the_end_of_next_month:
    "从开始日期到下个月月底都是新开发客户单量。",
  Unutilized_monthly_new_order_volume_strategy_For_the_month_for_which_the_starting_time_was_determined_based_on_the_calculation_type:
    "未使用整月新开单量策略：对于计算类型得出的起始时间的那个月，",
  For_the_volume_of_new_customer_orders: "为新开发客户单量。",
  The_time_type_for_calculation_is_in_days: "计算时间类型是天数：",
  The_start_and_end_times_are_calculated_by_adding_the_first_occurrence_time_of_the_corresponding_type_to_the_corresponding_calculated_value_in_days_months:
    "对应类型的首次出现时间加上对应计算值（天数/月份）得出的开始时间，和结束时间。",
  For_example_The_calculation_type_is: "例如：计算类型等于：",
  Enter_into_inventory_set_the_time_type_to_days_and_the_calculation_value_to_15:
    "入库，计算时间类型等于：天数，计算值等于：15",
  Assuming_the_initial_listing_date_is_2025_11_01_then_the_number_of_new_customer_orders_would_be_2025_11_01_to_2025_11_15:
    "假设首次上架时间是：2025-11-01 ，那新客户单量的开始时间和结束时间就是：2025-11-01~2025-11-15。",
  During_this_period_the_orders_that_were_dispatched_are_all_counted_as_the_sales_volume_for_new_customers:
    "在此期间出库的订单都算做新开发客户单量",
  // 盘点
  count_method: "盘点方式",
  Whether_to_automatically_generate_count_tasks: "是否自动生成盘点任务",
  Whether_to_freeze_inventory: "是否冻结库存盘点",
  whether_Difference_count: "是否差异盘点",
  count_setting: "盘点设置",
  When_there_is_an_count_surplus_or_count_deficit_the_next_round_of_count_tasks_will_be_generated_after_the_end_of_the_count_until_the_final_count:
    "当出现盘盈或盘亏的情况，盘点结束后将生成下一轮盘点任务，直至最终盘点。",
  Indicates_how_many_rounds_of_count_are_required_If_only_one_round_of_count_is_required_the_value_is_one_If_you_need_to_count_two_rounds_it_is_two_and_so_on:
    "表示需要进行几轮盘点，若只盘点一轮，则为1；若需盘点两轮，则为2，以此类推。",
  Count_round: "盘点轮次",
  max_count_round: "最大盘点轮次",
  The_types_of_count_tasks_are_divided_into_light_count_and_dark_count:
    "盘点任务类型分为明盘和暗盘。",
  If_the_light_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_will_be_displayed_If_dark_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_is_not_displayed:
    "若选择明盘，则会显示需盘点的SKU库存具体数量；若选择暗盘，则不显示需盘点的SKU库存具体数量。",
  Whether_multiple_rounds_of_count_can_be_the_same_person:
    "多轮盘点人是否可为同一人",
  If_the_automatic_generation_of_count_tasks_is_not_enabled_the_task_to_be_counted_is_not_automatically_generated:
    "若不开启自动生成盘点任务，则不会自动生成待盘点任务",
  If_you_need_to_restart_the_automatic_generation_of_the_count_task_the_time_of_the_automatic_generation_of_the_count_task_will_start_in_the_morning_of_the_next_day:
    "若需重新开启自动生成盘点任务，自动生成盘点任务的时间将在第二天的凌晨开始计时。",
  count_methods_are_divided_into_SKU_count_and_count_by_warehouse_location:
    "盘点方式分为按SKU进行盘点和按库位进行盘点。",
  According_to_the_SKU_count_all_the_storage_locations_that_have_this_SKU_stock_will_be_counted_and_only_the_time_of_the_last_SKU_count_will_be_updated:
    "按照SKU盘点，则将盘点所有存在此SKU库存的库位，且只会更新SKU最后一次盘点的时间。",
  If_the_count_is_taken_by_warehouse_location_all_SKUs_with_inventory_in_the_warehouse_location_will_be_counted_and_only_the_last_count_time_of_the_warehouse_location_will_be_updated:
    "按照库位盘点，则将盘点库位上所有存在库存的SKU，且只会更新库位的最后一次盘点时间。",
  Subtract_the_last_SKU_or_warehouse_count_time_according_to_the_current_days_find_the_qualified_data_and_generate_the_count_task:
    "按照当前天数减去SKU/库位最后一次盘点时间，找寻符合条件的数据，生成盘点任务。",
  The_cycle_of_the_count_task_is_automatically_generated:
    "自动生成盘点任务周期",
  Indicates_how_many_count_details_exist_in_an_automatic_count_task:
    "表示一个自动盘点任务中会存在多少条盘点明细。",
  For_example_if_the_task_method_is_SKUs_and_the_number_of_automatically_generated_tasks_for_library_locations_and_SKUs_is_ten_the_count_details_contain_10_different_SKUs:
    "例：当盘点方式为SKU且自动生成任务（库位/SKU）数量为10，则盘点明细将存在10条不同的SKU。",
  Automatic_generation_task: "自动生成任务",
  check_log: "查看日志",
  Not_less_than_two: "不可小于2",
  Quantity_of_need_to_counted: "需盘数量",
  Quantity_of_actually_count: "实盘数量",
  Quantity_of_wait_to_count: "待盘数量",
  Quantity_of_count_loss: "盘亏数量",
  Quantity_of_count_profit: "盘盈数量",
  task_number: "任务编号",
  finally: "最终",
  execution_time_of_count: "执行盘点时间",
  executor_of_count: "执行盘点人",
  execute_count: "执行盘点",
  check_count_details: "查看盘点明细",
  The_total: "总",
  Need_to_count_rounds: "需盘点轮次",
  current_count_rounds: "当前盘点轮次",
  counter: "盘点人",
  quantity_of_occupy_stock: "占用库存数量",
  quantity_of_disabled_stock: "不可用库存数量",
  storage_location_final_count_time: "库位最后盘点时间",
  product_final_count_time: "商品最后盘点时间",
  Manually_generate_count_task: "手动生成盘点任务",
  Designated_counter: "指定盘点人",
  Data_from_different_warehouses_exists_Ensure_that_the_selected_data_belongs_to_the_same_warehouse:
    "存在不同仓库的数据，请确认勾选的数据属于同一仓库！",
  The_warehouse_is_not_set_for_count_please_set_for_count_first:
    "该仓库未进行盘点设置，请先进行盘点设置",
  please_add_data_first: "请先添加数据！",
  count_task_number: "盘点任务编号",
  stock_batch: "库存批次",
  stock_batch_ID: "库存批次ID",
  stock_batch_Num: "库存批次数量",
  Number_of_quarantined_shelves: "隔离上架数量",
  Original_batch_shelf_time: "原批次上架时间",
  Isolated_storage_location: "隔离库位",
  Whether_the_inventory_is_out_of_storage_location: "是否非库位库存",
  Isolation_shelf_time: "隔离上架时间",
  Quarantine_inventory_shelving_task_number: "隔离库存上架任务编号",
  Mission_start_shelf_time: "任务开始上架时间",
  Mission_completed_shelf_time: "任务完成上架时间",
  Task_remarks: "任务备注",
  Original_storage_location: "原库位",
  Isolation_shelf_space: "隔离上架库位",
  Complete_the_task: "完成任务",
  Fetch_task: "获取任务",
  Complete_this_round_of_tasks: "完成本轮任务",
  Current_total_stock: "当前总库存",
  Real_time: "实时",
  Task_rotation: "任务轮次",
  Add_non_existing_stock_in_storage_location: "添加非现有库位库存",
  count_loss_reason: "盘亏原因",
  count_loss_remark: "盘亏备注",
  count_loss_type: "盘亏类型",
  Defective_product: "次品",
  lack: "缺少",
  Current_stock: "当前库存",
  Inventory_quantity_at_the_end_of_the_last_round: "上轮结束盘点时库存数量",
  Quantity_of_actually_count_of_last_round_count: "上轮实盘数量",
  Quantity_of_count_profit_of_last_round_count: "上轮盘盈数量",
  Quantity_of_count_loss_of_last_round_count: "上轮盘亏数量",
  End_time_of_last_round_count: "上轮盘点结束时间",
  count_checked_and_no_problem_stock: "盘点过，没问题的库存",
  Missing_or_damaged_quantity: "缺少/损坏的数量",
  The_amount_that_exceeds_the_real_time_current_inventory:
    "超过 当前库存(实时) 的数量",
  Whether_the_real_time_current_inventory_is_different_from_the_Inventory_quantity_at_the_end_of_the_last_round:
    "当前库存(实时)是否与上轮结束盘点时库存数量有差异",
  Please_complete_the_current_task_first: "请先完成当前任务",
  The_storage_location_does_not_exist_or_has_been_completed:
    "该库位不存在或已完成",
  The_bar_code_does_not_exist_or_has_been_completed: "该商品条码不存在或已完成",
  Please_scan_the_storage_location_and_scan_the_product_bar_code_and_enter_the_quantity_of_actually_count:
    "请先扫描库位、商品条码，并输入实盘数量",
  Cancel_count_task: "撤销盘点任务",
  count_details: "盘点详情",
  count_log: "盘点日志",
  Confirm_whether_to_cancel_the_count_task: "是否确认撤销盘点任务",
  countSetting: "盘点设置",
  stockStorageLocationList: "库存库位列表",
  countTaskList: "盘点任务列表",
  countTask: "盘点任务",
  IsolatedStorageLocationList: "隔离库位列表",
  isolatedShelfTaskList: "隔离上架任务列表",
  isolatedShelfTask: "隔离上架任务",
  pendingClaimList: "待赔付",
  Has_the_inventory_been_checked: "是否已执行盘点",
  countDetails: "盘点详情",
  Please_scan_the_storage_location: "请先扫描库位",
  please_confirm_exist_storage_location_data_first: "请先确认有库位数据存在",
  Isolated_storage_location_listing_task_number: "隔离库位上架任务编号",
  task_start_time: "任务开始时间",
  task_end_time: "任务结束时间",
  Whether_the_inventory_is_not_in_the_original_storage_location:
    "是否为非原库位库存",
  The_actual_number_of_products_on_shelves: "实际上架产品数量",
  the_time_that_product_listing_to_the_isolated_storage_location:
    "产品上架到隔离库位的时间",
  Please_scan_the_Original_storage_location: "请先扫描原始库位",
  please_confirm_exist_Original_storage_location_data_first:
    "请先确认有原库位数据存在",
  this_task_is_completed: "该任务为已完成状态",
  the_storage_location_do_not_exist_or_is_not_isolated_storage_location:
    "该库位不存在或不属于隔离库位",
  Whether_to_force_the_task_to_complete: "是否强制完成任务",
  The_inventory_has_been_counted_to_the_last_product_and_the_count_task_is_to_be_finished_Is_it_confirmed_that_it_is_completed:
    "已盘点至最后一个商品，即将结束盘点任务，是否确认完成",
  unoccupied_quantity: "未占用数量",
  occupied_quantity: "已占用数量",
  return_order: "退件单",
  manual_entry_and_exit: "手工出入库",
  Shifting_storage_location: "移库位",
  Shifting_warehouse: "移仓库",
  can_no_be_zero: "不能为0",
  When_this_feature_is_enabled_customers_will_not_be_able_to_use_this_inventory_to_submit_orders_during_the_count:
    "启用此功能，盘点时客户将无法使用此库存提交订单",
  Will_not_be_able_to_operate_this_inventory: "将不能操作此库存",
  If_the_whether_Difference_count_is_equal_yes_the_count_rounds_default_is_two_and_it_cannot_be_less_than_two:
    "如果是否差异盘点等于是，盘点轮次，默认变成2，且不可小于2。",
  It_is_used_to_control_the_maximum_count_rounds_when_there_is_a_difference_in_count_quantity:
    "用于控制出现差异盘点数量时，控制最大盘点轮次",
  modifiable: "可修改",
  When_there_is_no_difference_it_is_the_final_count_round:
    "出现无差异时则为最终盘点轮次",
  whether_the_profit_is_isolated_from_the_warehouse_on_the_shelf:
    "盘盈是否隔离库位上架",
  uncounted: "未盘点",
  Have_counted: "已盘点",
  whether_Difference: "是否差异",
  inventory_position_has_not_been_counted_in_recent_N_days: "近N天未盘点库位",
  goods_have_not_been_counted_in_recent_N_days: "近N天未盘点商品",
  Total_quantity_of_goods_in_warehouse: "仓库商品总数量",
  goods_type_quantity: "商品种数",
  Whether_the_inventory_loss_is_not_available_for_storage:
    "盘亏是否不可用库位上架",
  Unavailable_library_positions: "不可用库位",
  When_the_unavailable_storage_location_is_selected_for_shelving_the_inventory_of_goods_that_are_in_short_supply_during_the_inventory_check_will_be_automatically_shelved_to_the_unavailable_storage_location:
    "当选择了不可用库位上架后，执行盘点时盘亏的商品库存将自动上架至不可用库位",
  When_the_inventory_counting_settings_select_this_item_as_yes_executing_the_final_inventory_counting_if_there_is_a_profit_will_generate_an_isolated_shelving_task_and_move_the_profit_goods_to_the_isolated_library_position:
    "当盘点设置选择此项为“是”时，执行最终盘点后如果发现盘盈，将生成隔离上架任务，将盘盈的商品移至隔离库位。",
  When_the_inventory_counting_settings_select_this_item_as_no_executing_the_final_inventory_counting_if_there_is_a_profit_will_directly_correct_the_real_time_inventory_and_move_the_profit_goods_to_the_normal_inventory:
    "当盘点设置选择此项为“否”时，执行最终盘点后若有盘盈，将直接修正实时库存，盘盈商品将直接调整到正常库存中。",
  There_are_no_unavailable_locations_in_the_current_warehouse_so_if_you_need_to_set_them_go_to_Add_them_first:
    "当前仓库不存在不可用库位，若需设置，请先前往添加",
  isolated_storage_location_down: "隔离库位下架",
  isolated_storage_unit_no: "隔离库位号",
  isolated_storage_unit_quantity: "隔离库位数量",
  no_such_storage_unit_in_warehouse: "该仓库不存在该库位号",
  cannot_exceed_isolated_quantity: "不能大于隔离库位数量",
  Inventory_cannot_be_removed_from_the_shelves: "不可用库存下架",
  The_quantity_cannot_be_empty_and_must_be_a_number: "数量不能为空且必须为数字",
  Can_only_be_a_positive_integer: "只能为正整数",
  Confirm_recount: "确认再次盘点",
  Take_stock_again: "再次盘点",
  At_the_end_of_the_final_inventory_round_the_quantity_of_stock_exceeded_expectations:
    "最终盘点轮次结束时，超出预期的库存数量",
  At_the_end_of_the_final_inventory_round_the_quantity_of_missing_or_defective_stock:
    "最终盘点轮次结束时，缺少的或为次品的库存数量",
  Actual_inventory_quantity_at_the_end_of_the_final_counting_round:
    "最终盘点轮次结束时的实际的库存数量",
  Round_Start_Time: "轮次开始时间",
  Round_End_Time: "轮次结束时间",
  Whether_to_independently_choose_the_inventory_execution_method:
    "是否自主选择盘点执行方式",
  Select_inventory_execution_method: "选择盘点执行方式",
  Directly_deduct_from_inventory: "直接减扣库存",
  Place_on_unavailable_storage_location: "不可用库位上架",
  When_the_inventory_setting_is_selected_as_Yes_during_inventory_execution_if_there_is_a_loss_in_quantity_you_can_choose_whether_to_directly_deduct_from_inventory_or_shelve_in_unavailable_locations:
    "当盘点设置选择此项为“是”时，执行盘点时若存在盘亏数量，可自主选择“直接减扣库存”或“不可用库位上架”。",

  // 工作台
  viewOrderProcessingFee: "查看操作费",
  goods_ranking_list: "商品排行榜",
  Bar_chart: "柱状图",
  weeks: "周",
  hot: "热销",
  unsalable: "滞销",
  Line_chart: "折线图",
  Total_account_balance: "账户总余额",
  Account_balance: "账户余额",
  Number_of_authorized_stores: "已授权店铺数量",
  Number_of_authorized_expired_stores: "授权过期店铺数量",
  Time_period: "时间段",
  Sales_volume: "商品销量",
  Commodity_inventory: "商品库存",
  Commodity_inventory_storage_location: "商品库存（分库位）",
  You_have_an_expired_license_store_to_deal_with: "您有授权过期店铺待处理",
  There_are_stores_whose_authorization_has_expired_and_are_about_to_expire_that_need_to_be_handled:
    "您有授权过期和即将过期店铺待处理",
  You_have_expired_stores_that_need_to_be_handled: "您有即将过期店铺待处理",
  years: "年",
  Historical_announcemen: "历史公告",
  This_year: "今年",
  Number_of_squares: "方数",
  shipment: "发货量",
  orderolume: "下单量",
  Release_time: "发布时间",
  Frozen_balance: "冻结余额",
  Frozen: "冻结",
  Store_shipment: "店铺发货量",
  is_total_orders_click_on_the_detailed_data_to_view_the_order_list:
    "的总出单量,点击详细数据可查看出单量列表",
  is_total_orders_click_on_the_detailed_data_to_view_the_list_of_order_quantities:
    "的总出单量,点击详细数据可查看下单量列表",
  Real_time_total_orders_of_the_day_click_on_the_detailed_data_to_view_the_storage_order_list:
    "当天实时的总出单量,点击详细数据可查看仓储订单列表",
  Real_time_on_the_day: "当天实时",
  is_total_order_volume_click_on_the_detailed_data_to_view_the_storage_order_list:
    "的总下单量,点击详细数据可查看仓储订单列表",
  Created_nearly_seven_days_ago: "创建时间近七日",
  Warehouse_order: "仓储订单",
  Does_not_include_today_is_sales: "不包含今日销量",
  Pie_chart: "饼状图",
  This_week: "本周",
  Current_month: "本月",
  Unread_announcement: "未读公告",
  months: "月",
  main_account: "主账号",
  head_entry: "头程入库",
  First_Leg_Order: "头程单",
  exception_First_Leg_Order: "异常头程单",
  In_the_stock_shelves: "入库上架中",
  Hello_welcome_to_use_estp_oms: "您好，欢迎使用易速菲OMS",
  Hello_welcome_to_use_Hyperdimensional_OMS: "您好，欢迎使用超维物联OMS",
  Hello_welcome_to_use_YTB_OMS: "您好，欢迎使用洋驼帮OMS",
  customer_number: "客户编号",
  Top_up_immediately: "立即充值",
  Sales_Volume: "销量",
  Data_last_updated: "数据最近更新时间",
  Beijing_time: "北京时间",
  obligation_first_leg_order: "待付款头程单",
  Total_square_inventory: "库存总方数",
  go: "前往",
  Temporarily_unavailable_please_contact_the_administrator:
    "暂时无法查看，请联系管理员",
  The_operation_succeeds_and_The_data_is_refreshed_successfully:
    "操作成功，刷新数据成功",
  number_of_SKU: "SKU种数",
  Exclusive_Investment_Promotion: "专属招商",
  Exclusive_customer_service: "专属客服",
  inventory_all_quantity: "库存总数量",
  Total_number_inventory_in_transit: "在途库存总数量",
  Order_out_today: "今日出单量",
  Order_out_today_yesterday: "昨日出单量",
  Timeout_failed_to_complete_the_task: "超时未完成任务",
  Overdue_order: "逾期订单",
  Warehousing_order: "入库订单",
  Quantity_of_goods_in_stock_today: "今日入库上架单量",
  Number_of_SKUs_in_storage_today: "今日入库上架SKU数量",
  Overdue_putaway_order_quantity: "上架超时入库单量",
  Return_order: "退货订单",
  Order_quantity_of_return_today: "今日退货上架单量",
  Number_of_SKUs_returned_today: "今日退货上架SKU数量",
  First_billing: "头程账单",
  unaudited_customer_number: "待审核客户数量",
  toBePaidOrderList: "待付款订单",
  toBePaid: "待付款",
  Whether_the_product_is_sold_or_not_will_be_calculated_every_day_if_not_the_number_of_unsalable_days_will_be_added_by_one_and_if_there_is_the_number_of_unsalable_days_will_be_reset_to_zero:
    "每天会计算商品有无销售，如果没有则滞销天数加一，如有则滞销天数归零",
  The_sum_of_pending_shipment_distribution_and_shipment:
    "待发货、配货中、发货中的总和",
  The_number_to_be_reviewed: "待审核的数量",
  The_sum_of_the_delivery_exceptions_in_the_pending_review_and_waybill_number_acquisition:
    "待审核、运单号获取中交运异常的总和",
  You_do_not_have_permission_to_access_this_page: "您没有权限访问此页面",

  // 报表
  salesReportForSKU: "SKU销量报表",
  salesReportForWarehouse: "仓库销量报表",
  salesReportForPlatform: "平台销量报表",
  salesReportForCountry: "国家销量报表",
  salesReportForStore: "店铺销量报表",
  product_quantity_sold: "商品销售数量",
  Average_daily_sales: "平均每天销量",
  Product_name_in_Chinese_and_English: "商品中英文名",
  unsalableGoodsReport: "滞销商品报表",
  unsalable_days: "滞销天数",
  overdueList: "逾期列表",
  overdueDetailList: "逾期详情列表",
  customerDailyConsumptionFlow: "客户每日消费流水",
  customerMonthlyConsumptionFlow: "客户每月消费流水",
  commodityItemNumberReport: "商品件号报表",
  financialOperations: "财务运营报表",
  dailyBalance: "每日客户余额",
  shipmentReport: "发货量报表",
  warehouseShipmentReport: "仓库发货量报表",
  platformShipmentReport: "平台发货量报表",
  countryShipmentReport: "国家发货量报表",
  storeShipmentReport: "店铺发货量报表",
  orderPlacementReport: "下单量报表",
  warehouseOrderPlacementReport: "仓库下单量报表",
  platformOrderPlacementReport: "平台下单量报表",
  countryOrderPlacementReport: "国家下单量报表",
  storeOrderPlacementReport: "店铺下单量报表",
  Trend_chart: "趋势图",
  system_setting_overdue_time: "系统设置逾期时间",
  overdue_order_number: "逾期订单数量",
  overdue_data: "逾期日期",
  order_overdue_delivery_time: "订单逾期发货时间",
  order_delivery_time: "订单发货时间",
  Daily_cost_trend_chart: "每日费用趋势图",
  total_Daily_cost_trend_chart: "每日总费用趋势图",
  Total_cost: "总费用",
  clientShipmentReport: "客户发货量报表",
  warehouseDailyReport: "仓库日常报表",
  dailyOrderAllocationReport: "每日订单配货报表",
  monthlyOrderAllocationReport: "每月订单配货报表",
  dailyOrderSortReport: "每日订单分拣报表",
  monthlyOrderSortReport: "每月订单分拣报表",
  dailyOrderDeliverReport: "每日订单发货报表",
  monthlyOrderDeliverReport: "每月订单发货报表",
  task_finish_number: "完成任务数量",
  order_product_number: "订单商品数量",
  total_time_spent: "总耗时",
  order_count: "单量",
  dailyLogisticsReturnReceiptReport: "每日物流退货收货报表",
  dailyCustomerLogisticsReturnReceiptReport: "每日客户物流退货收货报表",
  dailyCustomeReturnGoodsReceiptReport: "每日客户退货商品收货报表",
  orderToBeReviewedOutOfStockReport: "待审核订单缺货商品报表",
  monthlyCustomeReturnGoodsReceiptReport: "每月客户退货商品收货报表",
  customerShippedQuantityByWarehouse: "客户发货量（仓库）",
  goodsSalesVolumeByTotalSku: "商品销量（SKU总计）",
  goodsSalesVolumeByWarehouse: "商品销量（仓库）",
  The_create_time_is_about_N_days: "创建时间近N天",
  Quantity_out_of_stock: "缺货数量",
  this_day: "当天",
  goodsOutOfStockReport: "商品缺货报表",
  out_of_stock_days: "缺货天数",
  out_of_stock_date: "缺货日期",
  dailyConsumptionFlow: "每日消费流水",
  monthlyConsumptionFlow: "每月消费流水",
  warehouse_hourly_uncleared_orders: "仓库每小时未清理订单",
  responsible_person: "负责人",
  total_unshipped_quantity: "未发货总量",
  total_shipped_quantity: "已发货总量",
  ratio: "比率",
  warehouse_hourly_shipping: "仓库每小时发货",
  total_order_quantity: "订单总量",
  outbound_count: "出库数量",
  orderTimelinessMonitoringTable: "订单时效监控表",
  hourlyShippingReport: "每小时发货报表",
  Packing_timeliness_rate: "打包时效率",
  monthlyOrderVolumeInvestmentPromotionOfficerReport: "招商员每月出单量报表",
  monthlyOrderVolumeInvestmentPromotionDepartmentReport: "招商部每月出单量报表",
  monthlyOrderVolumeCustomerReport: "客户每月出单量报表",
  monthlyOrderVolumeCountryReport: "国家每月出单量报表",
  monthlyOrderVolumeWarehouseReport: "仓库每月出单量报表",
  monthlyOrderVolumePlatformrReport: "平台每月出单量报表",
  investment_Promotion_Officer: "招商员",
  investment_Promotion_Department: "招商部",
  average_daily_order_volume: "日均单量",
  average_daily_proportion: "日均占比",
  total_order_volume: "总单量",
  total_order_volume_proportion: "总单量占比",
  number_of_newly_developed_customers: "新开发客户数量",
  the_total_order_volume_of_newly_developed_customers: "新开发客户单量",
  the_proportion_of_new_customer_orders: "新客户单量占比",
  Total_amount_of_inflow_outflow: "总出/入金额",

  // 打印标签
  only_100_order_numbers_are_supported_at_a_time: "一次仅支持100个单号",
  separated_by_newlines: "以换行隔开",
  get_label: "获取标签",
  get_success: "获取成功",
  printLabel: "打印标签",

  // 每日库存
  dailyInventory: "每日库存",
  record_date: "记录日期",
  inventory_grounding_time: "库存上架时间",
  daily_inventory_list: "每日库存列表",

  // 录像拍照列表
  deliveryTime: "出库时间",
  lastUpdateTime: "更新时间",
  completeTime: "完成时间",
  settleAccountsTime: "结算时间",
  stockId: "仓库",
  orderType: "类型",
  orderId: "单号",
  trackingNo: "运单号",
  referenceNo: "参考号",
  skuNum: "SKU*数量",
  fileUrl: "录像地址",
  video_storage_address: "录像存储地址",
  filePhotoUrl: "出库快照",
  createUserId: "出库人",
  starCreateTime: "开始出库时间",
  endCreateTime: "出库结束时间",

  // 仓内服务器存储空间信息
  totalStorageSpace: "总存储空间",
  usedStorageSpace: "已使用存储空间",
  remainingStorageSpace: "剩余存储空间",
  serverIP: "服务器IP",
  serverName: "服务器名字",
  warehouseServerPort: "端口",
  storageFilePath: "存储文件路径",
  addStorageSpaceServersWarehouse: "新增仓内服务器存储空间",
  editStorageSpaceServersWarehouse: "编辑仓内服务器存储空间",
  please_select_warehouse: "请选择仓库",
  please_select_serverIP: "请选择服务器IP",
  please_select_serverName: "请输入服务器名字",
  please_select_serverPort: "请输入服务器端口",

  // 订单-订单信息
  video_snapshot_information: "视频快照信息",

  // 授权店铺列表
  platformAuthorization: "平台授权",
  authorizedStoreList: "授权店铺",
  // 提示词条
  this_data_has_no_outbound_time: "此条数据无出库时间",
  please_choose_again: "请重新选择",
  total_cloud_server_storage_video_access_path: "总云服务器存储视频访问路径",
  total_cloud_server_storage_image_access_path: "总云服务器存储图片访问路径",
  total_cloud_server_storage_outbound_snapshot: "总云服务器存储出库快照",
  total_cloud_server_storage_video_address: "总云服务器存储录像地址",
  // 快速退货登记
  unpackRegisterReturnPackage: "登记到认领区",
  registerInClaimArea: "拆包裹登记退货",
  Please_select_the_quick_registration_type: "请选择快速登记类型",
  Change_storage_location: "更换库位",
  productId: "商品id",
  Please_select_the_product_details_first: "请先选择商品明细",
  basket_listing: "上架篮子",
  Please_enter_the_basket_for_listing: "请输入上架篮子",
  locationId: "库位Id",
  automatic_return_listing: "退货自动上架",
  Priority_Of_Listing_Scanning: "上架扫描优先级",
  not_automatically_listed: "不自动上架",
  shelf_return_warehouse_location: "上架至退货库位",
  registerList: "登记并上架",
  Is_the_qualified_quantity_0_saved_to_the_rejection_stage:
    "合格数量为0，是否保存至驳回阶段",
  Is_the_qualified_quantity_0_saved: "合格数量为0，是否保存",
  Please_upload_photo_of_the_package: "请上传包裹照片",
  The_actual_data_of_the_product_must_be_all_greater_than_0:
    "商品的真实数据必须全部大于0",
  Please_enter_the_qualified_and_unqualified_quantity: "请输入总数量",
  Please_select_the_billing_attribute_for_the_product: "请选择商品计费属性",
  Please_complete_the_selection_of_warehouse_location_number_first:
    "请先完成库位号选择",
  Multiple_products_please_select_multiple_SKU_types_and_location_numbers:
    "多个商品请选择多SKU类型库位号",
  Is_it_confirmed_that_there_is_a_difference_in_the_dimensions_of_the_three_sides_of_the_currently_inspected_product_compared_to_the_previous_inspected_product:
    "当前质检商品三边尺寸与之前质检的商品三边尺寸存在差异，是否确认",
  Is_it_confirmed_that_there_is_a_difference_between_the_actual_weight_of_the_current_quality_inspection_product_and_the_actual_weight_of_the_previous_quality_inspection:
    "当前质检商品真实重量与之前质检的真实重量存在差异，是否确认",
  The_qualified_quantity_cannot_exceed_the_total_quantity:
    "合格数量不能大于总数量",
  The_current_storage_location_is_a_single_SKU_storage_location_which_has_been_selected_by_other_products:
    "当前库位为单Sku库位，已被其他商品选择",

  // 退货库存管理
  batch_return_warehouse_relocation: "批量退货库位移库",
  automatically_print_the_inventory_transfer_list: "自动打印移库清单",
  print_the_inventory_transfer_list: "打印移库清单",
  view_SKU_transaction_history: "查看SKU流水",
  Inventory_transfer_task_ID: "移库任务ID",
  print_list: "打印清单",
  // 仓库收支报表
  commodity_income: "商品收入",
  refund_fee: "退款费用",
  shippingFee: "运费支出",
  shippingIncomFee: "运费收入",
  discountFee: "折扣总计",
  serviceFee: "服务费用",
  commissionFee: "佣金",
  taxFee: "税",
  advertisingFee: "广告费用",
  paymentFee: "支付手续费",
  warehousePackingFee: "仓库打包费用",
  otherFee: "其它收支",
  orderIncomeFee: "订单收入",
  platformName: "平台名称",
  FinancialRecognition: "财务确认",
  Pending_warehouse_transfer: "待移仓",
  To_be_received: "待接收",
  convertToWaitingForReception: "转为待接收",
  Please_enter_the_warehouse_location_number: "请输入库位号",
  Please_choose_to_add_SKU: "请添加sku",
  returnInventoryQuantity: "退货库存数量",
  controlTime: "控制时间",
  Transfer_of_warehouse_completed: "已移仓",
  Revoked: "已撤销",
  The_current_warehouse_type_is_shelf_to_return_location_Please_select_a_new_warehouse:
    "当前仓库类型为上架至退货库位，请重新选择仓库",
  recommended_shelf_location: "推荐上架库位",
  Is_the_measurement_size_correct: "测量尺寸是否正确",
  Please_add_SKU: "请添加SKU",
  Currency_for_profit_calculation: "利润计算币种",
  Order_delivery_time: "订单出库时间",
  Last_update_time: "最后更新时间",
  operatorUserId: "操作用户",
  total_inventory_batch: "当前批次总库存",
  Please_select_the_recommended_storage_location_for_listing:
    "请选择推荐上架库位",
  Please_select_the_data_that_needs_to_be_transferred_to_the_warehouse_first:
    "请先选择需要移库数据",
  Import_inventory_list: "导入库存列表",
  Return_warehouse_location_Return_pending_review: "退货库位退货待审核",
  Inventory_transfer_task_removal_flow: "移库任务下架流水",
  The_inventory_quantity_for_the_return_warehouse_relocation_cannot_be_0:
    "退货库位移库的库存数量不能为0",
  The_current_return_order_is_marked_as_abandoned_by_the_customer_and_will_be_automatically_discarded_after_saving:
    "当前退件单客户标记为废弃，保存后将自动废弃",
  Final_order_placement_time: "最后拉单时间",
  Last_updated_listing_time: "最后更新Listing时间",
  Product_SKU: "商品SKU",
  sales_volumes: "销售数量",
  Platform_settlement_amount: "平台结算金额",
  Order_product_sales_revenue: "订单商品销售额",
  Cost_of_goods: "商品成本",
  merchandise_procurement_cost: "商品采购成本",
  First_leg_freight: "头程运费",
  Platform_shipping_fee: "平台运费",
  Actual_shipping_cost: "实际运费",
  The_buyer_pays_the_shipping_fee: "买方支付运费",
  Platform_freight_subsidy: "平台运费补贴",
  Revenue_from_3PL_freight_refund: "3PL运费返还收入",
  Platform_fees: "平台费用",
  Platform_commission: "平台佣金",
  Alliance_commission: "联盟佣金",
  Transaction_fee: "交易费",
  Platform_activity_expenses: "平台活动费用",
  Additional_plan_service_fee: "额外计划服务费",
  threePL_insurance_premium: "3PL保险费",
  Seller_pays_cross_border_tax: "卖家支付跨境税",
  Freight_service_tax_SST: "运费服务税SST",
  Withholding_tax: "预扣税",
  Overseas_return_service_fee: "海外退货服务费",
  Value_added_tax_VAT: "增值税（VAT）",
  Product_and_Service_Tax: "产品服务税",
  Coupons_Discounts: "优惠券&折扣",
  Seller_Coupons: "卖家优惠券",
  Shopee_discount: "Shopee折扣",
  Shopee_coin_deduction: "Shopee金币抵扣",
  Shopee_discount_return: "Shopee折扣返回",
  refund_amount: "退款金额",
  Other_platform_expenses: "平台其他费用",
  place_an_order_time: "下单时间",
  createTime: "下单时间",
  Refund_product_amount: "退款商品金额",
  updateTime: "更新时间",
  Original_price_of_the_product: "商品原价",
  merchandise_discount: "商品折扣",
  Sellers_product_discount: "卖家商品折扣",
  Shopee_Coupons: "shopee优惠券",
  Shopee_coin_exchange: "shopee币兑换",
  The_buyer_pays_the_transaction_fee: "买方支付交易手续费",
  The_buyer_pays_the_total_amount: "买方支付总金额",
  Estimated_shipping_cost: "预估运费",
  The_seller_bears_the_shipping_cost: "卖家承担运费",
  Platform_compensation_amount: "平台赔偿金额",
  Service_fees_charged_for_participating_in_the_sellers_free_shipping_plan:
    "参加卖家免运费计划收取的服务费",
  Order_reverse_shipping_service_tax_shipping_service_tax:
    "订单反向运费服务税+运费服务税",
  SG_Goods_and_Services_Tax_MY_LVG_Goods_Ta: "SG商品及服务税/MY LVG商品税",
  Cross_border_goods_tax_logistics_clearance_service_fees_service_tax_on_low_value_goods_imported_from_Singapore_anti_dumping_duty_on_imported_goods:
    "跨境货物征收税+物流商清关服务收取费用+进口新加坡低价值商品征收服务税+进口商品征收的反倾销税",
  The_amount_of_fees_charged_to_the_seller_for_failure_to_deliver_the_order:
    "因未能配送订单而向卖家收取的费用金额",
  Return_order_return_shipping_fee: "退货订单退回运费",
  refundShippingSubsidyFee: "退货运费险收入",
  Compensation_provided_by_the_platform_for_lost_or_damaged_packages:
    "由于包裹丢失、损坏等平台给与的赔偿",
  Import_of_MY_low_value_goods_subject_to_service_tax:
    "进口MY低价值商品征收服务税",
  Profit_margin_Profit_Order_payment_for_product_amount_Financial_currency_exchange_rate:
    "利润率=利润 ÷（订单支付商品金额×财务币种汇率）",
  Charges_incurred_for_packages_requiring_signature_confirmation_services:
    "需要签名确认服务的包裹产生的费用",
  Profit_Order_paid_product_amount_Actual_shipping_fee_Buyer_paid_shipping_fee_Platform_shipping_subsidy_3PL_shipping_fee_refund_income_Commission_Alliance_commission_Transaction_fee_Service_fee_Platform_activity_fee_Additional_planned_service_fee_3PL_insurance_fee_Seller_paid_cross_border_tax_Shipping_service_tax_SST_Withholding_tax_Overseas_return_service_fee_Value_added_tax_VAT_Product_service_tax_Seller_discount_coupon_Shopee_discount_Shopee_gold_coin_deduction_Shopee_discount_refund_Refund_product_amount_Return_order_return_shipping_fee_Return_shipping_insurance_income_Platform_other_fees_Order_adjustment_amount_x_Financial_currency_exchange_rate_Product_procurement_cost_First_leg_shipping_fee_Warehouse_rental_Listing_fee_Order_processing_fee:
    "利润=(订单支付商品金额- 实际运费+买家支付运费+平台运费补贴+3PL运费返还收入-佣金-联盟佣金-交易费-服务费-平台活动费用-额外计划服务费-3PL保险费-卖家支付跨境税-运费服务税SST-预扣税-海外退货服务费-增值税（VAT）-产品服务税-卖家优惠卷-Shopee折扣-Shopee金币抵扣+Shopee折扣返还-退款商品金额-退货订单退回运费+退货运费险收入-平台其它费用+订单调整金额)×财务币种汇率-(商品采购成本+头程运费+仓租+上架费+订单处理费)",
  Profit_Order_payment_for_product_amount_Actual_Freight_Buyer_Paid_Freight_Platform_Freight_Subsidy_3PL_Freight_Return_Revenue_Commission_Alliance_Commission_Transaction_Fee_Service_Fee_Platform_Activity_Fee_Additional_Plan_Service_Fee_3PL_Insurance_Fee_Seller_Paid_Cross_border_Tax_Freight_Service_Tax_SST_Withholding_Tax_Overseas_Return_Service_Fee_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupon_Shopee_Discount_Shopee_Gold_Coin_Deduction_Shopee_Discount_Return_Refund_Product_Amount_Return_Order_Return_Freight_Return_Freight_Insurance_Income_Platform_Other_Fees_Financial_Currency_Exchange_Rate_Product_Procurement_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:
    "利润=(订单支付商品金额- 实际运费+买家支付运费+平台运费补贴+3PL运费返还收入-佣金-联盟佣金-交易费-服务费-平台活动费用-额外计划服务费-3PL保险费-卖家支付跨境税-运费服务税SST-预扣税-海外退货服务费-增值税（VAT）-产品服务税-卖家优惠卷-Shopee折扣-Shopee金币抵扣+Shopee折扣返还-退款商品金额-退货订单退回运费+退货运费险收入-平台其它费用)×财务币种汇率-(商品采购成本+头程运费+仓租+上架费+订单处理费)",
  Profit_Order_payment_for_product_amount_actual_shipping_cost_buyer_paid_shipping_cost_platform_shipping_subsidy_seller_bears_shipping_cost_seller_discount_coupon_gold_coin_deduction_platform_discount_subsidy_commission_product_service_tax_platform_activity_fee_installment_payment_handling_fee_advertising_fee_payment_handling_fee_platform_compensation_amount_platform_other_fees_refunded_product_amount_return_order_return_shipping_cost_Exchange_rate_product_procurement_cost_first_leg_shipping_cost_warehouse_rental_shelving_fee_order_processing_fee:
    "利润=（订单支付商品金额-实际运费+买家支付运费+平台运费补贴-卖家承担运费-卖家优惠卷-金币抵扣+平台优惠补贴-佣金-产品服务税-平台活动费-分期付款手续费-广告费用-支付手续费+平台赔付金额+平台其它费用-退款商品金额-退货订单退回运费）*汇率-（商品采购成本+头程运费 +仓租+ 上架费 + 订单处理费）",
  Profit_Discounted_product_subtotal_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Coupon_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Commission_Exchange_Rate_Product_Purchase_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:
    "利润=（折后商品小计-退款-实际运费+卖家支付运费+平台运费补贴-换货运费-卖家运费折扣-TSP佣金-平台佣金-联盟佣金-交易费用-SFP服务费-服务费-额外计划服务费-物流保险费-运费服务税SST-增值税（VAT）-产品服务税-卖家优惠卷-退件订单运费-平台其它费用-信用卡支付手续费+平台调整金额-生态捐款-手续费）*汇率-（商品采购成本+头程运费 +仓租+ 上架费 + 订单处理费）",
  storeCurrency: "店铺币种",
  escrowCurrency: "财务币种",
  exchangeRate: "财务币种汇率",
  income_expenditure_information: "收支信息",
  expense_item: "费用项目",
  revenue_expenditure: "收支",
  Take_the_actual_bill_and_the_buyer_pays_the_shipping_fee:
    "取实际账单买家支付运费",
  percent: "占比",
  Order_payment_for_product_amoun: "订单支付商品金额",
  The_last_update_time_of_profit_and_expense_data_automatically_updated_when_platform_orders_change_or_settle:
    "利润费用数据最后更新的时间，平台订单变动或者结算时自动更新",
  Take_the_settlement_time_of_the_order_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_When_the_settlement_time_is_empty_it_means_that_the_platform_has_not_ended_yet:
    "取订单结算时间，非平台订单的结算时间取订单移入【完成】状态的时间，结算时间为空时代表平台未结束",
  Take_the_final_settlement_time_of_the_order_Payment_Period_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet:
    "取订单最后结算的时间(Payment Period)，非平台订单的结算时间取订单移入【完成】状态的时间，结算时间为空时代表平台未结束",
  Take_the_final_settlement_date_of_the_order_Settlement_Date_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet:
    "取订单最后结算的时间(Settlement Date)，非平台订单的结算时间取订单移入【完成】状态的时间，结算时间为空时代表平台未结束",
  The_system_calculates_the_estimated_settlement_amount_of_the_order_based_on_the_income_of_the_order_platform_fees_minus_the_expenditure_of_the_order_platform_fees_Please_compare_and_verify_it_with_the_settlement_amount_of_the_platform:
    "系统根据订单平台费用收入-订单平台费用支出核算出订单的预估结算金额，请和平台结算金额比对核验",
  Estimated_settlement_amount: "预估结算金额",
  The_order_payment_completion_time_the_time_when_the_funds_have_been_transferred_is_recorded_For_non_platform_orders_the_settlement_time_is_determined_by_the_moment_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_blank_it_indicates_that_the_platform_has_not_finalized_the_order:
    "取订单打款完成时间(款项已完成转账)，非平台订单的结算时间取订单移入【完成】状态的时间，结算时间为空时代表平台未结束",
  The_time_when_the_platform_status_of_the_order_changes_to_Competed_Cancelled:
    "订单的平台状态变为Competed/Cancelled的时间",
  Retrieve_the_system_order_outbound_time: "取系统订单出库时间",
  Seller_bears_the_shipping_cost_actual_shipping_cost_buyer_pays_the_shipping_cost_platform_shipping_subsidy_3PL_shipping_cost_refund_income_not_included_in_order_profit_calculation_for_operational_analysis_reference_only:
    "卖家承担运费=实际运费-买家支付运费-平台运费补贴-3PL运费返还收入(不参与订单利润计算,仅供运营分析参考)",
  time_filtering: "时间筛选",
  Exchange_rate_setting_System_settings_Currency_exchange_rate_Currency_exchange_rate_list:
    "汇率设置：系统设置--币种汇率--币种汇率列表；",
  The_system_converts_the_original_currency_of_the_store_into_the_financial_currency_for_profit_based_on_the_exchange_rate:
    "系统根据汇率将店铺原始币种换算成利润财务币种；",
  When_the_currency_exchange_rate_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day:
    "当未设置币种汇率时，系统将不执行数据同步，设置后会在当天24点后同步数据。",
  deduction_currency_value_system_settings_Currency_exchange_rate_Exchange_rates_in_the_currency_exchange_rate_list_Record_the_exchange_rate_when_obtaining_the_order_revenue_and_expenditure_for_the_first_time_and_do_not_update_the_exchange_rate_value_in_the_profit_afterwards_When_the_currency_exchange_rate_is_not_set_it_defaults_to_0_When_the_exchange_rate_value_can_be_obtained_in_subsequent_automatic_updates_it_will_be_updated:
    "店铺币种转换财务扣款币种，取值 系统设置➡币种汇率➡币种汇率列表中的汇率,当第一次获取到订单收支时记录汇率，后续不更新利润中的汇率值,当未设置币种汇率时默认计0,后续自动更新时能获取到汇率值时更新",
  Please_set_the_conversion_exchange_rate_between_the_relevant_store_currency_and_the_financial_deduction_currency_which_will_be_used_for_calculating_order_profit_report_data:
    "请设置相关店铺币种与财务扣款币种转换汇率，将用于订单利润报表数据计算",
  Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only:
    "不参与订单利润计算，仅供运营分析参考",
  The_actual_settlement_amount_on_the_platform_is_not_included_in_the_calculation_of_order_profits_and_is_only_for_operational_analysis_reference:
    "平台实际结算金额，不参与订单利润计算，仅供运营分析参考",
  The_procedures_for_sellers_to_participate_in_the_PayLater_program_and_receive_fees:
    "卖家参与PayLater计划收取的手续",
  Freight_subsidies_and_rewards_provided_by_the_platform_Freight_subsidies_provided_by_the_platform_for_sellers_to_ship_Delivery_rewards_obtained_by_sellers_signing_a_joint_sponsorship_free_delivery_plan:
    "平台提供的运费补贴和奖励+平台为卖家发货提供的运费补贴+卖家签署共同资助免费送货计划而获取的送货奖励",
  billID: "账单ID",
  Deduct_a_20_refund_management_fee_from_the_total_amount_of_returned_items:
    "从退回的退件费总额中扣除20%的退款管理费",
  Service_fees_charged_for_participating_in_on_site_special_programs_service_fees_charged_for_participating_in_bonus_rebates_service_fees_charged_for_using_Tiktok_Mall_servers_charged_for_participating_in_coupon_plans_service_fees_charged_for_participating_in_limited_time_rush_purchase_service_fees_charged_for_promotional_activities_service_fees_charged_for_pre_purchase_plans:
    "参加现场特别节目收取的服务费+参加奖金返现收取的服务费+使用抖音商城收取的服务费+参加代金卷计划收取的服务器+参加限时抢购收取的服务费+促销活动收取的服务费+预购计划收取的服务费",
  difference_amount: "差异金额",
  bill_type: "账单类型",
  recalculateTime: "重算账单时间",
  Please_fill_in_the_task_number_first: "请先填写任务编号",
  Payment_time: "出账时间",
  part_number: "件号",
  The_commission_paid_by_the_seller_to_the_creator_alliance_advertising_commission_commission_purchased_through_partner_links_eligible_advertising_order_commission:
    "卖家支付给创作者的佣金+联盟广告佣金+通过合作伙伴链接购买的佣金+符合条件的广告订单佣金",

  Please_enter_SKU_line_break_or_comma_separated: "请输入SKU，换行或逗号隔开",
  Recalculate_warehouse_rental_fees: "重算仓租费",
  Recalculate_manual_outbound_fees: "重算手工出库费",
  Recalculate_manual_warehousing_fees: "重算手工入库费",
  Recalculate_the_return_item_listing_fee: "重算退件上架费",
  Recalculate_storage_fees: "重算入库费",
  Recalculate_storage_order_operation_fees: "重算仓储订单操作费",
  Please_select_the_delivery_time: "请选择出库时间",

  // 按模板设置费用
  Copy_the_expense_settings_to_the_specified_warehouse:
    "复制费用设置到指定仓库",
  Specify_the_customer: "指定客户",
  Customers_who_need_to_be_copied: "需要复制的客户",
  If_you_do_not_select_it_it_means_that_all_customers_are_selected:
    "若不选，则代表选择全部客户",
  Exclude_customers: "排除客户",
  Excluded_customers: "排除的客户",
  Specify_the_warehouse: "指定仓库",
  The_warehouse_that_was_copied: "被复制的仓库",
  Template_warehouse: "模板仓库",
  Specify_the_warehouse_from_which_the_data_originated: "指定数据来源的仓库",
  If_it_is_empty_it_is_equivalent_to_the_specified_warehouse:
    "若为空，则等于指定仓库",
  Template_customers: "模板客户",
  Generate_the_header_fee_settings_according_to_the_specified_template:
    "按照指定模板生成头程费用设置",
  The_type_of_expense: "费用类型",
  Order_Processing_Fees: "订单处理费",
  Warehouse_rental_fee: "仓租费",
  Labelling_fee: "贴标费",
  Head_fee: "头程费",
  Packaging_material_fee: "包材费",
  Please_select_a_specified_warehouse: "请选择指定仓库",
  Configure_at_least_one_item: "请至少配置一项",
  Adjust_the_price_of_the_first_leg_in_batches: "批量调整头程价格",
  Freight_costs: "运费成本",
  OverRange_shipping_rates: "超范围运费",
  On_the_basis_of_the_original_treatment_the_positive_number_increases_the_price_and_the_negative_number_decreases_the_price:
    "在原基础上进行处理，正数涨价，负数降价",
  Copy_additional_service_fees: "复制增值服务费用",
  Specify_the_customer_from_which_the_data_originated: "指定数据来源的客户",
  Please_select_a_module_type: "请选择模块类型",
  copy_approval_template: "复制审批模板",
  copy_template: "复制模板",
  replace_approver: "替换审批人",
  Original_approver: "原审批人",
  Approver: "审批人",
  Please_select_the_module_type_first: "请先选择模块类型",
  Please_select_the_task_stage: "请选择任务阶段",
  Please_select_the_valueAdded_type: "请选择增值类型",
  Please_select_a_template_customer: "请选择模板客户",
  Please_select_a_template_warehouse: "请选择模板仓库",

  // 个人中心
  modify_information: "修改信息",
  receiving_SMS_number: "接收短信号码",
  early_warning_balance: "预警余额",
  whether_to_receive_SMS_messages: "是否接收短信",
  Not_less_than_zero: "不可小于0",
  wechat_binding_status: "微信绑定状态",
  get_qrcode: "获取二维码",
  untie: "解绑",
  refresh_binding_status: "刷新绑定状态",
  bound: "已绑定",
  not_yet_bound: "未绑定",
  whether_to_untie: "是否解绑",

  // 公众号推送日志列表
  officialAccountPushLogs: "公众号推送日志列表",
  The_type_of_message: "消息类型",
  Push_status: "推送状态",
  Push_customers: "推送客户",
  Push_content: "推送内容",
  Push_time: "推送时间",
  Push_the_OpenID: "推送OpenID",
  creator: "创建人",
  The_push_succeeded: "推送成功",
  Push_failed: "推送失败",

  // 批量创建子账号
  Please_enter_a_name_for_the_subAccount: "请输入子账号名称",
  Please_enter_your_mobile_phone_number: "请输入手机号",
  Please_select_a_role: "请选择角色",
  Please_select_Enable_status: "请选择启用状态",
  role: "角色",
  roleGrade: "角色等级",
  Enabled_status: "启用状态",
  The_name_of_the_subAccount: "子账号名称",
  Mobile_phone_number: "手机号",
  mailbox: "邮箱",
  Confirm_your_password: "确认密码",
  The_warehouse_to_which_it_belongs: "所属仓库",
  Transit_warehouses: "中转仓库",
  Select_all: "全选",
  operate: "操作",
  Delete: "删除",
  Please_enter_your_password: "请输入密码",
  Please_enter_your_password_correctly_first: "请先正确输入密码",
  Please_enter_your_confirmation_password: "请输入确认密码",
  The_password_entered_twice_is_inconsistent: "两次输入的密码不一致",
  This_is_used_to_restrict_the_account_to_only_be_able_to_select_the_next_lower_role_level_when_creating_or_modifying_employee_accounts_during_operations_based_on_the_current_account_is_role_level:
    "用于限定账号在操作创建/修改员工账号时，仅能选择当前账号角色等级的下一级角色",

  // 入库
  Modify_the_quality_inspection_quantity: "修改质检数量",
  When_there_is_a_labeled_quantity_prioritize_the_fee_deduction_and_the_refund_of_the_labeling_fee_to_avoid_double_deductions:
    "当存在已贴标数量时，请优先处理费用补扣和返还贴标费用，以避免重复扣费",
  Please_enter_your_inquiry: "请输入查询内容",
  Please_select_the_level_3_data_you_want_to_modify: "请勾选要修改的三级数据",
  Select_the_data_in_the_same_task: "请勾选同一任务下的数据",
  The_number_of_quality_inspections_cannot_be_greater_than_the_number_of_appointments:
    "质检数量不能大于预约数量",
  The_number_of_labels_cannot_be_greater_than_the_qualified_quantity:
    "贴标数量不能大于合格数量",
  There_is_a_labeled_quantity: "存在已贴标数量",
  Whether_to_continue: "是否继续",
  The_operation_was_canceled: "已取消操作",
  Please_check_the_secondary_data: "请勾选二级数据",
  Please_check_the_boxes_under_the_same_shipping_list:
    "请勾选同一个入库单下的箱子",
  Please_select_the_products_in_the_same_task: "请勾选同一个任务下的产品",
  Please_check_only_one_task: "请只勾选一个任务",
  Please_tick_the_box: "请勾选",
  Please_check_only_one_inbound_order: "请只勾选一个入库单",
  Please_check_the_Inbound_List_or_Inbound_List_box: "请勾选入库单或入库单箱子",
  operation_cancelled: "已取消操作",
  Complete_quality_inspection_in_batches: "批量完成质检",
  The_quantity_to_be_inspected: "待质检数量",
  The_quantity_has_been_inspected: "已质检数量",
  sku: "sku",
  inspected_quantity: "已质检数量",
  labelled_quantity: "已贴标数量",
  actual_length_cm: "实际长度(CM)",
  actual_width_cm: "实际宽度(CM)",
  actual_height_cm: "实际高度(CM)",
  actual_weight_kg: "实际重量(KG)",
  commodity_billing_attribute: "商品计费属性",
  Confirm_quality_inspection_information: "确认质检信息",
  No_need_for_confirmation: "无需确认",
  to_be_confirmed: "等待确认",
  acknowledged: "已确认",
  Quality_inspection_information_status: "质检信息状态",
  Confirm_the_actual_weight_length_width_height_and_whether_the_billing_attributes_of_the_goods_are_correct:
    "确认实际重量，长宽高，商品计费属性是否正确",
  Please_verify_the_actual_weight_dimensions_length_width_height_and_the_billing_attributes_of_the_goods_to_prevent_any_abnormal_deductions_of_fees:
    "请确认实际重量，长宽高，商品计费属性是否正确，防止扣费异常",
  Please_input_inspection_quantity: "请输入质检数量",
  please_input_unqualified_quantity: "请输入不合格数量",
  please_input_labeled_quantity: "请输入贴标数量",
  please_input_positive_number: "请输入正数",
  please_input_qualified_quantity: "请输入合格数量",
  please_select_is_there_a_mark: "请选择是否有标",
  please_input_actual_length: "请输入实际长度",
  please_input_actual_width: "请输入实际宽度",
  please_input_actual_height: "请输入实际高度",
  please_input_actual_weight: "请输入实际重量",
  please_select_commodity_billing_attribute: "请选择商品计费属性",
  please_input_quantity: "请输入数量",
  appointment_quantity: "预约数量",
  whether_to_go_to_configure_warehouse_inbound_task_control_settings:
    "是否前往配置仓库入库获取任务控制设置?",
  please_check: "请勾选",
  inspection_quantity_cannot_exceed_reserved_quantity:
    "质检数量不能大于预约数量",
  labeled_quantity_cannot_exceed_qualified_quantity: "贴标数量不能大于合格数量",
  box_number: "箱号",
  special_commodity_confirm: "特殊商品，是否确认？",
  box_number_error_please_reenter: "箱号有误请重新输入",
  please_input_box_number: "请输入箱号",
  please_input_goods_code: "请输入商品条码",
  current_box_number_no_goods_code: "当前箱号不存在该商品条码",
  duplicate_sku_box_number: "出现重复SKU箱号",
  operation_successful: "操作成功",
  product_entry_number: "入库单号",
  product: "产品",
  has_labeled_quantity_continue: "存在已贴标数量，是否继续?",
  please_input_real_length: "请输入实际长度",
  please_input_real_width: "请输入实际宽度",
  please_input_real_height: "请输入实际高度",
  please_input_real_weight: "请输入实际重量",
  real_length_cm: "实际长度 (CM)",
  real_width_cm: "实际宽度 (CM)",
  real_height_cm: "实际高度 (CM)",
  real_weight_kg: "实际重量 (KG)",
  commodity_chinese_name: "中文名称",
  commodity_english_name: "英文名称",
  labeled_quantity: "已贴标数量",
  this_time_labeled_quantity: "本次贴标数量",
  There_is_an_incorrect_location_number: "存在错误库位号",
  Please_fill_it_out: "请填写",
  shelved_quantity: "已上架数量",
  recommended_storage_location_number: "推荐库位号",
  reserved_commodity_quantity: "预约商品数量",
  Task_time: "任务时间",
  set_priority_quality_inspection: "设置优先质检",
  pause_task: "暂停任务",
  activate_task: "激活任务",
  modify_quality_inspection_num: "修改质检数量",
  to_be_generated: "待生成",
  uncompleted: "未完成",
  paused: "已暂停",
  Rebinding_task: "换绑任务",
  Mandate_Holder: "任务执行人",
  task_id: "任务ID",
  customer_id: "客户ID",
  task_executor: "任务执行人",
  task_quality_inspection_start_time: "任务质检开始时间",
  task_quality_inspection_end_time: "任务质检结束时间",
  total_reserved_quantity: "总预约数量",
  total_qualified_quantity: "总合格数量",
  total_unqualified_quantity: "总不合格数量",
  is_task_paused: "是否暂停任务",
  is_priority_quality_inspection: "是否优先质检",
  Rebinding: "换绑",
  is_excess_quality_inspection_task: "是否为超额质检任务",
  reserved_quantity: "预约数量",
  excess_quantity: "多发数量",
  lack_send_quantity: "少发数量",
  breakage_quantity: "破损数量",
  is_wrongly_sent_sku: "是否为错发SKU",
  Please_select_the_assignee: "请选择任务执行人",
  original_qualified_quantity: "原合格数量",
  original_labeled_quantity: "原贴标数量",
  original_lack_send_quantity: "原少发数量",
  original_breakage_quantity: "原破损数量",
  please_select: "请勾选",
  confirm_operation: "确认操作?",
  prompt: "提示",
  cancel: "取消",
  set_priority_shelves: "设置优先上架",
  total_shelved_quantity: "总上架数量",
  is_priority_shelves: "是否优先上架",
  batch_complete_shelves: "批量完成上架",
  shelves_layer: "货架层数",
  shelves_column: "货架列数",
  shelves_cube: "容量",
  Mark_the_number_of_anomalies: "标记异常数量",
  Please_enter_a_valid_number: "请输入有效的数字",
  Please_enter_an_integer_greater_than_0: "请输入大于0的整数",
  The_current_row_data_is_abnormal_The_qualified_quantity_cannot_be_less_than_the_quantity_that_has_been_put_on_the_shelves:
    "当前行数据异常，合格数量不能小于已上架数量",
  The_abnormal_quantity_cannot_exceed: "异常数量不能大于",
  Exchange_shipping_fee: "换货运费",
  Seller_shipping_discount: "卖家运费优惠",
  TSP_commission: "TSP佣金",
  Transportation_insurance_premium: "运输保险费",
  Credit_card_payment_processing_fee: "信用卡支付手续费",
  SFP_service_fee: "SFP服务费",
  Ecological_donation: "生态捐款",
  Transportation_Service_Tax_SST: "运输服务税SST",
  Platform_adjustment_amount: "平台调整金额",
  TikTok_Coupons: "TikTok优惠券",
  TikTok_product_discounts: "TikTok商品折扣",
  Add_multiple_SKU: "添加多发SKU",
  Add_wrongly_sent_SKU: "添加错发SKU",

  // 服务
  preview_file: "预览文件",
  all_file_number: "文件总数量",
  can_preview_file_number: "可预览文件数量",
  can_not_preview_file_number: "不可预览文件数量",
  current_preview_file: "当前预览文件",
  download_all: "全部下载",
  download_file: "下载文件",
  upload_file: "上传文件",
  add_type_of_value_added_expense: "添加增值费用类型",
  type_of_value_added: "增值类型",
  revocation_time: "撤销时间",
  can_preview: "可预览",
  can_not_preview: "不可预览",
  task_phase: "任务阶段",
  customer_file: "客户文件",
  view_file: "查看文件",
  warehouse_file: "仓库文件",
  a: "个",
  freight: "运费",
  special_expense: "特殊费用",
  revocation_operator: "撤销人",
  accomplish_operator: "完成人",
  confirm_audit: "确认审核",
  return_to_be_audit: "退回待审核",
  filename: "文件名",
  value_added_task_id: "增值任务ID",
  whether_to_submit: "是否提交",
  cancelled_operation: "已取消操作",
  transfer_inventory_customer: "转移库存客户",
  whether_to_audit: "是否审核",
  whether_to_return_to_be_audit: "是否退回待审核",
  only_can_upload: "只能上传",
  file_and_not_more_than_300_MB: "文件，且不超过300MB",
  file_and_not_more_than: "文件，且不超过",
  add_expense_item: "添加费用项",
  add_settings_of_value_added_expense: "添加增值费用设置",
  default_expense: "默认费用",
  valueAddedServiceTask: "增值服务任务",
  operateValueAddedServiceTask: "操作增值服务任务",
  valueAddedServiceTaskDetail: "增值服务任务详情",
  valueAddedServiceFee: "增值服务费",
  valueAddedServiceList: "增值服务列表",
  approverList: "审批人列表",
  approvalProcesstemplate: "审批流程模板",
  Import_the_approval_process_template: "导入审批流程模板",
  SKU_Inventory_Transfer: "SKU库存转移",
  Full_Inventory: "全部库存",
  Transfer_the_entire_inventory_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_in_all_warehouses_After_the_task_is_completed_the_product_barcode_and_SKU_will_have_a_suffix:
    "将转移对应SKU在系统中的所有仓库的库存至对应的客户。任务完成后，商品条码及SKU将增加后缀",
  Partial_Inventory: "部分库存",
  Transfer_the_specified_quantity_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_Re_labeling_is_required:
    " 将转移对应SKU在系统中的指定数量的库存至对应的客户。需要重新贴标。",
  Label_Removal: "撕标签",
  Common_scenarios_include_removing_the_specified_barcode_from_the_product_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing:
    "常用场景，撕掉商品上指定的条码。根据处理的难易度，仓库会重新对此任务进行定价",
  Replace_Product_Barcode: "更换商品条码",
  Replace_the_barcode_on_the_product_with_the_system_barcode_Common_scenarios_include_incorrect_barcode_content_mismatch_with_system_settings_damaged_barcode_stained_barcode_and_aged_barcode_that_cannot_be_recognized:
    "将商品上的条码替换成系统的条码。常用场景,商品条码内容错误，与系统设置内容不相符合，商品条码破损，受到污渍浸染，商品条码老化无法识别。",
  Replace_Other_Labels_on_Products: "更换商品上的其它标签",
  Replace_the_labels_on_products_according_to_requirements_If_the_processing_is_complex_please_describe_it_clearly_or_provide_detailed_information_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing:
    "根据要求处理替换商品上的标签。如果处理复杂，请描述清晰，或者提供详细的资料。根据处理的难易度，仓库会重新对此任务进行定价。",
  Processing: "加工",
  Common_scenarios_include_processing_the_packaging_box_bubble_wrap_and_specified_products_transported_to_the_warehouse_If_it_is_complex_please_provide_a_detailed_operation_process_It_can_be_created_together_with_the_creation_of_the_inventory_receipt_or_added_as_a_value_added_service_before_the_inventory_receipt_starts_inspection:
    "常用场景：将运输至仓库的包装盒，气泡膜与指定的商品进行加工处理。如果较为复杂，请提供详细的操作流程。可在创建入库单时一同创建，或者入库单未开始质检前添加增值服务。",
  Assembly: "组装",
  Common_scenarios_include_assembling_multiple_products_into_a_new_product_or_multiple_assemblies_of_products_and_adjusting_the_inventory_for_corresponding_shelf_up_and_shelf_down_operations_after_assembly_If_there_are_complex_assembly_operations_please_provide_detailed_explanations_and_example_files:
    "常用场景：将多个商品组装成一个新的产品，或者将商品进行多次组装，组装后库存会进行相对应的上下架调整。如果存在较复杂的组装操作，请详细说明，提供详细的示例文件。",
  transfer_customer_id: "转移客户ID",
  Transfer_inventory_to_use_current_label: "转移库存是否使用当前标签",
  If_selected_the_product_barcode_of_the_transferred_party_will_be_changed_to_the_current_SKU_barcode_If_not_selected_the_product_barcode_of_the_transferred_party_will_remain_unchanged:
    "选择是，转移库存后被转移方的商品条码将变成当前SKU的条码。选择否，被转移方商品条码不变",
  file: "文件",
  select_inventory: "选择库存",
  Save_and_Submit: "保存并提交",
  greater_than_0_number: "大于0的数",
  batch_submit: "批量提交",
  batch_return_to_be_audit: "批量退回待审核",
  batch_revoke: "批量撤销",
  batch_confirm: "批量确认",
  Confirm_revoke: "是否确认撤销?",
  The_remarks_are_the_same_as_the_original: "备注与原备注相同",
  task_info: "任务信息",
  Audit_flow: "审核流程",
  Joint_approval: "联合审批",
  Single_approval: "单独审批",
  Process_flow: "处理流程",
  Module_type: "模块类型",
  processing: "处理中",
  add_flow: "添加流程",
  edit_flow: "编辑流程",
  select_auditor: "选择审核人",
  Audit_details: "审核详情",
  Approval_level: "审批层级",
  approver_Type: "审批类型",
  comfirm_delete: "确认删除?",
  please_set_audit_flow: "请设置审核流程",
  valueAddedServiceFeeDetail: "增值服务费详情",
  addValueAddedServiceTask: "创建增值服务任务",
  expense_deduction_details: "费用补扣明细",
  createValueAddedServiceTask: "创建增值服务任务",
  editValueAddedServiceTask: "编辑增值服务任务",
  create_Task: "创建任务",
  set_Audit_Flow: "设置审核流程",
  return_Audit_Flow: "撤销审核流程",
  batch_confirm_audit: "批量确认审核",
  set_process_flow: "设置处理流程",
  return_process_flow: "撤销处理流程",
  batch_complete_task: "批量完成任务",
  Edit_price: "编辑价格",
  Joint_audit: "联合审核",
  Single_audit: "单独审核",
  add_approver: "添加审核人",
  print_task: "打印任务",
  view_audit_process: "查看审核流程",
  view_process_flow: "查看处理流程",
  confirm_complete_task: "确认完成任务",
  billing_type: "计费类型",
  mark_Exception: "标记异常",

  // 拣货库位补货管理
  replenishmentTaskControl: "补货任务控制",
  replenishmentList: "补货任务列表",
  Picking_storage_location_number: "拣货库位号",
  Inventory_storage_location_number: "备货库位号",
  Order_quantity_awaiting_replenishment: "订单待补货数量",
  Replenishment_control_threshold_quantity: "补货控制阈值数量",
  Picking_items_below_the_threshold_based_on_the_current_inventory_quantity:
    "低于阈值拣货现有库存数量",
  Inventory_threshold_for_picking_warehouse_locations: "拣货库位库存阈值",
  Number_of_task_varieties: "任务商品种数",
  No_recommended_storage_location_Default_replenishment_quantity_is_not_specified:
    "无推荐库位默认补货数量",
  Generate_replenishment_task: "生成补货任务",
  Create_replenishment_task_control: "创建补货任务控制",
  Only_video_and_image_formats_are_supported_for_preview_for_other_types_of_files_please_download_them_and_view_them:
    "仅支持视频及图片格式预览，其他类型文件请下载后查看",
  returnRemark: "退回备注",
  The_length_of_this_note_does_not_exceed_2000_characters: "备注长度不超过2000",
  // 在线商品
  shopeeOnlineProductDetails: "Shopee在线商品明细",
  lazadaOnlineProductDetails: "Lazada在线商品明细",
  tiktokOnlineProductDetails: "Tiktok在线商品明细",
  lazadaHostTheOnlineProductDetails: "Lazada托管在线商品明细",
  Shop_SKU: "店铺SKU",
  Inventory_SKU: "库存SKU",
  Multi_attribute_ID: "多属性ID",
  Pairing_Log: "配对日志",
  "Confirm_unpairing?": "确认解除配对?",
  Prompt: "提示",
  Confirm: "确定",
  Operation_successful: "操作成功",
  Deletion_cancelled: "已取消删除",
  Unpair: "解除配对",
  Online_SKU_Image: "线上SKU图片",
  Multi_attribute: "多属性",
  Inventory_SKU_Image: "库存SKU图片",
  Chinese_Name: "中文名称",
  English_Name: "英文名称",
  Store: "店铺",
  Inventory_Sync_Time: "库存同步时间",
  Inventory_Sync_Quantity: "库存同步数量",
  Online_SKU: "线上SKU",
  Please_select_customer_first: "请先选择客户",
  Please_check_only_one_item: "请只勾选一条",
  Inventory_synchronization_time: "库存同步时间",
  Inventory_synchronization_quantity: "库存同步数量",

  // 物流交接
  Handover_task_order_number: "交接任务单号",
  taskStatus: "任务状态",
  delivery_door: "发货门",
  trailer_number: "拖车号",
  handover_person: "交接人",
  handover_start_time: "交接开始时间",
  handover_end_time: "交接结束时间",
  handover_attachments: "交接附件",
  Ended: "已结束",
  handoverTime: "交接时间",
  scan_the_flow_chart: "扫描流水",
  upload_attachments: "上传附件",
  print_handover_form: "打印交接单",
  scanTime: "扫描时间",
  orderDetails: "订单明细",
  handover_scanning_time: "交接扫描时间",
  scan_people: "扫描人",
  create_handover_task: "创建交接任务",
  end_handover_task: "结束交接任务",
  Are_you_sure_to_end_the_current_friendship_task: "是否确认结束当前结交任务",
  end_handover_task_success: "结束交接任务成功",
  created_successfully: "创建成功",
  Please_enter_the_task_number: "请输入任务编号",

  marking_can_be_posted_for_outbound_shipment: "标记可贴单出库",
  remove_the_label_from_the_outbound_shipment: "移除可贴单出库",
  selected_product: "已选择商品",
  can_be_posted_and_shipped_from_the_warehouse: "可贴单出库仓库",
  batch_posting_outbound_information: "批量贴单出库信息",
  scan: "扫描",
  batch_labeling_posting_and_outbound: "批量标记贴单出库",
  batch_deletion_of_tags_stickers_and_outbound_shipments:
    "批量删除标记贴单出库",
  amount_money: "金额",
  logisticsControlList: "物流交接控制",
  Confirm_the_deletion_of_the_logistics_handover_processr: "确认删除物流交接?",
  New_logistics_handover_added: "新增物流交接",

  // 任务调度
  taskSchedulingList: "任务调度列表",
  taskLogList: "任务日志列表",
  serverList: "服务器列表",
  Task_name: "任务名称",
  Task_type: "任务类型",
  Task_priority: "任务优先级",
  Distribution_rules: "分发规则",
  Cron_string: "运行规则",
  Port_path: "端口路径",
  Minimum_running_memory: "最低运行内存",
  Minimum_running_CPU: "最低运行CPU",
  Whether_it_is_enabled: "是否启用",
  Asynchronous_distribution: "异步分发",
  Scheduled_execution: "定时执行",
  Periodical_execution: "周期执行",
  Last_run_start_time: "最近运行开始时间",
  Please_enter_a_name_for_the_task: "请输入任务名称",
  Please_enter_a_task_priority: "请输入任务优先级",
  Please_enter_a_distribution_rule: "请输入分发规则",
  Please_enter_a_running_rule: "请输入运行规则",
  Please_enter_the_port_path: "请输入端口路径",
  Please_enter_the_minimum_running_memory: "请输入最低运行内存",
  Please_enter_the_minimum_running_CPU: "请输入最低运行CPU",
  Distribute_parameter_content: "分发参数内容",
  Unusual_content: "异常内容",
  Abnormal_time: "异常时间",
  Server_status: "服务器状态",
  Server_name: "服务器名称",
  Server_port: "服务器端口",
  memory: "内存",
  Update_the_server_information: "更新服务器信息",

  // 移仓
  listWarehouseTransferTasks: "移仓任务列表",
  Move_out_Of_Warehouse: "移出仓库",
  Move_into_warehouse: "移入仓库",
  All_inventory_information: "所有库存信息",
  Current_inventory_information: "现有库存信息",
  Completion_time_warehouse_transfer: "移仓完成时间",
  Please_select_to_move_out_of_the_warehouse: "请选择移出仓库",
  Please_select_to_move_into_the_warehouse: "请选择移入仓库",
  Moving_in_and_out_of_the_warehouse_is_not_allowed_to_be_repeated:
    "移入移出仓库不允许重复",
  Warehouse_transfer_task_number: "移仓任务编号",
  Remove_warehouse_location_number: "移出库位号",
  Move_into_storage_location_number: "移入库位号",
  Create_warehouse_transfer_task: "创建移仓任务",
  addWarehouseTransferTaskBtn: "创建移仓任务",
  edit_warehouse_transfer_task: "编辑移仓任务",
  Warehouse_transfer_type: "移仓类型",
  Partial_warehouse_transfer: "部分移仓",
  All_positions_transferred: "全部移仓",
  Warehouse_transfer_information: "移仓信息",
  Move_out_warehouse_location: "移出库位号",
  Move_into_storage_location: "移入库位号",
  Please_select_the_type_of_warehouse_transfer: "请选择移仓类型",
  Please_select_the_storage_location_number_to_be_moved_into:
    "请选择移入库位号",
  Select_the_goods_that_need_to_be_transferred: "选择需要转移的商品",
  Quickly_plan_storage_locations: "快速规划库位",
  Please_select_the_goods_that_require_rapid_planning_of_storage_locations:
    "请选择需要快速规划库位的商品",
  Only_virtual_and_temporary_storage_locations_can_be_used_at_this_location_The_virtual_and_temporary_storage_locations_of_this_warehouse_are_empty_Please_create_the_corresponding_virtual_and_temporary_storage_locations_for_the_warehouse_and_then_refresh_again:
    "该处只可使用虚拟库位与临时库位,该仓的虚拟库位与临时库位为空,请创建对应仓库的虚拟库位与临时库位后在刷新重试",
  The_number_of_listings_cannot_exceed_the_inventory_quantity_The_current_inventory_quantity_is:
    "上架数量不能大于库存数量，当前库存数量为",
  Select_a_store: "选择店铺",
  If_the_shipping_address_in_the_store_is_backend_is_not_consistent_with_the_system_warehouse_address_it_cannot_be_selected_Please_go_to_the_store_authorization_page_to_confirm:
    "店铺后台发货地址与系统仓库地址不一致的无法勾选，请到店铺授权页确认",
  Shop_shipping_warehouse: "店铺发货仓库",
  Clear_all: "清除全部",
  No_data_obtained: "未获取到数据",
  Selected_store: "已选择店铺",
  // 同步库存
  synchronousInventorySettingList: "同步库存设置列表",
  synchronousInventoryLogList: "同步库存日志列表",
  synchronousInventoryAnomaly: "同步库存异常",
  synchronousInventoryProductList: "在线商品库存同步列表",
  store: "店铺",
  online_sku: "线上SKU",
  multi_attribute_id: "多属性ID",
  multi_attribute: "多属性",
  inventory_sku: "库存SKU",
  sync_time: "同步时间",
  online_sku_image: "线上SKU图片",
  sync_inventory_quantity: "同步库存数量",
  rule_name: "规则名称",
  inventory_allot_policy: "库存分配策略",
  modifier: "修改人",
  create_time: "创建时间",
  modify_time: "修改时间",
  create: "创建",
  set_non_sync_online_products: "设置不同步在线商品",
  The_creation_and_modification_rules_will_not_take_effect_immediately_Please_wait_patiently:
    "创建/修改规则不会立刻生效，请耐心等待。",
  Only_online_products_that_have_been_paired_with_inventory_SKUs_will_be_synchronized:
    "只有配对了库存SKU的在线商品才会同步。",
  Inventory_threshold: "库存阈值",
  Sync_store_range: "同步店铺范围",
  Sync_SKU_ranges: "同步SKU范围",
  Recent_run_time: "最近运行时间",
  Sync_specified_policy_inventory: "同步指定策略库存",
  The_quantity_of_available_inventory_at_that_time: "当时可用库存数量",
  The_available_inventory_quantity_during_the_synchronization_process:
    "执行同步时的可用库存数量",
  Synchronized_item_ID: "历史ItemId",
  synchronous_regimes: "同步状态",
  synchronous_messages: "同步消息",
  The_name_of_the_inventory_updateable_strategy: "库存可更新得策略名称",
  Inventory_synchronization_strategy: "库存同步策略",
  Inventory_synchronization_strategy_value: "库存同步策略值",
  ExportOrderTraceTaskList: "物流交接明细",
  Are_you_sure_to_modify_the_processing_plan: "是否确认修改处理方案",
  The_task_number_selection_is_inconsistent_please_choose_again:
    "任务编号选择不一致，请重新选择",

  Only_products_with_inventory_quantity_greater_than_0_and_inventory_quantity_greater_than_the_occupied_inventory_quantity_can_be_selected:
    "只能选择库存数量大于0的且库存数量大于占用库存数量的商品",
  There_are_not_enough_suitable_storage_locations_for_the_user_please_choose_on_your_own:
    "用户合适的库位不足，请自行选择",
  Import_warehouse_order: "导入仓储订单",
  Do_you_want_to_cancel_the_selected_warehouse_transfer_task:
    "是否撤销选中移仓任务",
  Have_you_completed_the_warehouse_relocation_task: "是否完成移仓任务",
  Has_the_status_of_pending_reception_confirmed: "是否已确认到待接收状态",
  Please_first_select_the_warehouse_transfer_task_that_needs_to_be_revoked:
    "请先选择需要撤销的移仓任务",
  Are_you_sure: "是否确认",
  completeWarehouseRelocation: "完成移仓",
  exportTransferTask: "导出移库任务",
  transfer_task_list: "移库任务列表",
  AdjustTheWarehouseRelocationTaskLocation: "调整移仓任务库位",
  Print_the_inventory_transfer_list: "打印移仓清单",
  Print_transfer_and_packing_information: "打印移仓装箱信息",
  exportWarehouseInventoryInformation: "导出仓库库存信息",
  Only_one_warehouse_transfer_task_can_be_selected: "有且只能选择一个移仓任务",
  Export_existing_inventory: "导出现有库存",
  Export_all_inventory: "导出所有库存",
  Please_select_the_relocation_task: "请选择移仓任务",
  binning: "分箱",
  Please_download_from_the_task_center_in_five_minutes:
    "请五分钟后在任务中心下载",
  server_storage_address: "服务器存储地址",
  Please_add_product_details_first: "请先添加商品明细",
  Please_select_products_with_SKU_and_location_numbers_that_are_not_the_same:
    "请选择sku和库位号不相同的商品",
  Profit_Order_payment_for_product_amount_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupons_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Fees_Refund_Product_Amount_Return_Order_Return_Freight_x_Exchange_Rate_Product_Procurement_Cost_Initial_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:
    "利润=（订单支付商品金额-退款-实际运费+卖家支付运费+平台运费补贴-换货运费-卖家运费折扣-TSP佣金-平台佣金-联盟佣金-交易费用-SFP服务费-服务费-额外计划服务费-物流保险费-运费服务税SST-增值税（VAT）-产品服务税-卖家优惠卷-退件订单运费-平台其它费用-信用卡支付手续费+平台调整金额-生态捐款-手续费-退款商品金额-退货订单退回运费）×汇率-（商品采购成本+头程运费 +仓租+ 上架费 + 订单处理费）",
  The_value_added_tax_paid_by_the_platform_on_behalf_of_the_buyer_import_value_added_tax_value_added_tax_paid_by_the_platform_on_behalf_of_the_seller:
    "平台代表买家支付的的增值税+进口增值税+平台代表卖家支付的增值税",
  Return_order_return_fee: "退货订单退回费用",
  When_the_original_currency_conversion_profit_financial_currency_exchange_rate_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day:
    "当未设置店铺原始币种换算利润财务币种汇率时，系统将不执行数据同步，设置后会在当天24点后同步数据",
  Gold_coin_deduction: "金币抵扣",
  Platform_preferential_subsidies: "平台优惠补贴",
  Installment_payment_handling_fee: "分期付款手续费",
  Sellers_free_shipping_promotion_fee_refund_of_shipping_fee_to_customer_shipping_subsidy_provided_by_seller_seller_pays_for_shipping_fee:
    "卖家包邮促销费用+因退款运费退给客户+卖家提供的运费补贴+卖家支付运费",
  The_total_amount_of_other_expenses_not_shown_such_as_FBI_project_processing_fees_buyer_review_incentives_LazFlash_additional_daily_subsidies_below_9_99_etc:
    "未展示费用的其它费用总和，例如：FBI项目处理费、买方评审激励、LazFlash额外/每天低于9.99美元的补贴等",
  starting_inventory: "起始库存(>=)",
  Terminate_inventory: "结束库存(<)",
  Inventory_allocation_strategy: "库存分配策略",
  Inventory_update_value: "库存更新值",
  Fixed_value: "固定值",
  Percentage: "百分比",
  schema: "模式",
  Add_the_maximum_inventory_range: "添加最大库存区间",
  Shop_back_end: "店铺后台",
  Mapping_warehouse_address: "映射仓库地址",
  ship_address: "发货地址",
  Create_a_strategy: "创建策略",
  Manually_synchronize_the_specified_strategy: "手动同步指定策略",
  Inventory_warning_threshold: "库存预警阈值",
  resynchronization: "重新同步",
  Latest_synchronization_time: "最近同步时间",
  Synchronous_logs: "同步日志",
  The_shipping_address_in_the_store_is_back_end_must_be_exactly_the_same_as_the_warehouse_address_If_they_are_not_the_same_please_modify_it_in_the_store_is_back_end_and_then_click_the_Manually_Synchronize_Warehouse_button:
    "店铺后台发货地址需和仓库地址完全一致，如不一致请到店铺后台修改后点击手动同步仓库按钮",
  The_fixed_value_strategy_is_a_fixed_quantity_and_the_percentage_strategy_is_a_percentage_of_the_current_available_inventory:
    "固定值策略为固定的数量，百分比策略为当前可用库存的百分比",
  The_creation_modification_manual_synchronization_of_the_policy_will_be_completed_within_half_an_hour:
    "创建/修改/创建/修改/手动同步策略将在半小时内执行完",
  Please_check_the_synchronization_status_in_the_synchronization_inventory_log_list:
    "请到同步库存日志列表中查看同步情况",
  Only_the_online_products_that_have_been_matched_with_the_inventory_SKUs_will_be_synchronized:
    "只有配对了库存SKU的在线商品才会同步",
  The_shipping_address_in_the_store_is_backend_must_be_exactly_the_same_as_the_warehouse_address_in_the_system:
    "店铺后台发货地址需同系统仓库地址完全一致",
  Maximum_synchronized_inventory: "最大可同步库存",
  total_inventory: "总库存",
  Unshipped_inventory: "未发货库存",
  Warehouse_orders_include_those_that_have_been_shipped_delivered_invalidated_cancelled_and_those_that_match_the_total_quantity_of_the_corresponding_SKUs:
    "仓储订单除了已发货，已交运，已作废，取消，相匹配SKU的数量总和",
  The_maximum_synchronizable_inventory_quantity_for_a_combined_SKU_is_equal_to_the_lowest_inventory_quantity_among_the_SKUs_in_the_combination:
    "组合SKU的最大可同步库存数量等于组合中库存最少的那个SKU",
  Select_store: "选择店铺",
  Specified_SKUs: "指定SKU",
  To_prevent_over_selling_when_the_synchronized_inventory_falls_below_the_warning_threshold_the_system_will_automatically_set_the_inventory_quantity_to_0:
    "为了预防超卖，当可同步库存低于警戒阈值时，系统将自动同步库存数量为0",
  Set_inventory_alert_threshold_100_Current_maximum_available_inventory_99_Below_the_inventory_alert_threshold_the_system_synchronizes_the_inventory_quantity_to_0:
    "例：设置库存警戒阈值：100 ，当前最大可用库存：99 低于库存警戒阈值，系统同步库存数量为0",
  Input_the_synchronous_inventory_range_interval_When_the_quantity_of_synchronous_inventory_falls_within_this_range_the_system_will_synchronize_based_on_the_set_synchronization_strategy_and_the_synchronous_inventory_quantity:
    "输入可同步库存范围区间，当可同步库存数量在该范围区间时，系统根据设置同步策略和同步库存数量进行同步",
  Add_asynchronous_online_products: "添加不同步在线商品",
  Asynchronous_online_product_logs: "不同步在线商品日志",
  This_operation_will_permanently_delete_Do_you_want_to_continue:
    "此操作将永久删除，是否继续",

  // 合同管理
  contractList: "合同列表",
  contractDetail: "合同详情",
  The_name_of_the_contract: "合同名称",
  Contract_number: "合同编号",
  Type_of_contract: "合同类型",
  Initiation_time: "发起时间",
  Signing_time: "签署时间",
  Expiration_time: "到期时间",
  voided_ontract: "作废合同",
  Rejection_contract: "驳回合同",
  Activate_the_contract: "激活合同",
  contractSubject: "切换主体列表",
  Apply_for_switching_the_entity: "申请切换主体",
  Rejection_time: "驳回时间",
  Those_who_rejected_it: "驳回人",
  Reason_for_Rejection: "驳回原因",
  Details_of_the_Supplementary_Agreement: "附加协议详情",
  downLoadContract: "下载合同",
  Please_select_the_customer_type: "请选择客户类型",
  E_signature_Treasure_Authorization_Status: "e签宝授权状态",
  Invalid_review: "审核作废",
  Review_rejected: "审核驳回",
  Parent_Contract_Number: "父合同编号",
  Is_it_the_contracting_party: "是否为签约主体",
  Without_signing_the_contract_all_functions_will_be_prohibited:
    "时间未签署合同，将禁止所有功能",
  protocolCode: "协议编码",
  Has_the_contract_and_user_information_been_verified_to_be_correct_and_approved_for_review:
    "是否已核实合同及用户信息无误，确认审核通过？",
  Sign_expiration_date: "签署到期日期",
  Signing_link_expiration_date: "签署链接到期日期",
  Please_contact_your_dedicated_investment_manager_to_review_the_contract_information:
    "请联系您的专属招商，审核合同信息。",
  Whether_to_automatically_renew: "是否自动续签",
  Used_for_subsequent_billing_and_invoicing_functions_of_the_system_account:
    "用于系统账户后续出账开票功能使用",
  The_phone_number_of_the_current_contract_signatory_otherwise_the_contract_cannot_be_successfully_signed:
    "当前合同签署人名下的手机号，否则合同无法签署成功",
  Real_QQ_WeChat_contact_with_our_company_otherwise_the_contract_cannot_be_successfully_signed:
    "真实的与我方公司联系的QQ/微信，否则合同无法签署成功",
  addcompany: "添加公司",
  Sign_contract_documents: "签署合同资料",
  qq_wehat__non_nickname: "QQ/微信（非昵称）",
  Company_Name: "企业名称",
  contracting_entity: "签约主体",
  Do_you_want_to_apply_for_switching_subjects: "是否申请切换主体?",
  Please_contact_the_investment_promotion_review_to_switch_the_subject_application:
    "请联系招商审核切换主体申请",
  deadline: "截止",
  Is_the_selected_contract_to_be_reviewed: "是否审核通过",
  Whether_to_void_the_selected_contract: "是否作废",

  Note_To_ensure_the_legal_validity_of_the_contract_please_verify_the_accuracy_of_relevant_materials:
    "注意:为保障合同法律效力，请对相关资料进行准确性核验",

  // 备货单管理
  Inventory_information: "备货单信息 ",
  Product_Details: "商品详情",
  suggest_types: "建议类型",
  stock_up_suggestions: "备货建议",
  shortage_suggestion: "缺货建议",
  generate_a_backup_order: "生成备货单",
  Total_number_of_products_awaiting_review: "待审核商品总量",
  Planned_stocking_inventory: "计划备货库存",
  Sales_volume_7_14_30_60_90: "销量（7/14/30/60/90）",
  Daily_average_sales_in_the_past_30_days: "近30天日均销量",
  Stock_quantity: "备货数量",
  Minimum_reserve_price: "最低备货价",
  Last_stocking_price: "上次备货价",
  Reserve_currency_type: "备货币种",
  Stock_unit_price: "备货单价",
  In_stock: "备货中",
  Total_stocking_price: "备货总价",
  Stock_quantity_times_Stock_unit_price: "备货数量*备货单价",
  The_stage_of_inventory_management_is_equal_to_the_total_number_of_matching_SKUs_in_the_pending_review_and_inventory_process:
    "备货单管理中阶段等于，待审核，备货中，匹配的SKU的总数量",
  Daily_sales_in_the_past_30_days_purchase_days_warning_inventory_total_inventory_in_transit_inventory_if_less_than_0_display_0:
    "近30天日销量*采购天数+预警库存-库存总量-在途库存，小于0则显示0",
  By_default_it_is_equal_to_the_currency_of_the_last_stocking_If_not_available_it_is_RMB_which_can_be_modified:
    "默认等于上次备货的币种，如果没有则是RMB，可修改",
  By_default_it_is_equal_to_the_unit_price_of_the_last_stocking_If_not_available_it_is_the_purchase_price_of_the_product_which_can_be_modified:
    "默认等于上次备货的单价，如果没有则是商品的采购价，可修改",
  Completed_the_last_completed_stocking_unit_price_for_matching_SKUs:
    "已完成中,匹配SKU的最后一次完成的备货单价。",
  Starting_time_of_stocking: "备货开始时间",
  Please_select_the_start_time_for_stocking: "请选择备货开始时间",
  Completed_matching_the_lowest_stocking_unit_price_for_SKU:
    "已完成,匹配SKU的最低的备货单价",
  Please_select_products_from_the_same_warehouse: "请选择同一仓库下的商品",
  Stock_order_number: "备货单号",
  Stockist: "备货员",
  LeadTime: "备货时间",
  supplier: "供应商",
  Platform_order_status: "平台订单状态",
  Subtotals_of_pre_discount_products: "折前商品小计",
  Subtotals_of_discount_products: "折后商品小计",
  Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only_seller_discounts_product_discounts_flash_purchases_buy_more_save_more_vouchers_and_bundled_transactions:
    "不参与订单利润计算，仅供运营分析参考，卖家折扣（产品折扣、闪购、多买多省、代金券和捆绑交易）",
  The_data_at_this_stage_is_the_original_data_before_merging_the_stocking_list_for_reference_only:
    "此阶段的数据是合并备货单前的原始数据，仅做参考",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_only_for_orders_that_have_been_shipped_out_Profit_data_will_continue_to_be_updated_in_the_early_morning_until_the_settlement_time_of_platform_orders_is_updated:
    "当未设置店铺原始币种换算利润财务币种汇率时，系统将不执行数据同步，设置后会在当天24点后同步前一天数据，只同步已出库订单，利润数据将在凌晨持续更新，直至平台订单结算后更新结算时间。",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated:
    "当未设置店铺原始币种换算利润财务币种汇率时，系统将不执行数据同步，设置后会在当天24点后同步前一天数据，只同步已出库且账单已产生订单，利润数据将在凌晨且账单产生时更新，账单产生时将会以最后产生账单的时间作为结算时间。",
  Exchange_rate_setting: "汇率设置",
  Total_quantity_of_stocked_goods: "备货商品总数量",
  Total_number_of_stocked_goods: "备货商品总种量",
  Total_price_of_the_purchase_order: "备货单总价",
  Total_cubic_meter_of_inventory_M_three: "备货总立方（M³）",
  Total_weight_of_stock_KG: "备货总重量（KG）",
  Ending_time_of_stocking: "备货结束时间",
  Real_payment_amount: "实付款金额",
  Stocking_remarks: "备货备注",
  Total_cubic_meters_of_goods_M_three: "商品总立方（M³）",
  Total_weight_of_the_product_KG: "商品总重量（KG）",
  Merge_backup_documents: "合并备货单",
  Are_you_sure_to_merge_the_selected_backup_orders: "是否确定合并选择的备货单",
  Change_to_void_status: "修改状态为作废",
  Change_the_status_to_abnormal: "修改状态为异常",
  Change_status_to_return: "修改状态为退回",
  Submit_to_stocking: "提交到备货中",
  Have_you_submitted_it_to_the_inventory: "是否提交到备货中",
  Submit_to_Completed: "提交到已完成",
  SKUs_that_have_not_been_stocked_will_not_be_displayed_on_this_page:
    "没入过库的SKU将不在此页面显示",
  Please_select_a_backup_order_to_print: "请选择一个备货单打印",
  Inventory_quantity_if_there_is_real_length_width_and_height_it_is_real_length_real_width_real_height_if_there_is_no_real_length_width_and_height_it_is_length_width_height_100000_if_less_than_0_001_it_is_equal_to_0_001:
    "备货数量*（如果有真实长宽高就是 真实长*真实宽*真实高，如果没有真实长宽高就是 长*宽*高）/1000000,如果小于0.001则等于0.001",
  If_there_is_a_true_weight_the_stock_quantity_multiplied_by_the_true_weight_If_not_available_stock_quantity_weight:
    "如果有真实重量，则备货数量*真实重量。如果没有则备货数量*重量",
  Append_contract: "追加合同",
  AppendContract: "追加合同",
  Add_supplementary_agreement: "追加附属协议",
  Add_an_ancillary_agreement_template: "添加附属协议模板",
  Addendum_to_the_subcontract: "追加子合同",
  Please_select_the_addendum_contract: "请选择追加合同",
  contract: "合同",
  The_contract_has_not_been_generated_yet: "暂未生成合同",
  To_be_signed: "待签署",
  To_be_signed_contract: "待签署合同",
  Go_to_sign: "前往签署",
  You_have_contracts_to_sign: "您有待签署的合同，是否前往签署？",
  Add_contract_template: "添加合同模板",
  Edit_contract_template: "编辑合同模板",
  Template_chinese_name: "模板中文名称",
  Template_english_name: "模板英文名称",
  Audit_contract: "审核合同",
  Credit_limit: "信用额度",
  Online_product_status: "在线商品状态",
  The_store_product_data_status_for_synchronizing_inventory_will_be_automatically_synchronized_at_least_once_a_day_and_other_unconfigured_items_need_to_be_manually_synchronized:
    "设置同步库存的店铺产品数据状态每天至少会自动同步一次,其他未配置的需要手动获取同步",

  Online_product_matching: "在线商品配对",
  Update_the_order_status: "更新订单状态",
  Batch_Online_product_matching: "批量在线商品配对",
  receiveWarehousePermissions: "接收仓权限",
  Choose_zones_and_shelves_for_quick_planning: "选择快速规划的分区和货架",
  If_a_partition_or_shelf_is_selected_only_unused_shelves_under_that_partition_or_shelf_will_be_recommended_If_partitioning_or_shelving_is_not_selected_it_will_be_recommended_that_the_corresponding_customer_s_receiving_warehouse_has_unused_storage_locations_near_the_inventory_shelves_If_there_is_no_inventory_it_will_not_be_recommended:
    "如果选择了分区或货架，仅会推荐该分区或货架下未使用的货架。如果不选择分区或货架，则会推荐对应客户接收仓有库存货架附近未使用的库位，如果无库存则不推荐。",
  Pair_product_images: "配对产品图片",
  Paired_product_barcode: "配对产品商品条码",
  Matching_product_SKU: "配对产品sku",
  Paired_product_Chinese_name: "配对产品中文名称",
  Paired_product_English_name: "配对产品英文名称",
  online_SKU: "在线sku",
  Actual_amount: "实际金额",
  Please_select_orders_from_the_same_platform: "请选择同一平台下的订单",
  The_old_password_matches_the_new_password_please_re_enter:
    "旧密码与新密码一致，请重新输入",

  generate_a_contract: "生成合同",
  Deposit_Bank: "开户银行",
  Deposit_Bank_No: "开户银行账号",
  ID_card_address: "身份证地址",
  ID_card_name: "姓名",
  Please_enter_your_name: "请输入姓名",
  Please_enter_the_name_of_the_legal_representative: "请输入法人姓名",
  Please_enter_the_company: "请输入公司",
  Please_enter_the_legal_representative_company: "请输入法人公司",
  Please_select_the_company: "请选择公司",
  Please_enter_the_business_license_code: "请输入营业执照编码",

  contractTemplateManagemen: "合同模版",
  Contract_Template_Id: "合同模版Id",
  Contract_signing_expiration_date: "合同签署到期天数",
  file_path: "文件路径",
  Please_select_the_contract_type: "请选择合同类型",
  Please_select_the_contract_template: "请选择合同模版",
  Please_upload_the_file: "请上传文件",
  Signing_effective_time: "签署有效时间",
  Validity_period_of_ID_card: "身份证有效期",
  Please_enter_the_validity_period_of_your_ID_card: "请输入身份证有效期",
  Validity_period_of_legal_person_s_ID_card: "法人身份证有效期",
  Please_enter_the_validity_period_of_the_legal_person_s_ID_card:
    "请输入法人身份证有效期",
  Date_of_Birth: "出生日期",
  Please_enter_your_date_of_birth: "请输入出生日期",
  Business_license_address: "营业执照地址",
  Validity_period_of_business_license: "营业执照有效期",
  Please_enter_the_validity_period_of_the_business_license:
    "请输入营业执照有效期",
  Please_enter_your_ID_address: "请输入身份证地址",
  Please_enter_the_address_on_your_business_license: "请输入营业执照地址",
  When_uploading_the_ID_card_file_the_first_one_is_the_front_of_the_ID_card_and_the_second_one_is_the_back_of_the_ID_card:
    "身份证文件上传时，第一张为身份证正面，第二张为身份证反面",
  Please_select_data_from_the_same_warehouse: "请选择同一仓库下的数据",
  Batch_modify_storage_location_types_and_store_SKU_types:
    "批量修改库位类型，存放SKU类型",
  Single_page_signature_page: "单页签署页面",
  Please_enter_the_single_page_signature_page: "请输入单页签署页面",
  Signature_page_number_of_saddle_seal: "骑缝章签署页码",
  Please_enter_the_page_number_for_signing_the_saddle_seal:
    "请输入骑缝章签署页码",
  Total_number_of_pages_in_the_contract: "合同总页数",
  If_the_total_number_of_pages_in_the_contract_is_2_fill_in_1_2_The_total_number_of_pages_in_the_contract_is_3_please_fill_in_1:
    "如果总共合同总页数是2，就填1-2。合同总页数是3，就填1-3",
  Online_product_information: "在线商品信息",
  Online_variant_ID: "线上变体ID",
  Import_warehouse_transfer_task: "导入移仓任务",
  Export_warehouse_inventory_information: "导出仓库库存信息",
  Adjust_the_storage_location: "调整库位",
  The_selected_stock_quantity_cannot_be_0_please_enter_the_stock_quantity:
    "选择的备货数量不能为0，请输入备货数量",
  Order_status: "订单状况",
  Rule_1: "规则1",
  Rule_2: "规则2",

  Channel_number: "通道编号",
  Area_code: "区域代码",
  Shelf_number: "货架编号",
  Shelf_position: "货架位号",
  Represent_with_1_2_letters_numbers_to_distinguish_different_functional_areas_for_example:
    "用 1-2 位字母/数字表示，区分不同功能区域，例如:",
  R_Receiving_Area: "R:收货区(Receiving)",
  S_Storage_Area: "S:存储区(Storage)",
  P_Picking_Area: "P:拣货区(Picking)",
  D_Delivery_Area: "D:发货区(Delivery)",
  Or_use_SA_to_distinguish_different_areas_of_different_functional_zones_heavy_shelves_light_shelves_ground_push:
    "或用 SA 区分不同功能区的不同区域(重型货架、轻型货架、地推)",
  Represented_by_1_2_digits_numbered_in_sequence_such_as_01_02__99_combined_with_the_area_number_such_as_S_01_for_storage_area:
    "用 1-2 位数字表示，按顺序编号(如 01、02…99)，结合区域编号(如 S-01 表示存储区",
  Represent_with_1_2_digits_numbered_in_sequence_such_as_01_02_99_combined_with_the_area_channel_number_such_as_S_01_01_representing_the_first_shelf_of_the_first_channel_in_the_storage_area:
    "用 1-2 位数字表示，按顺序编号(如 01、02…99)，结合区域通道编号(如 S-01-01 表示存储区第一通道第 1个货架)。",
  Represent_with_1_2_digits_numbered_from_bottom_to_top_such_as_01_02_03_combined_with_the_area_channel_and_shelf_number_such_as_S_01_01_01_representing_the_first_layer_of_the_first_shelf_in_the_first_channel_of_the_storage_area:
    "用 1-2 位数字表示，从下到上编号(如 01、02、03…)，结合区域、通道、货架编号(如S-01-01-01 表示存储区第一通道第1个货架第一层)。",
  Represented_by_1_2_digits_the_same_layer_is_numbered_from_left_to_right_such_as_01_02_combined_with_the_area_channel_shelf_and_layer_numbers_such_as_S_01_01_01_01_representing_the_first_channel_first_shelf_first_layer_first_digit_grid_of_the_storage_area:
    "用 1-2 位数字表示，同一层从左到右编号(如 01、02…)，结合区域、通道、货架、层编号(如 S-01-01-01-01 表示存储区第一通道第1个货架第一层第一位(格))",
  Complete_coding_example_S_02_05_03_04: "完整编码示例:S-02-05-03-04",
  if_03_is_03_rd_floor_04_is_04_th_storage_location_S_Storage_area_02_Second_aisle_05_Fifth_shelf:
    "03 第3层04 第4个库位S 存储区02 第二通道 05 第五个货架",
  Please_enter_the_area_code: "请输入区域代码",
  Please_enter_the_channel_number: "请输入通道编号",
  Please_enter_the_shelf_position: "请输入货架位号",
  Online_product_images: "在线商品图片",
  increase_storage_locations: "增加库位",

  // 帮助中心
  articleList: "文章列表",
  article_Name: "文章名称",
  whether_to_turn_it_on: "是否开启",
  create_Article: "创建文章",
  edit_Article: "编辑文章",
  article_Details: "文章详情",
  Open: "开启",
  Shut_down: "关闭",
  articleDetail: "文章详情",
  External_ERP_Help_Documentation: "外部ERP帮助文档",
  help_document: "帮助文档",
  help_center: "帮助中心",
  Please_enter_the_article_name: "请输入文章名称",
  Please_select_the_status: "请选择状态",
  Please_select_the_menu: "请选择菜单",
  helpDocument: "帮助文档",

  // 全球虾皮
  shopeeGlobalOnlineProducts: "Shopee全球在线商品",
  global_item_id: "全球itemId",
  global_multi_attribute_id: "全球多属性id",
  global_online_sku: "全球线上sku",
  is_mapped: "是否映射",
  product_status: "产品状态",
  pull_product_task: "拉取产品任务",
  pull_log: "拉取日志",

  delete_shelves_by_layer: "按层数删除货架",
  The_lowest_purchase_unit_price_in_the_completed_stage_of_inventory_management:
    "备货单管理 已完成 阶段中最低的采购单价",
  The_most_recent_purchase_unit_price_in_the_completed_stage_of_inventory_management:
    "备货单管理 已完成 阶段中最近一次的采购单价",
  Default_last_purchase_currency_initially_CNY: "默认上次采购币种,初始为CNY",
  The_default_is_the_last_purchase_unit_price_which_is_initially_the_purchase_price_of_the_product:
    " 默认为上次采购单价，初始为商品的采购价格。",
  Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_and_planned_stock_quantity:
    "近30天日销量*采购天数+预警库存-库存总量-在途库存-计划备货数量",
  Do_not_display_items_less_than_or_equal_to_0: "小于等于0的不显示",
  Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_planned_stock_quantity_and_out_of_stock_quantity:
    "近30天日销量*采购天数+预警库存-库存总量-在途库存-计划备货数量+缺货数量",
  Suggested_stocking_quantity_multiplied_by_purchase_unit_price:
    " 建议备货数量*采购单价",
  Completing_the_purchase_order_will_not_change_the_purchase_unit_price_of_the_goods:
    "完成备货单，不会改变商品的采购单价",
  The_number_of_layers_cannot_be_0: "层数不能为0",
  Mandatory_deduction_of_fees: "强制扣费",
  Do_you_confirm_the_mandatory_deduction_of_fees: "是否确认强制扣费",
  Unrestricted_balance_can_be_deducted_as_negative: "不受限制，余额可扣成负数",
  Inventory_management_pending_review_sum_of_stage_quantities_in_inventory_preparation:
    " 备货单管理 待审核+备货中 阶段数量之和",
  The_quantity_of_inventory_pending_review_reviewed_received_in_transit_warehouse_in_transit_in_the_final_stage_of_receiving_received_in_the_final_stage_under_quality_inspection_and_not_yet_listed_in_the_quality_inspection_stage:
    "入库单 待审核、已审核、中转仓收货、运输中、尾程收货中、尾程已收货、质检中、已质检 阶段未上架的数量",
  Please_enter_1_2_characters: "请输入1-2位字符",
  Please_enter_1_2_digits: "请输入1-2位数字",
  Please_enter_a_number: "请输入数字",
  Is_it_an_available_storage_location: "是否为可用库位",
  deduction_item: "扣费项",
  Sales_Trend_Chart: "销量趋势图",
  total_occupancy_quantity: "总占用数量",
  Occupied_inventory_volume: "占用库存总量",
  Total_occupancy_quantity_order_occupancy_quantity_manual_outbound_occupancy_quantity_warehouse_transfer_occupancy_quantity:
    "总占用数量（订单占用数量/手工出库占用数量/移仓占用数量）",
  Sales_time_filtering: "销量时间筛选",
  Order_occupancy_quantity: "订单占用数量",
  Quantity_occupied_by_manual_outbound: "手工出库占用数量",
  Number_of_occupied_warehouses_for_relocation: "移仓占用数量",
  Please_select_the_item_that_needs_to_be_deducted: "请选择需要扣费项",
  Please_select_the_storage_type: "请选择存放类型",
  Please_select_the_type_of_storage_location: "请选择库位类型",
  Transfer_according_to_batches_If_the_transfer_quantity_is_less_than_or_equal_to_the_available_inventory_of_a_single_batch_transfer_the_available_inventory_first_If_the_available_inventory_of_the_batch_is_less_than_the_total_inventory_of_the_batch_it_cannot_be_transferred:
    "按照批次进行转移，如果转移数量<=单个批次可用库存，先转移可用库存。如果>批次可用库存<批次总库存，无法转移",
  If_batch_occupancy_quantity_priority_should_be_given_to_transferring_occupied_inventory_followed_by_transferring_available_inventory:
    "如果>=批次占用数量，优先转移占用库存，然后转移可用库存",
  After_transferring_a_batch_of_inventory_if_there_are_still_remaining_quantities_that_have_not_been_transferred_transfer_the_remaining_quantities_from_other_batches:
    "一个批次库存转移完之后，还有剩余没有转移的数量，从其他批次进行剩余数量转移",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_day_s_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated_Note_The_billing_of_platform_orders_may_be_generated_at_multiple_time_points_If_some_of_the_billing_points_are_generated_before_the_currency_exchange_rate_is_set_these_bills_will_not_be_pulled_resulting_in_incomplete_order_report_fees:
    "当未设置店铺原始币种换算利润财务币种汇率时，系统将不执行数据同步，设置后会在当天24点后同步前一天数据，只同步已出库且账单已产生订单，利润数据将在凌晨且账单产生时更新，账单产生时将会以最后产生账单的时间作为结算时间。注：平台订单的账单产生可能在多个时间点，如一部分账单产生时间点在设置币种汇率之前，则这部分账单不会被拉取产生订单报表费用不全的问题",
  Currency_for_warehouse_fee_settlement: "仓库费用结算币种",
  When_the_original_currency_conversion_profit_financial_currency_exchange_rate_for_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_the_setting_is_completed_the_data_from_the_previous_day_will_be_synchronized_after_24_00_of_the_current_day_Only_orders_that_have_been_dispatched_and_bills_have_been_generated_will_be_synchronized_The_profit_data_will_be_updated_at_the_beginning_of_the_next_day_when_the_bill_is_generated_The_settlement_time_will_be_the_time_when_the_bill_was_last_generated:
    "当未设置店铺原始币种换算利润财务币种汇率时，系统将不执行数据同步，设置后会在当天24点后同步前一天数据，只同步已出库且账单已产生订单，利润数据将在凌晨且账单产生时更新，账单产生时将会以最后产生账单的时间作为结算时间。",
  Note_The_generation_of_bills_for_platform_orders_may_occur_at_multiple_time_points_For_instance_if_a_portion_of_the_bills_are_generated_before_the_setting_of_currency_exchange_rates_then_these_bills_will_not_be_retrieved_to_generate_the_order_report_resulting_in_the_issue_of_incomplete_fees:
    "注：平台订单的账单产生可能在多个时间点，如一部分账单产生时间点在设置币种汇率之前，则这部分账单不会被拉取产生订单报表费用不全的问题",
  Original_currency_of_the_order: "订单原币种",
  BatchAddStorageLocations: "批量添加库位",
  Please_fill_in_the_scope_in_order: "请按照顺序填写范围",
  The_initial_value_cannot_be_greater_than_or_equal_to_the_end_value:
    "初始值不能大于或等于结束值",
  The_initial_value_must_be_greater_than_0: "初始值必须大于0",
  The_interval_between_initial_and_final_values_should_not_exceed_20:
    "初始值结束值间隔请不要超过20",
  Position_grid_number: "位(格)号",
  Fetching: "获取中",
  Refresh_delivery_exception: "刷新交运异常",
  Activate_Contract: "激活合同",
  First_leg_order_log: "头程订单日志",
  Initial_billing_log: "头程账单日志",
  Create_template: "创建模版",
  Set_custom_calculation: "设置自定义计算",
  Custom_calculation_log: "自定义计算日志",
  Daily_sales_in_the_past_30_days: "近30天日销量",
  Planned_stocking_quantity: "计划备货数量",

  No_goods_found: "未找到商品",
  Stock_up_suggestions_Product_information: "备货建议商品信息",
  Out_of_stock_suggested_product_information: "缺货建议商品信息",
  Address_Business_License_Address: "地址/营业执照地址",
  Customer_type: "客户类型",
  Customer_authorization_status: "客户授权状态",
  Authorization_effective_time: "授权生效时间",
  Authorization_expiration_time: "授权失效时间",
  Go_to_authorization: "前往授权",

  logistics_information: "物流信息",
  Logistics_update_time: "物流更新时间",
  Current_inventory_batch_quantity: "当前库存批次数量",
  Unqualified_quantity_shortage_damage: "不合格数量（少发数量/破损数量）",
  Positive_numbers_are_required_to_refund_fees_while_negative_numbers_are_required_to_deduct_customer_balances:
    "正数是要返还费用的，负数是要扣除客户余额的",
  ReturnedForGeneration: "退回待生成",

  Our_Information: "我方信息",
  the_other_party_s_information: "对方信息",

  Identity_witness_portrait: "身份证人像面",
  National_emblem_on_ID_card: "身份证国徽面",

  Please_enter_QQ_WeChat: "请输入QQ/微信",
  generated_person: "生成人",
  generation_time: "生成时间",
  The_automatic_addition_of_packaging_materials_will_only_be_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained:
    "自动添加包材只有提交至待发货或者运单号获取中才会触发",
  preview: "预览",

  Packaging_material_combination: "包材组合",
  Inventory_quantity_is_below: "库存数量低于",
  Sales_in_the_last_30_days_greater_than: "近30天销量大于",
  Sales_in_the_last_30_days_greater: "近30天销量",

  Please_select_the_affiliated_warehouse: "请选择所属仓库",
  The_calculated_suggested_stocking_quantity_will_be_sorted_in_descending_order:
    "计算后的建议备货数量将以从大到小排序",

  Custom_calculation_settings: "自定义计算设置",
  Suggested_stocking_quantity: "建议备货数量",
  Calculate_based_on_custom_calculation_formula: "根据自定义计算公式核算",
  Calculate_the_recommended_stocking_quantity_based_on_the_formula_in_your_custom_calculation_settings_located_in_the_top_right_corner:
    "根据您在右上角-自定义计算设置中的公式，核算出建议备货数量",
  When_the_available_inventory_cannot_meet_your_pending_shipment_quantity_a_shortage_recommendation_will_be_triggered_recommending_as_much_as_is_needed:
    "当可用库存量无法满足您的待发货量时，将触发缺货推荐，缺多少推荐多少",
  The_total_quantity_of_goods_required_for_orders_in_the_pending_processing_and_review_stages_of_the_order_list:
    "订单列表待处理+待审核阶段订单需要的商品数量总和",
  Calculate_the_recommended_stocking_quantity_based_on_a_custom_calculation_formula:
    "根据自定义计算公式核算出建议备货的数量",
  Inventory_in_return_processing: "退货处理中库存",

  Average_daily_sales_in_the_past_30_days_multiplied_by_purchase_days_plus_warning_inventory_at_least_one_must_be_activated:
    "(近 30 天日均销量*采购天数)+预警库存，至少要开启一个",
  Total_inventory_available_inventory_Total_number_of_goods_awaiting_review_Inventory_in_return_processing_In_transit_inventory_Planned_stocking_quantity_at_least_one_must_be_activated:
    "(库存总量/可用库存)-待审核商品总量-退货处理中库存-在途库存-计划备货数量，至少要开启一个",

  warehouse_type: "仓库类型",
  Please_enter_the_name_of_the_person_in_charge: "请输入负责人名称",
  Only_process_orders_that_have_been_pending_review_and_entered_the_system_within_the_current_15_day_period:
    "只处理待审核中进入系统当前时间15天内的订单",
  The_order_will_be_automatically_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained:
    "订单提交到待发货或者运单号获取中会自动触发",
  Return_Order: "退货单",
  Pending_Review_Pending_Listing_In_Listing_Process_Number_of_Qualified_Items_Not_Yet_Completed_for_Listing:
    "待审核，待上架，上架中，合格未完成上架的数量",

  // 可更换sku
  canChangeSku: "可更换SKU",
  abnormalSKUPendingProcessing: "异常SKU待处理",
  batch_change_sku: "批量更换SKU",
  change_sku: "更换SKU",
  please_select_the_sku_to_be_replaced: "请选择需要替换的sku",
  please_select_new_sku: "请选择新的sku",
  please_select_orders_from_the_same_warehouse: "请勾选同一仓库订单",
  The_old_and_new_sku_cannot_be_the_same: "新旧sku不能相同",
  Mark_replaceable_SKU: "标记可更换SKU",
  Month_of_cost_recalculation: "费用重算月份",
  Order_adjustment_amount: "订单调整金额",

  If_there_is_a_token_error_prompt_please_check_if_the_token_is_copied_correctly_or_if_the_authorized_Lazada_service_marketplace_site_corresponds_to_the_system_repository_country:
    "如果出现token错误提示，请检查token是否复制正确或检查授权lazada服务市场站点是否与系统仓库国家对应",

  channel_name: "渠道名称",
  Service_Type: "服务类型",
  Billing_Plan: "计费规划",
  Delivery_countr: "配送国家",
  Delivery_area: "配送地区",
  Logistics_provider_name: "物流商名称",

  Quality_inspection_has_started: "已开始质检",
  Completed_quality_inspection: "已完成质检",

  Number_of_items_awaiting_quality_inspection: "待质检条数",
  The_number_of_quality_inspection_items_that_have_started: "已开始质检条数",
  Number_of_completed_quality_inspections: "已完成质检条数",

  Product_in_transit_details: "商品在途明细",
  Quick_Region_Selection: "快捷地区选择",
  Video_plugin_Connection_error_please_check_if_the_video_plugin_is_open_After_reopening_the_video_plugin_the_page_needs_to_be_refreshed:
    "视频插件连接错误，请检查是否打开视频插件,视频插件重新打开后需要刷新页面",
  Failed_to_save_the_currently_recorded_video: "当前录制视频保存失败",
  Please_enter_the_name_of_the_logistics_provider: "请输入物流商名称",
  Please_enter_the_channel_name: "请输入渠道名称",
  Please_select_the_delivery_country: "请选择配送国家",

  Import_logistics_channel_management_data: "导入物流渠道管理数据",
  Export_Logistics_Channel_Management_Data: "导出物流渠道管理数据",
  Edit_channel: "编辑渠道",

  Confirm_the_logistics_provider: "确认物流商",
  Recording_local_address: "录像本地地址",
  Confirm_Clearing_Order_Packaging: "是否确认清除订单包材",
  Operation_Successful: "操作成功",
  Please_Select_The_Data: "请勾选数据",
  Please_Select_Data_From_The_Same_Platform: "请选择同一平台的数据",
  Confirm_Transfer_To_Pending: "是否确认转入待处理",
  Confirm_Excluding_All_Rules: "是否确认排除所有规则",
  Confirm_Canceling_Exclusion_Of_All_Rules: "是否确认取消排除所有规则",
  Confirm_Excluding_Automatic_Packaging_Rules: "是否确认排除自动包材规则",
  Confirm_Canceling_Exclusion_Of_Automatic_Packaging_Rules:
    "是否确认取消排除自动包材规则",
  Confirm_Excluding_Submission_Rules: "是否确认排除提交规则",
  Confirm_Canceling_Exclusion_Of_Submission_Rules: "是否确认取消排除提交规则",
  Yes: "是",
  No: "否",
  Currently_Selected_Orders_Have_No_Shipping_Exceptions_No_Action_Required:
    "当前选中订单无交运异常，无需操作",
  Orders_Will_Be_Marked_As_Out_Of_Stock_If_Warehouse_Has_No_Inventory_After_Submission:
    "操作提交动作后，仓库没有货物的订单，会被标记为缺货",
  Out_Of_Stock_Orders: "缺货订单",
  Selected_Orders_Contain_Orders_Without_Tracking_Numbers_Cannot_Preview_Shipping_Labels:
    "所选订单中存在运单号为空的订单,无法预览面单",
  Preview_PDF: "预览PDF",
  Sum_Of_Created_Within_Last_Seven_Days_Pending_Review_Tracking_Number_Acquisition_In_Progress_And_Shipping_Exceptions:
    "创建时间近七天内，待审核、运单号获取中交运异常的总和",
  Shipping_Exceptions_In_Last_Seven_Days: "近七天交运异常",
  Basic_Query: "基本查询",
  Expired_Stores: "已过期店铺",
  Order_Number: "订单号",
  Tracking_Number: "运单号",
  Creation_Time: "创建时间",
  Transaction_Number: "交易号",
  Platform: "平台",
  Order_Source: "订单来源",
  API_Order: "API订单",
  Push_Order: "推送单",
  Manual_Order: "手工单",
  Cargo_Query: "货物查询",
  Warehouse: "仓库",
  Logistics_Channel: "物流渠道",
  Country: "国家",
  Chinese_Product_Name: "中文品名",
  English_Product_Name: "英文品名",
  Order_Status_Query: "订单状态查询",
  Logistics_Status: "物流状态",
  Priority_Delivery: "优先交付",
  Delivery_Method: "送货方式",
  WMS_Status: "WMS状态",
  Platform_Status: "平台状态",
  Time_Query: "时间查询",
  Confirmation_Time: "确认时间",
  Outbound_Time: "出库时间",
  Batch_Query: "批量查询",
  Add_Quick_Query: "新增快捷查询",
  Create_Order: "创建订单",
  Copy_Order: "复制订单",
  Transfer_To_Tracking_Number_Acquisition_In_Progress_Or_Awaiting_Shipment:
    "转入运单号获取中/待发货",
  Orders_With_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Awaiting_Shipment_Orders_Without_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Tracking_Number_Acquisition_In_Progress:
    "有运单号的订单会自动转入阶段：待发货，无运单号的订单会自动转入阶段：运单号获取中。",
  Transfer_To_Pending: "转入待处理",
  Fetch_Orders: "获取订单",
  Set_Order_Packaging: "设置订单包材",
  Clear_Order_Packaging: "清除订单包材",
  Void_Orders: "作废订单",
  Delete_Orders: "删除订单",
  Only_Supports_Operating_API_Orders_Within_12_Hours_Of_Delivery_Deadline_And_Push_Orders_Created_More_Than_12_Hours_Ago:
    "仅支持操作发货截止时间12小时之内的API订单和创建时间12小时之后的推送单",
  Return_To_Pending_Review: "退回待审核",
  Activate: "激活",
  Refresh_Platform_Status: "刷新平台状态",
  Online_Product_Matching: "在线商品配对",
  Resubmit_For_Shipping: "重新交运",
  More_Operations: "更多操作",
  Import: "导入",
  Export: "导出",
  Tracking_Number_Acquisition_Successful_Will_Automatically_Transfer_To_Awaiting_Shipment:
    "运单号获取成功后会自动转入待发货",
  Shipping_Label_Operations: "面单操作",
  Upload_Shipping_Label: "上传面单",
  System_Printing_Requires_Downloading_A_Print_Plugin:
    "使用系统打印需要下载打印插件",
  Click_To_Download: "点击下载",
  Print_Shipping_Label: "打印面单",
  Download_Shipping_Label: "下载面单",
  Preview_Shipping_Label: "预览面单",
  Order_Batch_Processing: "订单批处理",
  Replace_SKU: "替换SKU",
  Delete_SKU: "删除SKU",
  Add_SKU: "添加SKU",
  Modify_SKU_Quantity: "修改SKU数量",
  Modify_Warehouse: "修改仓库",
  Edit_Notes: "编辑备注",
  Rule_Processing: "规则处理",
  Exclude_Submission_Rules: "排除提交规则",
  Cancel_Excluding_Submission_Rules: "取消排除提交规则",
  Exclude_Automatic_Packaging_Rules: "排除自动包材规则",
  Cancel_Excluding_Automatic_Packaging_Rules: "取消排除自动包材规则",
  Exclude_All_Rules: "排除所有规则",
  Cancel_Excluding_All_Rules: "取消排除所有规则",
  Exception: "异常",
  Order_Amount: "订单金额",
  Tracking_Number_Acquisition_In_Progress: "运单号获取中...",
  Push: "推",
  Manual: "手",
  Platform_Set_Priority_Delivery: "平台设置优先交付",
  Priority: "优",
  Manual_Set_Priority_Delivery: "手动设置优先交付",
  Pre_Sale_Orders: "预售订单",
  Pre_Sale: "预",
  Out_Of_Stock: "缺",
  Split_Orders: "拆分订单",
  Split: "拆",
  Product_Category: "商品种类",
  Product_Quantity: "商品数量",
  Operation: "操作",
  Edit: "编辑",
  Do_Not_Leave_Blanks_For_Line_Breaks: "不留白换行",
  Warehouse_Order_List: "仓储订单列表",
  All: "全部",
  Today: "今日",
  Yesterday: "昨日",
  Day_Before_Yesterday: "前日",
  Last_Three_Days: "最近三天",
  Last_Week: "最近一周",
  Last_Month: "最近一个月",
  Non_Out_Of_Stock_Orders: "非缺货订单",
  With_Tracking_Number: "有运单号",
  Without_Tracking_Number: "无运单号",
  Notes: "备注",
  With_Notes: "有备注",
  Without_Notes: "无备注",
  With_Platform_Notes: "有平台备注",
  Without_Platform_Notes: "无平台备注",
  Platform_Notes: "平台备注",
  Non_Split_Orders: "非拆分订单",
  Non_Pre_Sale_Orders: "非预售订单",
  Paired_Orders: "配对订单",
  Already_Paired_Orders: "已配对订单",
  Not_Paired_Orders: "未配对订单",
  Shipping_Exceptions: "交运异常",
  Priority_Delivery_Orders: "优先交付订单",
  Non_Priority_Delivery_Orders: "非优先交付订单",
  With_Shipping_Exceptions: "有交运异常",
  Without_Shipping_Exceptions: "无交运异常",
  Task: "任务",
  All_Tasks: "全部任务",
  Today_Tasks: "今日任务",
  Yesterday_Tasks: "昨日任务",
  Submitted_Order_Tasks: "提交的订单任务",
  Today_000000_180000_Submitted_Order_Tasks:
    "今日00:00:00-18:00:00提交的订单任务",
  Yesterday_000000_235959_Submitted_Order_Tasks:
    "昨日00:00:00-23:59:59提交的订单任务",
  Not_Excluding_Submission_Rules: "未排除提交规则",
  Excluded_Submission_Rules: "已排除提交规则",
  Not_Excluding_Automatic_Packaging_Rules: "未排除自动包材规则",
  Excluded_Automatic_Packaging_Rules: "已排除自动包材规则",
  Shipping_Label: "面单",
  With_Shipping_Label: "有面单",
  Without_Shipping_Label: "无面单",
  Online_Product_Image: "线上产品图片",
  No_Online_Product_Details_Available: "暂无线上商品明细",
  Online_Product_Details: "线上商品明细",
  Product_Image: "产品图片",
  System_Product_Details: "系统商品明细",
  Quantity: "数量",
  Out_Of_Stock_Status: "是否缺货",
  Out: "缺",
  Total_Inventory: "库存总量",
  Total_Available_Inventory: "可用库存总量",
  Total_Occupied_Inventory: "占用库存总量",
  Total_Unavailable_Inventory: "不可用库存总量",
  Total_In_Transit_Inventory: "在途库存总量",
  This_Operation_Will_Permanently_Delete_The_Query_Condition_Proceed:
    "此操作将永久删除该查询条件, 是否继续?",
  Currently_Only_Single_Order_Upload_Is_Supported: "暂时只支持单个订单上传",
  Current_Order_Cannot_Upload_Shipping_Label_Only_Orders_With_Order_Status_As_Pending_Review_Or_Awaiting_Shipment_And_WMS_Status_As_Picking_Exception_Sorting_Exception_Shipping_Exception_Or_Cancellation_Exception_Can_Upload_Shipping_Label:
    "当前订单不能上传面单，只有订单状态为待审核或待发货，wms状态为配货异常、分拣异常、发货异常、撤销异常的订单可以上传面单",
  Shipping_Label_Address_Is_Empty: "面单地址为空",
  Printing_In_Progress: "正在打印...",
  Network_Response_Failed: "网络响应失败",
  Download_Failed_Please_Try_Again_Later: "下载失败，请稍后重试",
  Select_The_SKU_To_Add_And_Enter_The_Quantity_To_Add:
    "选择需要添加的SKU，并输入需要添加SKU的数量",
  Product_Barcode: "商品条码",
  Only_One_Can_Be_Selected: "只能选择一个",
  Please_Enter_The_Quantity: "请输入数量",
  Please_Enter_Notes: "请输入备注",
  Select_The_SKU_To_Delete: "选择需要删除的sku",
  Please_Select_The_SKU: "请选择SKU",
  Order_Fetching_Time: "获取订单时间",
  Please_Enter_Separated_By_Commas_Or_Line_Breaks: "请输入，用逗号或换行隔开",
  Please_Select_Store: "请选择店铺",
  Transaction_Number_And_Order_Fetching_Time_Cannot_Be_Empty_Simultaneously:
    "交易号和获取订单时间不能同时为空",
  Fetch_Logistics_Tracking: "获取物流轨迹",
  Logistics_Tracking: "物流轨迹",
  Latest_Update: "最新更新",
  Logistics_Information_Is_Being_Fetched: "物流信息正在拉取中",
  Select_The_SKU_To_Modify_And_Enter_The_New_SKU_Quantity:
    "请选择需要修改的SKU，并输入需要修改的SKU数量",
  Select_Product: "选择商品",
  Please_Select_Warehouse: "请选择仓库",

  If_a_warehouse_needs_to_be_selected_within_the_page: "若页面内需选择仓库",
  The_selection_of_goods_can_only_be_made_after_choosing_a_warehouse:
    "选择仓库后才能进行商品选择",
  If_a_warehouse_is_selected_only_the_goods_that_have_been_stocked_on_the_shelves_in_that_warehouse_will_be_displayed:
    "如果选择了仓库，那么仅展示有上架过库存的商品。",
  Pair: "配对",
  Paired_Product_Image: "配对产品图片",
  Paired_Product_Barcode: "配对产品商品条码",
  Paired_Product_SKU: "配对产品SKU",
  Paired_Product_Chinese_Name: "配对产品中文名称",
  Paired_Product_English_Name: "配对产品英文名称",

  Statistics_Time_Range: "统计时间范围",
  Number_Of_People: "人数",
  Human_Efficiency: "人效",
  Packing_Lead_Time: "打包时效",
  Starting_Hour: "起始小时",
  Corresponding_Hour_For_Calculation_Day: "计算天的对应小时",
  Ending_Hour: "截止小时",
  Corresponding_Hour_For_Calculation_Day_Plus_One_Day: "计算天加一天的对应小时",
  Changes_Take_Effect_From_The_Next_Hour: "修改后的下一个小时才会生效",
  Add: "添加",
  Operation_Log: "操作日志",
  Type: "类型",
  Calculation_Day: "计算天",
  Calculation_Day_Starting_Hour: "计算天起始小时",
  Next_Day_Ending_Hour: "第二天截止小时",
  Calculation_Time_Field: "计算时间字段",
  List_Row_Background_Color: "列表行背景颜色",
  Please_Enter_Starting_Hour: "请输入起始小时",
  Please_Enter_A_Number_Between_0_And_23: "请输入0-23的数字",
  Starting_Hour_Cannot_Be_Greater_Than_Ending_Hour: "起始小时不能大于截止小时",
  Please_Enter_Ending_Hour: "请输入截止小时",
  Ending_Hour_Cannot_Be_Less_Than_Starting_Hour: "截止小时不能小于起始小时",
  Please_Enter_Type: "请输入类型",
  Type_Cannot_Be_Duplicated: "类型不能重复",
  Please_Select_Background_Color: "请选择背景颜色",
  Background_Color_Cannot_Be_Duplicated: "背景颜色不能重复",
  Please_Select_Calculation_Day: "请选择计算天",
  Please_Select_Calculation_Time_Field: "请选择计算时间字段",
  Auto_Update_Time: "自动更新时间",
  Next_Auto_Update_Time: "下次自动更新时间",
  Set_Statistical_Time_Range: "设置统计时间范围",
  Orders_Not_Completed_For_Delivery_Before_Statistical_Time_Range:
    "统计时间范围之前的未完成发货的订单",
  Warehouse_Orders: "仓储订单",
  Total_Orders_Awaiting_Shipment_Picking_In_Progress_And_Shipping_In_Progress_For_The_Corresponding_Warehouse:
    "对应仓库的待发货，拣货中，发货中的订单总量",
  Total_Orders_Shipped_And_Dispatched_For_The_Corresponding_Warehouse:
    "对应仓库的已发货，已交运的订单总量",
  Total_Orders: "订单总量",
  Total_Not_Shipped: "未发货总量",
  Total_Shipped: "已发货总量",
  Please_Select_Time: "请选择时间",
  Hour: "小时",
  Minute: "分钟",
  Second: "秒",
  Statistical_Time_Range: "统计时间范围",
  Corresponding_Start_Time_Of_Execution_At_That_Time_End_Time:
    "当时执行的对应起始时间，截止时间",
  Corresponding_Field_For_Statistical_Data: "用于统计数据的对应字段",
  // 通知列表
  Unread_Notification: "未读通知",
  noticeList: "通知列表",
  Receive_customer: "接收客户",
  Receive_staff: "接收员工",
  Receive_warehouse: "接收仓库",
  Receive_department: "接收部门",
  Receive_country: "接收国家",
  Add_Notification: "添加通知",
  Edit_Notification: "编辑通知",
  Recipient: "接收对象",
  Please_enter_a_title: "请输入标题",
  Please_enter_content: "请输入内容",
  Please_select_the_recipient: "请选择接收对象",
  The_title_must_be_1_to_50_characters: "标题必须在1-50个字符之间",
  Please_choose_a_logistics_provider: "请选择物流商",
  Platform_And_Shop: "平台/店铺",
  Export_inventory_historical_inventory_information: "导出库存+历史库存信息",
  Appointment_for_warehouse_entry_and_storage_time: "预约到仓入库时间",
  To_be_confirmed: "待确认",
  Number_of_packaging_cycles: "打包圈数",
  Please_select_the_scheduled_time_for_warehouse_entry_and_storage:
    "请选择预约到仓入库时间",
  storage_phase: "入库阶段",
  quantity_in_transit: "在途数量",

  Daily_scheduled_inbound_time: "每日预约入库时间",
  Select_time_range: "选择时间范围",
  Maximum_number_of_reserved_storage_parties: "最大预约入库方数",

  Total_number_of_reserved_storage_units:  "总预约入库方数",
  Available_for_appointment:  "可预约",
  Fully_booked:  "已预约满",
  The_available_appointment_dates_are_green_and_the_remaining_number_of_available_appointments_per_day_is_displayed_below_the_dates_If_the_number_of_reserved_parties_is_full_it_will_be_marked_in_red_indicating_that_the_reservation_is_full:

    "可预约的日期为绿色，日期下方显示每天剩余可预约方数。已预约方数满的为红色，显示已预约满。",

  Monday:  "一",
  Tuesday:  "二",
  Wednesday:  "三",
  Thursday:  "四",
  Friday:  "五",
  Saturday:  "六",
  Sunday:  "日",

  Pre_order_storage_for_the_next_seven_days: "未来七天预约入库",

  // 退货/退款
  The_buyer_initiates_a_return: "买家发起退货",
  The_goods_are_being_returned_to_the_warehouse: "货物退回仓库",
  Ongoing_disputed_orders: "进行中的争议订单",
  Refund_request_has_been_initiated: "已发起退款",
  closed: "已关闭",
  Rejected: "已拒绝",
  Once_the_seller_makes_a_decision: "待卖家决定",
  Once_Lazada_makes_a_decision: "待Lazada决定",
  in_dispute: "争议中",
  The_refund_application_has_been_closed: "仅退款申请已关闭",
  return_number: "退货单号",
  Return_type: "退货类型",
  Platform_return_status: "平台退货状态",
  Return_reason: "退货原因",
  Buyer_description_return_reason: "买家描述退货原因",
  Return_pickup_method: "退货取件方式",
  Return_logistics_status: "退货物流状态",
  Return_waybill_number: "退货运单号",
  Dispute_type: "争议类型",
  Dispute_description: "争议描述",
  Compensation_seller_status: "赔偿卖家状态",
  Evidence_upload_status: "证据上传状态",
  Arbitration_status: "仲裁状态",
  Compensation_seller_amount: "赔偿卖家金额",
  Return_creation_time: "退货创建时间",
  Seller_operation_deadline: "卖家操作截止时间",
  Buyer_return_goods_deadline: "买家退回商品截止",
  Seller_compensation_deadline: "卖家申请赔偿截止",
  Seller_evidence_deadline: "卖家提交证据截止",
  Pictures_videos: "图片/视频",
  Attachments: "附件",

  When_Couriers_Mistakenly_Deliver_Returned_Items_To_A_Non_Corresponding_Return_Warehouse_And_They_Need_To_Be_Transferred_To_The_Correct_Warehouse_Return_Orders_Involving_Such_Operations_Will_Enter_This_Stage:

    "因快递员将退件误送到非对应退货仓库，需中转至正确仓库时；涉及此类操作的退货单将进入此阶段。",

  Apply_For_Customer_ID: "申请客户ID",
  Document_Type: "单据类型",
  Application_Time: "申请时间",
  Application_Month: "申请月份",
  Invoicing_Entity: "开票主体",
  Invoice_Header: "发票抬头",
  Total_Invoice_Amount: "发票总额",
  Invoice_Medium: "发票介质",
  Invoice_Status: "发票状态",
  Invoice_Date: "开票日期",
  Rejection_Reason: "驳回原因",
  Invoice_Serial_Number: "发票流水号",
  Unified_Social_Credit_Code: "统一社会信用代码",
  Apply_For_Invoicing: "申请开票",
  Electronic: "电子",
  Invoicing_Month: "开票月份",
  Applied_Invoice_Amount: "申请开票金额",
  Please_Select_Data_For_The_Same_Invoicing_Entity: "请选择同一开票主体数据",
  Please_Select_Data_For_The_Same_Invoice_Header: "请选择同一发票抬头数据",
  Reject_Invoice: "驳回发票",
  Please_Enter_Rejection_Reason: "请输入驳回原因",
  Upload_Invoice: "上传发票",
  Batch_Upload_Invoice: "批量上传发票",
  Invoice: "发票",
  Click_To_Upload: "点击上传",
  Only_PDF_Files_Under_10MB_Are_Accepted: "只能上传pdf文件，且不超过10MB",
  Please_Check_If_The_Invoice_Is_Correct: "请检查发票是否正确",
  Previous_Page: "上一页",
  Next_Page: "下一页",
  Please_Select_Invoice_Date: "请选择开票日期",
  Please_Upload_Invoice: "请上传发票",
  Please_Upload_PDF_Format_File: "请上传pdf格式的文件",
  File_Size_Cannot_Exceed_10MB: "文件大小不能超过10MB",
  Revoke: "撤销",
  Issue_Invoice: "开具发票",
  Invoice_Download: "发票下载",
  First_Mile_Cost: "头程费用：",
  Refers_To_The_First_Mile_In_Custom_Cost_Item_Integration_Not_Just_The_Cost_Type_Equal_To_First_Mile:
    "指的是自定义费用项整合中的头程，不只是费用类型等于头程。",
  Overseas_Warehouse_Cost: "海外仓费用：",
  Is_The_Sum_Of_All_Costs_Excluding_First_Mile_Cost_And_Top_Ups:
    "就是除头程费用、充值外的所有费用总和。",
  Download_Invoice: "下载发票",
  View: "查看",
  Confirm_Revocation: "是否确认撤销？",
  Invoice_Details: "发票详情",
  Invoice_Line_Items: "发票明细",
  Preview_Invoice: "预览发票",
  No_Invoice_Available: "暂无发票",
  Submit: "提交",
  Re_Upload_Invoice: "重新上传发票",
  Invoice_Export: "开票导出",
  Invoicing: "开票",
  Data_With_Empty_Invoice_Address_Exists_Cannot_Submit:
    "存在发票地址为空的数据，不可提交",
  Confirm_Information_Is_Correct_And_Submit_To_Invoiced_This_Action_Is_Irreversible:
    "是否确认信息正确提交至已开票，此操作不可撤销。",
  Top_Up_Amount_Cannot_Be_Invoiced_Directly_It_Must_Be_Consumed_And_Settled_Before_Invoicing:
    "充值金额不能直接开票，必须消费后结算才能开票。",
  invoiceDetail: "发票详情",
  issueInvoice: "开票",
  issueInvoiceConfiguration: "开票配置",
  The_Customer_ID_And_Invoice_Header_Will_Be_Extracted_From_The_File_Name_For_Data_Matching_Please_Ensure_The_File_Name_Is_Correct: "将提取文件名中的客户ID和开票抬头进行数据匹配，请确保文件名正确。",
  No_Invoicing_Application_Data_Exists: "不存在开票申请数据",
  Rejection_Reason_Too_Long_Supports_up_to_255_characters:
    "驳回原因过长，最多支持255个字符",
  All_Costs_Incurred_In_The_System_Related_To_First_Mile_Logistics_Business:
    "系统中产生的所有关于头程物流业务的费用",
  Including_First_Mile_Business_Related_Costs_From_The_Deduction_Or_Supplement_Cost_Type:
    "包含补扣费用类型中的关于头程业务费用",
  All_Overseas_Warehousing_Business_Related_Costs_Incurred_In_The_System:
    "在系统中产生的所有关于海外仓储业务的费用",
  Including_Overseas_Warehousing_Business_Related_Costs_From_The_Deduction_Or_Supplement_Cost_Type:
    "包含补扣费用类型中的关于海外仓储业务费用",

  failure: "失效",
  take_effect: "生效",
  Upload_contract: "上传合同",
  contract_file_type: "合同文件类型",
  contract_file: "合同文件",
  Electronic_contract: "电子合同",
  Paper_contract: "纸质合同",

  Pulling_in_progress: "正在拉取中",
  Waiting_to_run: "等待运行中",
  Place_an_order: "下发订单",
  Obtain_a_third_party_designated_return_order: "获取第三方指定退货单",
  Third_party_warehouse_authorization_company: "第三方仓授权公司",

  Edit_packaging_material: "修改包材",
  plugin: "插件",
  camera: "摄像头",
  Connection_successful: "连接成功",
  Insufficient_space_storage_days_warning: "空间不足存储天数预警",
  Insufficient_disk_space_automatic_cleaning: "磁盘空间不足自动清理",
  Only_allow_upload: "只允许上传",

  Dispatch_the_first_leg: "下发头程",
  The_current_status_does_not_allow_for_repeated_operation_dispatch:
    "当前状态不可重复操作下发",
  distribute_goods: "下发商品",
  Third_party_logistics_company: "第三方物流公司",
  Issue_warehouse_receipt: "下发入库",
  Is_it_a_default_contract: "是否为默认合同",
  batch_download: "批量下载",
  Personnel_from_the_investment_promotion_department_and_contract_documents_cannot_be_selected_simultaneously:
    "招商部人员和合同文件不能同时选择",
  Both_paper_and_electronic_contracts_exist_please_choose_again:
    "同时存在纸质合同和电子合同，请重新选择",
  Upload_the_paper_contract: "上传纸质合同",
  Is_API_Push_Enabled: "是否API推送",
  Migration_of_online_goods: "迁移在线商品",
  The_migration_of_the_store_cannot_be_consistent_with_the_selection_of_the_store_name_Please_reselect:
    "迁移店铺不能与选择店铺名称一致，请重新选择",
  Third_party_log_list: "第三方日志列表",
  Daily_upload_time_of_pictures_videos_to_the_warehouse_server:
    "每天上传图片/视频到仓库服务器时间",
  Additional_Charging_Information: "计费信息",
  Distribution_Shipping_Classification: "配/发货分类",
  stock_information: "库存信息",
  Warehouse_customer_provided_packaging_materials: "仓库/客户自备包材",
  Warehouse_packaging_materials: "仓库包材",
  Self_provided_packaging_materia: "自备包材",
  Packaging_operation: "包材操作",

  Quantity_in_transit: "配货中数量",
  Occupied_quantity: "占用数量",
  The_current_request_to_the_third_party_interface_is_abnormal_Please_check_the_authorization_of_the_third_party_logistics_company:
    "当前第三方接口请求异常，请检查第三方物流公司授权！",
  Currently_there_is_no_data_from_the_third_party_Please_synchronize_the_product_first:
    "当前没有第三方数据，请先同步商品",
  Headhaul_bills_are_settled_by_our_system_do_not_sync_third_party_headhaul_bill_settlement_status:
    "头程账单由我方系统结算，不同步第三方头程账单结算状态",
  Headhaul_bills_are_settled_by_the_third_party_logistics_system_synchronize_third_party_headhaul_bill_settlement_status_and_follow_the_third_party_system:
    "头程账单由第三方物流系统结算，同步第三方头程账单结算状态，以第三方物流系统为准",
  Headhaul_bills_may_be_charged_by_both_systems_when_one_side_updates_the_settlement_stage_synchronize_to_that_side_is_bill_stage:
    "头程账单由双方系统向客户收费，哪方的结算阶段更新后，就同步成哪方的账单阶段",
  The_third_party_printing_has_failed_at_present: "当前第三方打印失败",
  The_third_party_printing_failed_Please_check_the_third_party_authorization_information:
    "第三方打印失败，请检查第三方授权信息！",
  Issued_By: "开票人",

  This_operation_will_permanently_delete_continue:
    "此操作将永久删除, 是否继续?",

  Non_API_Orders_Exist_Operation_Not_Allowed: "存在非API订单，不可操作！",
  Changing_The_Customer_ID_Will_Automatically_Clear_The_Corresponding_Return_Product_Details_Please_Proceed_With_Caution:
    "更换客户ID，将自动清除对应退件商品明细，请谨慎作。",
  Please_Check_Whether_The_Currently_Set_Customer_ID_Is_Greater_Than_The_Largest_Customer_ID_In_The_Current_System:
    "请检查当前设置的客户ID是否大于目前系统中最大的客户ID。",
  If_So_Subsequently_Registered_Customer_IDs_Will_Start_From_This_Customer_ID_And_Increment_By_1:
    "如果大于，则后续注册的客户ID将从此客户ID开始自增+1。",
  Distributor: "分销商",
  When_the_warehouse_customer_provided_packaging_materials_are_self_supplied_packaging_materials:
    "仓库/客户自备包材为自备包材时",
  Warehouse_IDs_cannot_be_the_same: "仓库ID不能相同",
  Customer_IDs_cannot_be_the_same: "客户ID不能相同",
  Packaging_name_cannot_be_the_same: "包材名称不能相同",
  Inventory_adjustment_of_packaging_materials: "包材库存调整",
  Adjust_quantity: "调整数量",
  remove_from_shelves: "下架",
  Please_select_packaging: "请选择相同",
  Packaging_material_data: "包材数据",
  Self_provided_packaging_materials_only_support_adjustment_for_removal_with_a_maximum_removal_quantity_of_inventory_quantity_occupied_quantity:
    "选择数据存在自备包材，自备包材只支持调整下架，最大下架数量为：库存数量-占用数量",
  Packaging_material_product_information: "包材商品信息",
  surface_area: "表面积",
  The_quantity_must_be_greater_than_1: "数量必须大于1",
  logistics_warehouse: "物流仓库",
  Logistics_transit_warehouse: "物流中转仓",
  The_adjustment_quantity_must_be_greater_than_0: "调整数量必须大于0",

  No_Orders_Exist_For_The_Currently_Selected_Task: "当前勾选任务不存在订单",
  tagName: "标签名",
  color: "颜色",
  Commodity_diversion_number: "商品分流编号",
  The_priority_must_be_a_positive_integer: "优先级必须为正整数",
  Please_check_the_list_data_first: "请先勾选列表数据",
  File_upload: "文件上传",
  Please_enter_search_keywords: "请输入搜索关键词",
  No_data: "无数据",
  If_you_need_to_pull_a_specific_product: "如需拉取指定商品",
  Please_click_the_Pull_Specified_Product_button_select_the_corresponding_store_and_enter_the_product_link_SkcId:
    "请点击“拉取指定商品”按钮选择对应店铺输入商品链接SkcId",
  Please_enter_SkcId_separated_by_commas_or_newlines:
    "请输入SkcId，用逗号或换行隔开",
  on_sale: "在售",
  Not_published_on_the_website: "未发布到站点",
  off_the_shelf: "已下架",
  terminated: "已终止",

  Please_Select_Floor_Or_Zone: "请选择楼层或分区",

  ...otherChinese,

  Number_of_automatically_generated_tasks: "自动生成任务数量",
  Final_inventory_execution_time: "最终执行盘点时间",
  Final_inventory_executor: "最终执行盘点人",

  Batch_import_and_claim_data: "批量导入认领数据",
  cut_off_time: "截止时间",

  Due_To_The_Large_Export_Volume_Please_Wait_Patiently:
    "由于导出数量过大，请耐心等待。",
  Large_Scale_Exports_Must_Include_A_Time_Condition_And_The_Maximum_Time_Span_Cannot_Exceed_One_Calendar_Month:
    "大批量导出必须存在一个时间条件，且时间跨度最大不能超过1个自然月。",
  The_Current_Export_Limit_Is_100000_Rows_Excluding_Child_Data:
    "当前限制导出条数为10万条（不包含子级数据）。",
  If_The_Number_Of_Exported_Rows_Exceeds_100000_The_Export_Will_Fail_Please_Export_Within_The_Specified_Limit:
    "若导出条数超过10万条，将导出失败，请在规定范围内进行导出。",
  Specified_Condition_Data: "指定条件数据",
  Specified_Condition: "指定条件",
  Please_Select_The_Specification_Type: "请选择指定类型",
  Up_To_500_Records_Are_Supported: "最多支持500条数据",
  Up_To_5000_Records_Are_Supported: "最多支持5000条数据",
  Clear: "清空",
  Please_Select_The_Parent_Data: "请勾选上级数据",
  // 属性管理
  Sales_status: "销售状态",
  Custom_classification: "自定义分类",
  Import_attribute_managemen: "导入属性管理",
  category: "类目",
  Category_Name: "类目名称",
  level: "级别",
  Brand_Name: "品牌名称",
  Parent_category: "上级类目",
  batchCreation: "批量创建",
  add_Category: "添加类目",
  Edit_Category: "编辑类目",
  Batch_Add_category: "批量添加类目",
  Please_select_category_name: "请选择类目名称",
  Import_category_management: "导入类目管理",
  Arrange_in_descending_order_by_value: "按数值从大到小排列",
  Confirm_attribute_deletion: "确认删除属性?",
  Please_add_the_category: "请添加类目",
  Please_add_the_attribute: "请添加属性",
  Default_category: "默认类目",
  confirm_delete_category: "确认删除类目",
  Category_names_must_be_unique_Please_check_and_resubmit:
    "类目名称不得相同，请检查后再提交",
  // 菜单
  cancelOrderReport: "取消订单报表",
  Cancel_type: "取消类型",
  Seller_Buyer_Cancel: "卖/买家取消",
  Warehouse_out_of_stock_cancellation: "仓库缺货取消",
  The_current_barcode_has_been_scanned: "当前条码已扫描成功",

  Packaging_manage: "包装操作",
  This_document_is_used_as_a_reference_for_the_process_in_the_warehouse:
    "此文件用于给仓库做流程参考",
  Please_fill_in_the_complete_fee_information_first: "请先填写完整费用信息",
  Please_enter_the_SKU_product_barcode_Chinese_name_and_English_name_of_the_product_separated_by_commas_or_line_breaks_in_English:
    "请输入SKU、商品条码、中文品名、英文品名，用英文逗号或者换行隔开",
  value_added_task_number: "增值任务单号",
  Please_enter_the_category_name: "请输入类目名称",
  Returned_but_not_yet_warehoused: "已退回未入库",
  Lost_package_in_logistics: "物流丢包",
  Damaged_goods: "商品损坏",
  Product_differences: "商品差异",
  Refund_only: "仅退款",
  Return_and_refund: "退货退款",
  Pending_receipt: "待收货",
  Shelving_in_progress: "上架中",
  Claim_area: "认领区",
  Destroyed: "销毁",
  Transferred: "转运",
  No_return_logistics: "无退回物流",
  Returned_but_not_yet_signed: "已退回未签收",
  Returned_and_signed: "已退回已签收",
  Pending: "待处理",
  Platform_or_Merchant_intervention: "平台/商家介入",
  Completed: "完结",
  Return_to_the_merchant: "退回商家",
  Returning: "退货中",
  Refunded: "已退款",
  Disputed: "已提出争议",
  Rejected_or_Cancelled: "已拒绝/取消",
  Merchant_pending_processing: "商家待处理",
  Waiting_for_TikTok_Buyer_processing: "等待TikTok/买家处理",
  Appealed_or_Disputed: "已上诉/有争议",
  Resolved: "已解决",
  Applied: "已申请",
  Package_Sent: "包裹已寄出",
  Platform_Under_Review: "平台审核中",
  Order_item_ID: "订单商品ID",
  Return_tracking_number: "退回运单号",
  Reason_for_Refund: "退款原因",
  Please_upload_pictures_and_videos_as_evidence: "请上传图片和视频作为凭证",
  Please_upload_the_picture_as_evidence: "请上传图片作为凭证",
  The_picture_is_mandatory_while_the_video_is_optional:
    "图片为必填，视频为选填",
  Each_file_should_be_no_larger_than_2MB_and_a_maximum_of_10_files_are_allowed:
    "单个文件不超过 2MB，最多 10 个文件",
  The_picture_is_a_mandatory_field: "图片为必填",
  Platform_return_process_stage: "平台退货阶段",
  System: "系统",
  Application_status: "申请状态",
  Description_of_return_reason: "退货原因描述",
  Return_logistics_information: "退回物流信息",
  Return_and_Collection_Method: "退件取件方式",
  return_logistics_status: "退回物流状态",
  Dispute_arbitration: "争议仲裁",
  Pay_special_attention_to: "重点关注",
  system_order_status: "系统订单状态",
  system_return_phase: "系统退货阶段",
  Latest_update_The_logistics_information_is_currently_being_retrieved:
    "最新更新：物流信息正在拉取中",
  No_logistics_tracking_available: "暂无物流轨迹",
  Return_images_and_videos: "退货图片视频",
  Total_number_of_files: "文件总数量",
  Currently_previewing: "当前预览",
  Download_all: "下载全部",
  File_name: "文件名",
  Video: "视频",
  Download_failed: "下载失败",
  File_request_failed: "文件请求失败",
  The_following_orders_products_have_been_selected_for_direct_refund_without_the_need_for_return:
    "以下订单/商品已被选定为无需退货直接退款",
  Please_confirm_if_you_agree_to_the_refund: "请确认是否同意退款",
  The_following_orders_products_require_the_buyer_to_return_the_goods_first:
    "下列订单/商品需先由买家寄回",
  Please_verify_the_goods_before_approving_the_refund:
    "请验证商品后方可批准退款",
  The_following_orders_products_have_been_refused_for_return_Please_provide_the_reasons_for_the_rejection:
    "下列订单/商品被拒绝退货。请提供拒绝理由",
  And_attach_pictures_for_illustration: "并上传图片以作说明",
  Please_enter_the_refund_amount: "请输入退款金额",
  Photo_or_Video: "照片/视频",
  Maximum_file_upload_size: "最大文件上传大小",
  Each_picture_is_10MB_in_size_or_each_video_is_30MB_in_length_1_minute:
    "每张图片10MB或每支影片1分钟(30MB)",
  Please_upload_at_least_one_picture_video_is_optional:
    "请至少上传一张图片（视频为选填）",
  Please_enter_the_reason_for_rejection: "请输入拒绝原因",
  Missing_the_upload_of_target_data: "缺少上传目标数据",
  File_format_error: "文件格式错误",
  or_mp4_video: "或 mp4 视频",
  This_platform_currently_only_supports_uploading_images_Please_select_another_image_file:
    "当前平台仅支持上传图片，请重新选择图片文件",
  Videos_are_not_allowed_to_be_uploaded_on_the_non_Lazada_platform:
    "非 Lazada 平台禁止上传视频",
  Agree_to_return_the_item: "同意退货",
  Reject_to_return_the_item: "拒绝退货",
  Full_refund: "全额退款",
  Confirm_receipt: "确认收货",
  Agree_to_refund: "同意退款",
  Reject_to_refund: "拒绝退款",
  Partial_refund: "部分退款",
  Initiate_dispute: "发起争议",

  Contract_medium_type: "合同介质类型",
  Our_company: "我方公司",
  Business_type: "业务类型",
  Overseas_warehouse: "海外仓储",
  First_Mile_Logistics: "头程物流",
  Region_type: "地区类型",
  Domestic: "国内",
  Overseas: "海外",
  Hong_Kong_Ang_Macau: "港澳台",
  When_the_signing_validity_period_is_not_filled_in_or_equal_to_0_the_validity_period_is_equal_to_unlimited:
    "签署有效时间未填写或者等于0的时候，有效时间等于无限期",
  tip_365_days_per_year_730_days_per_year_1095_days_per_year:
    "一年365天，二年730，三年1095",
  infinite: "无限",
  enterprise_individual: "企业/个人",
  Sync_the_initial_shipping_status: "同步头程状态",
  Update_the_first_leg_status_which_must_be_the_dispatched_status:
    "更新头程状态，需是下发状态",
  Sync_online_product_images_to_SKU: "同步在线商品图片至SKU",
  Do_you_want_to_synchronize_and_update_the_current_online_product_images_to_the_paired_sku_main_image:
    "是否将当前在线商品图片同步更新至配对SKU主图",
  Scanned_waybill_number: "已扫描运单号",
  Import_relocation_location: "导入移库位",
  Export_warehouse_rent: "导出仓租",
  The_warehouse_rental_type_does_not_currently_support_selecting_export:
    "仓租类型暂不支持选择导出",
  Invalid_Effective: "失效/生效",
  Upload_failed: "上传失败",
  There_already_exists_an_identical_export_task_Do_you_want_to_download_it_directly:
    "已经存在完全相同的导出任务，是否直接下载",
  Do_not_download_reexport_instead: "不下载重新导出",
  The_current_waybill_number_is_duplicated: "当前运单号重复",
  The_current_waybill_number_exceeds_the_limit_length_of_30_characters:
    "当前运单号超过限制长度30个字符",
  Are_you_sure_to_confirm_the_current_scanned_waybill_number:
    "是否确认当前扫描运单号",
  Old_location_type: "旧库位类型",
  New_location_type: "新库位类型",
  Automatically_read_the_location_type_corresponding_to_the_selected_location:
    "自动读取选择的库位对应的库位类型",
  The_total_inventory_on_the_old_storage_location_and_the_proportion_of_total_inventory_to_usage:
    "旧库位上的库存总量，库存总占用量",
  Total_waybill_quantity: "总运单量",
  companyInformation: "公司信息",
  Sales_volume_7_14_30_45_60_90: "销量(7/14/30/45/60/90)",
  Minimum_purchase_price: "最低采购单价",
  Last_purchase_unit_price: "上次采购单价",
  Purchase_currency: "采购币种",
  Purchase_unit_price: "采购单价",
  Total_stocking_amount: "备货总金额",
  Is_consolidated_backup_order: "是否为合并备货单",
  client_region: "客户地区",
  Switch_Invoicing_Entity: "切换开票主体",
  Switching_The_Signing_Entity_Takes_Effect_After_Approval_All_Invoiced_Amounts_Thereafter_Will_Belong_To_This_Entity: "切换签约主体，审核通过后生效，在此之后的开票金额将归属于此主体。",
  Switching_The_Invoicing_Entity_Takes_Effect_At_Dawn_Of_The_Next_Day_Only_The_Last_Entity_Switched_Each_Day_Is_Valid_All_Invoiced_Amounts_For_The_Corresponding_Business_Type_Thereafter_Will_Belong_To_This_Entity: "切换开票主体，次日凌晨生效，仅每日切换的最后一个主体有效，在此之后对应业务类型的开票金额将归属于此主体。",
  Confirm_Operation: "是否确认操作",
  Multiple_Invoice_Records_Exist_Please_Upload_Individually: "存在多条开票数据，请单独上传",
  Incorrect_File_Name_Format: "文件名格式错误",
  Upload_Failed: "上传失败",
  Customer_Identification_Failed: "识别客户失败",

  print_and_video_plugin: "打印+录像插件",

  Please_Contact_The_Customer_To_Provide_The_Shipping_Label: "请联系客户提供面单",
  Please_Go_To_The_Print_Label_Page_To_Obtain_The_Label: "请前往打印标签页获取标签",
  Unable_To_Access: "无法访问",
  PDF_Download_Failed: "下载PDF失败",

  Closed: "已关闭",
  The_Platform_Order_Status_Is_Completed_If_You_Still_Need_To_Ship_The_Order_Please_Create_A_Manual_Order: "平台订单状态已完结，如果您还需要发货请创建手工单。",
  no_warehouse: "无仓库",
  Can_the_actual_product_data_be_modified_during_inbound_quality_inspection_or_return_quality_inspection: "在进行入库质检、退货质检时，能否修改产品真实数据",
  Modify_the_product_barcode_import_template_20250917:"修改商品条码导入模板20250917",
  Delete_shelves:"删除货架",
  orderProcessingFeeReport:"订单处理费报表" ,
  Total_contracting_material_cost:"总包材费",
  Switch_repositories: "切换仓库",
  You_can_select_one_or_more_warehouses_and_the_system_will_only_display_the_data_of_the_warehouses_you_have_chosen: "您可以选择一个或多个仓库，系统将只展示您选择的仓库的数据",
  Your_selection_will_be_remembered_and_will_still_be_valid_the_next_time_you_log_in: "您的选择将被记住，并在您下次登录时继续生效",
  Synchronize_third_party_product_information: "同步第三方商品信息",
  True_Weight: "真实重量",
  True_Length: "真实长(CM)",
  True_Height: "真实高(CM)",
  True_Width: "真实宽(CM)",
  No_blank_space:"不留白",
  Seller_is_email_address: "卖家邮箱",
  Please_enter_your_email_address: "请输入邮箱地址",
  Please_enter_and_then_click_the_Query_button_on_the_right: "请输入后点击右侧查询",

  appeal: "申诉",
  dispute: "争议",
  third_party_distribution_log: "第三方下发日志",

  Start_execute_time: "执行开始时间",
  Finish_execute_time: "执行完成时间",
  if_you_need_to_check_progress_please_go_to: "如需了解进度，请到",
  task_center_export_excel_task_view_progress: "任务中心【导出Excel任务】",
  view_progress: "查看进度",
  Import_return_inventory_list: "导入退货库存列表",
  all_product_quantity_equals_defective_quantity_this_return_order_will_turn_to_reject_stage:
    "商品数量均等于不合格数量，此退货单将会转入驳回阶段",
  import_batch_return_warehouse_location_transfer: "导入批量退货库位移库",
};
